/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody } from '../models/advanceDealApiV1PipelineDealsDealIdAdvancePostBody';

import type { ApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost200 } from '../models/approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost200';

import type { BulkDealAssignOwnerRequest } from '../models/bulkDealAssignOwnerRequest';

import type { BulkDealRequest } from '../models/bulkDealRequest';

import type { BulkDealRestoreRequest } from '../models/bulkDealRestoreRequest';

import type { BulkLeadAssignOwnerRequest } from '../models/bulkLeadAssignOwnerRequest';

import type { BulkLeadStatusRequest } from '../models/bulkLeadStatusRequest';

import type { CancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost200 } from '../models/cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost200';

import type { ContactRoleOptionListResponse } from '../models/contactRoleOptionListResponse';

import type { CreateContactApiV1PipelineContactsPostBody } from '../models/createContactApiV1PipelineContactsPostBody';

import type { CreateOrganizationApiV1PipelineOrganizationsPostBody } from '../models/createOrganizationApiV1PipelineOrganizationsPostBody';

import type { DealAggregatesResponse } from '../models/dealAggregatesResponse';

import type { DealBulkAssignOwnerResponse } from '../models/dealBulkAssignOwnerResponse';

import type { DealCollectionResponse } from '../models/dealCollectionResponse';

import type { DealContactCreate } from '../models/dealContactCreate';

import type { DealContactUpdate } from '../models/dealContactUpdate';

import type { DealCreate } from '../models/dealCreate';

import type { DealCriteriaCompletionsUpdate } from '../models/dealCriteriaCompletionsUpdate';

import type { DealListResponse } from '../models/dealListResponse';

import type { DealProductCreate } from '../models/dealProductCreate';

import type { DealProductReorder } from '../models/dealProductReorder';

import type { DealProductUpdate } from '../models/dealProductUpdate';

import type { DealResponse } from '../models/dealResponse';

import type { DealStageMove } from '../models/dealStageMove';

import type { DealUpdate } from '../models/dealUpdate';

import type { DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams } from '../models/deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams';

import type { DeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete200 } from '../models/deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete200';

import type { DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams } from '../models/deletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams';

import type { EmailTemplateCreate } from '../models/emailTemplateCreate';

import type { EmailTemplateListResponse } from '../models/emailTemplateListResponse';

import type { EmailTemplatePreviewRequest } from '../models/emailTemplatePreviewRequest';

import type { EmailTemplatePreviewResponse } from '../models/emailTemplatePreviewResponse';

import type { EmailTemplateResponse } from '../models/emailTemplateResponse';

import type { EnrollContactsRequest } from '../models/enrollContactsRequest';

import type { EnrollmentAggregatesResponse } from '../models/enrollmentAggregatesResponse';

import type { EnrollmentListResponse } from '../models/enrollmentListResponse';

import type { EnrollmentResponse } from '../models/enrollmentResponse';

import type { EnrollmentStatusUpdate } from '../models/enrollmentStatusUpdate';

import type { GenerateEmailRequest } from '../models/generateEmailRequest';

import type { GenerateEmailResponse } from '../models/generateEmailResponse';

import type { GenerateSequenceRequest } from '../models/generateSequenceRequest';

import type { GenerateSequenceResponse } from '../models/generateSequenceResponse';

import type { GetContactApiV1PipelineContactsContactIdGetParams } from '../models/getContactApiV1PipelineContactsContactIdGetParams';

import type { GetContactDealsApiV1PipelineContactsContactIdDealsGetParams } from '../models/getContactDealsApiV1PipelineContactsContactIdDealsGetParams';

import type { GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams } from '../models/getConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams';

import type { GetCrmDashboardApiV1PipelineDashboardGetParams } from '../models/getCrmDashboardApiV1PipelineDashboardGetParams';

import type { GetDealAggregatesApiV1PipelineDealsAggregatesGetParams } from '../models/getDealAggregatesApiV1PipelineDealsAggregatesGetParams';

import type { GetDealApiV1PipelineDealsDealIdGetParams } from '../models/getDealApiV1PipelineDealsDealIdGetParams';

import type { GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams } from '../models/getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams';

import type { GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams } from '../models/getDealsByProductApiV1PipelineProductsProductIdDealsGetParams';

import type { GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams } from '../models/getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams';

import type { GetForecastReportApiV1PipelineReportsForecastGetParams } from '../models/getForecastReportApiV1PipelineReportsForecastGetParams';

import type { GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams } from '../models/getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams';

import type { GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams } from '../models/getLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams';

import type { GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams } from '../models/getLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams';

import type { GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams } from '../models/getOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams';

import type { GetPipelineApiV1PipelinePipelinesPipelineIdGetParams } from '../models/getPipelineApiV1PipelinePipelinesPipelineIdGetParams';

import type { GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams } from '../models/getPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams';

import type { GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams } from '../models/getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams';

import type { GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams } from '../models/getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams';

import type { GetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet200 } from '../models/getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet200';

import type { GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams } from '../models/getSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams';

import type { GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams } from '../models/getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams';

import type { GetWinLossReportApiV1PipelineReportsWinLossGetParams } from '../models/getWinLossReportApiV1PipelineReportsWinLossGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { InteractionCreate } from '../models/interactionCreate';

import type { InteractionListResponse } from '../models/interactionListResponse';

import type { InteractionResponse } from '../models/interactionResponse';

import type { InteractionUpdate } from '../models/interactionUpdate';

import type { LeadBulkAssignOwnerResponse } from '../models/leadBulkAssignOwnerResponse';

import type { LeadBulkStatusResponse } from '../models/leadBulkStatusResponse';

import type { LeadContextResponse } from '../models/leadContextResponse';

import type { LeadCreateDealRequest } from '../models/leadCreateDealRequest';

import type { LeadCreateRequest } from '../models/leadCreateRequest';

import type { LeadCriteriaStatusResponse } from '../models/leadCriteriaStatusResponse';

import type { LeadFilterFacets } from '../models/leadFilterFacets';

import type { LeadFunnelReport } from '../models/leadFunnelReport';

import type { LeadListResponse } from '../models/leadListResponse';

import type { LeadMilestoneCreateRequest } from '../models/leadMilestoneCreateRequest';

import type { LeadMilestoneCriteriaReorder } from '../models/leadMilestoneCriteriaReorder';

import type { LeadMilestoneCriterionCreate } from '../models/leadMilestoneCriterionCreate';

import type { LeadMilestoneCriterionListResponse } from '../models/leadMilestoneCriterionListResponse';

import type { LeadMilestoneCriterionResponse } from '../models/leadMilestoneCriterionResponse';

import type { LeadMilestoneCriterionUpdate } from '../models/leadMilestoneCriterionUpdate';

import type { LeadMilestoneListResponse } from '../models/leadMilestoneListResponse';

import type { LeadMilestoneReorder } from '../models/leadMilestoneReorder';

import type { LeadMilestoneResponse } from '../models/leadMilestoneResponse';

import type { LeadMilestoneUpdateRequest } from '../models/leadMilestoneUpdateRequest';

import type { LeadRoutedPipelineResponse } from '../models/leadRoutedPipelineResponse';

import type { LeadRoutedPipelineUpdate } from '../models/leadRoutedPipelineUpdate';

import type { LeadSourceAgentCreate } from '../models/leadSourceAgentCreate';

import type { LeadSourceAgentLibraryResponse } from '../models/leadSourceAgentLibraryResponse';

import type { LeadSourceAgentListResponse } from '../models/leadSourceAgentListResponse';

import type { LeadSourceAgentResponse } from '../models/leadSourceAgentResponse';

import type { LeadSourceAgentUpdate } from '../models/leadSourceAgentUpdate';

import type { LeadSourceRunDetailResponse } from '../models/leadSourceRunDetailResponse';

import type { LeadSourceRunListResponse } from '../models/leadSourceRunListResponse';

import type { LeadStatusCountsResponse } from '../models/leadStatusCountsResponse';

import type { LeadStatusUpdate } from '../models/leadStatusUpdate';

import type { ListActivitiesApiV1PipelineActivitiesGetParams } from '../models/listActivitiesApiV1PipelineActivitiesGetParams';

import type { ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams } from '../models/listAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams';

import type { ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams } from '../models/listContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams';

import type { ListContactsApiV1PipelineContactsGetParams } from '../models/listContactsApiV1PipelineContactsGetParams';

import type { ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams } from '../models/listDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams';

import type { ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams } from '../models/listDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams';

import type { ListDealProductsApiV1PipelineDealsDealIdProductsGetParams } from '../models/listDealProductsApiV1PipelineDealsDealIdProductsGetParams';

import type { ListDealsApiV1PipelineDealsGetParams } from '../models/listDealsApiV1PipelineDealsGetParams';

import type { ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams } from '../models/listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams';

import type { ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams } from '../models/listLeadMilestonesApiV1PipelineLeadMilestonesGetParams';

import type { ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams } from '../models/listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams';

import type { ListLeadsApiV1PipelineLeadsGetParams } from '../models/listLeadsApiV1PipelineLeadsGetParams';

import type { ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams } from '../models/listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams';

import type { ListOrganizationsApiV1PipelineOrganizationsGetParams } from '../models/listOrganizationsApiV1PipelineOrganizationsGetParams';

import type { ListOutreachTasksApiV1PipelineProspectingTasksGetParams } from '../models/listOutreachTasksApiV1PipelineProspectingTasksGetParams';

import type { ListPipelinesApiV1PipelinePipelinesGetParams } from '../models/listPipelinesApiV1PipelinePipelinesGetParams';

import type { ListRottingDealsApiV1PipelineDealsRottingGetParams } from '../models/listRottingDealsApiV1PipelineDealsRottingGetParams';

import type { ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet200 } from '../models/listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet200';

import type { ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams } from '../models/listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams';

import type { ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams } from '../models/listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams';

import type { ListSequencesApiV1PipelineProspectingSequencesGetParams } from '../models/listSequencesApiV1PipelineProspectingSequencesGetParams';

import type { ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams } from '../models/listStagesApiV1PipelinePipelinesPipelineIdStagesGetParams';

import type { ListTemplatesApiV1PipelineProspectingTemplatesGetParams } from '../models/listTemplatesApiV1PipelineProspectingTemplatesGetParams';

import type { OutreachTaskListResponse } from '../models/outreachTaskListResponse';

import type { OutreachTaskOutcomeUpdate } from '../models/outreachTaskOutcomeUpdate';

import type { OutreachTaskResponse } from '../models/outreachTaskResponse';

import type { OutreachTaskStatusUpdate } from '../models/outreachTaskStatusUpdate';

import type { PipelineCreate } from '../models/pipelineCreate';

import type { PipelineDashboard } from '../models/pipelineDashboard';

import type { PipelineResponse } from '../models/pipelineResponse';

import type { PipelineUpdate } from '../models/pipelineUpdate';

import type { PipelineUpdateRequest } from '../models/pipelineUpdateRequest';

import type { ProspectResearchResponse } from '../models/prospectResearchResponse';

import type { ProspectingDeleteResult } from '../models/prospectingDeleteResult';

import type { ResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost200 } from '../models/resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost200';

import type { ReviewBatchRequest } from '../models/reviewBatchRequest';

import type { ReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost200 } from '../models/reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost200';

import type { RottingDealListResponse } from '../models/rottingDealListResponse';

import type { SequenceAnalytics } from '../models/sequenceAnalytics';

import type { SequenceCreate } from '../models/sequenceCreate';

import type { SequenceListResponse } from '../models/sequenceListResponse';

import type { SequenceResponse } from '../models/sequenceResponse';

import type { SequenceStatusUpdate } from '../models/sequenceStatusUpdate';

import type { SequenceStepCreate } from '../models/sequenceStepCreate';

import type { SequenceStepListResponse } from '../models/sequenceStepListResponse';

import type { SequenceStepReorderRequest } from '../models/sequenceStepReorderRequest';

import type { SequenceStepResponse } from '../models/sequenceStepResponse';

import type { SequenceStepUpdate } from '../models/sequenceStepUpdate';

import type { SequenceStepVariantCreate } from '../models/sequenceStepVariantCreate';

import type { SequenceStepVariantListResponse } from '../models/sequenceStepVariantListResponse';

import type { SequenceStepVariantResponse } from '../models/sequenceStepVariantResponse';

import type { SequenceStepVariantUpdate } from '../models/sequenceStepVariantUpdate';

import type { SequenceUpdate } from '../models/sequenceUpdate';

import type { SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate } from '../models/sharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate';

import type { StageCreate } from '../models/stageCreate';

import type { StageCriteriaReorder } from '../models/stageCriteriaReorder';

import type { StageCriterionCreate } from '../models/stageCriterionCreate';

import type { StageCriterionUpdate } from '../models/stageCriterionUpdate';

import type { StageListResponse } from '../models/stageListResponse';

import type { StageReorder } from '../models/stageReorder';

import type { StageResponse } from '../models/stageResponse';

import type { StageUpdate } from '../models/stageUpdate';

import type { TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost201 } from '../models/triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost201';

import type { TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody } from '../models/triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody';

import type { UpdateContactApiV1PipelineContactsContactIdPutBody } from '../models/updateContactApiV1PipelineContactsContactIdPutBody';

import type { UpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut200 } from '../models/updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut200';

import type { UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody } from '../models/updateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List the tenant's lead milestones in ladder order.

Unpaged by design: bounded reference data a tenant curates to a handful of
rungs (ui-list-pages.md § 11, Shape B), and every consumer needs all of it.
 * @summary List Lead Milestones
 */
export const listLeadMilestonesApiV1PipelineLeadMilestonesGet = (
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadMilestoneListResponse>({
    url: `/api/v1/pipeline/lead-milestones`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryKey = (
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams
) => {
  return [
    `/api/v1/pipeline/lead-milestones`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>>
  > = ({ signal }) =>
    listLeadMilestonesApiV1PipelineLeadMilestonesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>>
  >;
export type ListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryError =
  HTTPValidationError;

export function useListLeadMilestonesApiV1PipelineLeadMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeadMilestonesApiV1PipelineLeadMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeadMilestonesApiV1PipelineLeadMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Lead Milestones
 */

export function useListLeadMilestonesApiV1PipelineLeadMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadMilestonesApiV1PipelineLeadMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeadMilestonesApiV1PipelineLeadMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeadMilestonesApiV1PipelineLeadMilestonesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a rung to the tenant's lead funnel (admin).
 * @summary Create Lead Milestone
 */
export const createLeadMilestoneApiV1PipelineLeadMilestonesPost = (
  leadMilestoneCreateRequest: LeadMilestoneCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LeadMilestoneResponse>({
    url: `/api/v1/pipeline/lead-milestones`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leadMilestoneCreateRequest,
    signal
  });
};

export const getCreateLeadMilestoneApiV1PipelineLeadMilestonesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
      >,
      TError,
      { data: LeadMilestoneCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
    >,
    TError,
    { data: LeadMilestoneCreateRequest },
    TContext
  > => {
    const mutationKey = ['createLeadMilestoneApiV1PipelineLeadMilestonesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
      >,
      { data: LeadMilestoneCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createLeadMilestoneApiV1PipelineLeadMilestonesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeadMilestoneApiV1PipelineLeadMilestonesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
    >
  >;
export type CreateLeadMilestoneApiV1PipelineLeadMilestonesPostMutationBody =
  LeadMilestoneCreateRequest;
export type CreateLeadMilestoneApiV1PipelineLeadMilestonesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Lead Milestone
 */
export const useCreateLeadMilestoneApiV1PipelineLeadMilestonesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
      >,
      TError,
      { data: LeadMilestoneCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createLeadMilestoneApiV1PipelineLeadMilestonesPost>
  >,
  TError,
  { data: LeadMilestoneCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateLeadMilestoneApiV1PipelineLeadMilestonesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Rewrite the tenant's lead funnel order from one ordered id list (admin).

Declared BEFORE `/lead-milestones/{milestone_id}` so the literal segment is
matched first — Starlette resolves in registration order, and a literal
registered after a `/{param}` route on the same prefix is dead
(`tests/test_route_literal_shadowing.py`). Nothing shadows it today (the
parameter routes are PUT/DELETE), but the ordering is the contract, not the
current verb set.

The mirror of `POST /pipelines/{id}/stages/reorder`: ONE reorder mechanism for
both ladders. It replaces the pair of position-swapping PUTs the settings
section used to fire, which could half-land and could not express a drag
across more than two rungs at all.
 * @summary Reorder Lead Milestones
 */
export const reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost = (
  leadMilestoneReorder: LeadMilestoneReorder,
  signal?: AbortSignal
) => {
  return customInstance<LeadMilestoneListResponse>({
    url: `/api/v1/pipeline/lead-milestones/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leadMilestoneReorder,
    signal
  });
};

export const getReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
        >
      >,
      TError,
      { data: LeadMilestoneReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
      >
    >,
    TError,
    { data: LeadMilestoneReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
        >
      >,
      { data: LeadMilestoneReorder }
    > = (props) => {
      const { data } = props ?? {};

      return reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
      >
    >
  >;
export type ReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPostMutationBody =
  LeadMilestoneReorder;
export type ReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPostMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Lead Milestones
 */
export const useReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
        >
      >,
      TError,
      { data: LeadMilestoneReorder },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof reorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPost
    >
  >,
  TError,
  { data: LeadMilestoneReorder },
  TContext
> => {
  const mutationOptions =
    getReorderLeadMilestonesApiV1PipelineLeadMilestonesReorderPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a lead milestone (admin). The `key` is immutable — rename `label`.
 * @summary Update Lead Milestone
 */
export const updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut = (
  milestoneId: string,
  leadMilestoneUpdateRequest: LeadMilestoneUpdateRequest
) => {
  return customInstance<LeadMilestoneResponse>({
    url: `/api/v1/pipeline/lead-milestones/${milestoneId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: leadMilestoneUpdateRequest
  });
};

export const getUpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
        >
      >,
      TError,
      { milestoneId: string; data: LeadMilestoneUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
      >
    >,
    TError,
    { milestoneId: string; data: LeadMilestoneUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
        >
      >,
      { milestoneId: string; data: LeadMilestoneUpdateRequest }
    > = (props) => {
      const { milestoneId, data } = props ?? {};

      return updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut(
        milestoneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
      >
    >
  >;
export type UpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPutMutationBody =
  LeadMilestoneUpdateRequest;
export type UpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Milestone
 */
export const useUpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
        >
      >,
      TError,
      { milestoneId: string; data: LeadMilestoneUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPut
    >
  >,
  TError,
  { milestoneId: string; data: LeadMilestoneUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an EMPTY lead milestone (admin).

A rung any lead is parked on is rejected with a 400 pointing at deactivation:
leads store the key rather than a foreign key, so deleting an occupied rung
would strand them on a value nothing resolves.

A rung that is the last ACTIVE carrier of a `counts_as_*` marker is refused
with `LEAD_FUNNEL_MARKER_REASSIGNMENT_REQUIRED` unless `reassign_markers_to`
names the rung that should take it — an automation with no rung to write to
fails silently, which is the whole reason the guard exists.
 * @summary Delete Lead Milestone
 */
export const deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete = (
  milestoneId: string,
  params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams
) => {
  return customInstance<ProspectingDeleteResult>({
    url: `/api/v1/pipeline/lead-milestones/${milestoneId}`,
    method: 'DELETE',
    params
  });
};

export const getDeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
        >
      >,
      TError,
      {
        milestoneId: string;
        params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
      >
    >,
    TError,
    {
      milestoneId: string;
      params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams;
    },
    TContext
  > => {
    const mutationKey = [
      'deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
        >
      >,
      {
        milestoneId: string;
        params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams;
      }
    > = (props) => {
      const { milestoneId, params } = props ?? {};

      return deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete(
        milestoneId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
      >
    >
  >;

export type DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Lead Milestone
 */
export const useDeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
          >
        >,
        TError,
        {
          milestoneId: string;
          params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDelete
      >
    >,
    TError,
    {
      milestoneId: string;
      params?: DeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteParams;
    },
    TContext
  > => {
    const mutationOptions =
      getDeleteLeadMilestoneApiV1PipelineLeadMilestonesMilestoneIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a milestone's qualification criteria, in display order.

Unpaged by design: bounded reference data a tenant curates to a handful of
rows per rung (ui-list-pages.md § 11, Shape B).
 * @summary List Lead Milestone Criteria
 */
export const listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet =
  (milestoneId: string, signal?: AbortSignal) => {
    return customInstance<LeadMilestoneCriterionListResponse>({
      url: `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria`,
      method: 'GET',
      signal
    });
  };

export const getListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryKey =
  (milestoneId?: string) => {
    return [
      `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria`
    ] as const;
  };

export const getListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
      >
    >,
    TError = HTTPValidationError
  >(
    milestoneId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryKey(
        milestoneId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
        >
      >
    > = ({ signal }) =>
      listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet(
        milestoneId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!milestoneId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
      >
    >
  >;
export type ListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryError =
  HTTPValidationError;

export function useListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet<
  TData = Awaited<
    ReturnType<
      typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet<
  TData = Awaited<
    ReturnType<
      typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet<
  TData = Awaited<
    ReturnType<
      typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Lead Milestone Criteria
 */

export function useListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet<
  TData = Awaited<
    ReturnType<
      typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaGetQueryOptions(
      milestoneId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a qualification criterion to a lead milestone (admin).
 * @summary Create Lead Milestone Criterion
 */
export const createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost =
  (
    milestoneId: string,
    leadMilestoneCriterionCreate: LeadMilestoneCriterionCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<LeadMilestoneCriterionResponse>({
      url: `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leadMilestoneCriterionCreate,
      signal
    });
  };

export const getCreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
        >
      >,
      TError,
      { milestoneId: string; data: LeadMilestoneCriterionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
      >
    >,
    TError,
    { milestoneId: string; data: LeadMilestoneCriterionCreate },
    TContext
  > => {
    const mutationKey = [
      'createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
        >
      >,
      { milestoneId: string; data: LeadMilestoneCriterionCreate }
    > = (props) => {
      const { milestoneId, data } = props ?? {};

      return createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost(
        milestoneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
      >
    >
  >;
export type CreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPostMutationBody =
  LeadMilestoneCriterionCreate;
export type CreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Lead Milestone Criterion
 */
export const useCreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
          >
        >,
        TError,
        { milestoneId: string; data: LeadMilestoneCriterionCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPost
      >
    >,
    TError,
    { milestoneId: string; data: LeadMilestoneCriterionCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a milestone's qualification criterion (admin).
 * @summary Update Lead Milestone Criterion
 */
export const updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut =
  (
    milestoneId: string,
    criterionId: string,
    leadMilestoneCriterionUpdate: LeadMilestoneCriterionUpdate
  ) => {
    return customInstance<LeadMilestoneCriterionResponse>({
      url: `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria/${criterionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: leadMilestoneCriterionUpdate
    });
  };

export const getUpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
        >
      >,
      TError,
      {
        milestoneId: string;
        criterionId: string;
        data: LeadMilestoneCriterionUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
      >
    >,
    TError,
    {
      milestoneId: string;
      criterionId: string;
      data: LeadMilestoneCriterionUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
        >
      >,
      {
        milestoneId: string;
        criterionId: string;
        data: LeadMilestoneCriterionUpdate;
      }
    > = (props) => {
      const { milestoneId, criterionId, data } = props ?? {};

      return updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut(
        milestoneId,
        criterionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
      >
    >
  >;
export type UpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPutMutationBody =
  LeadMilestoneCriterionUpdate;
export type UpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Milestone Criterion
 */
export const useUpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
          >
        >,
        TError,
        {
          milestoneId: string;
          criterionId: string;
          data: LeadMilestoneCriterionUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPut
      >
    >,
    TError,
    {
      milestoneId: string;
      criterionId: string;
      data: LeadMilestoneCriterionUpdate;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Soft-delete a milestone's qualification criterion (admin).

Soft, not hard: a lead's recorded completions reference the criterion, and
they are the evidence trail behind a qualification that already happened.
 * @summary Delete Lead Milestone Criterion
 */
export const deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete =
  (milestoneId: string, criterionId: string) => {
    return customInstance<ProspectingDeleteResult>({
      url: `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria/${criterionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
        >
      >,
      TError,
      { milestoneId: string; criterionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
      >
    >,
    TError,
    { milestoneId: string; criterionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
        >
      >,
      { milestoneId: string; criterionId: string }
    > = (props) => {
      const { milestoneId, criterionId } = props ?? {};

      return deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete(
        milestoneId,
        criterionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
      >
    >
  >;

export type DeleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Lead Milestone Criterion
 */
export const useDeleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
          >
        >,
        TError,
        { milestoneId: string; criterionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDelete
      >
    >,
    TError,
    { milestoneId: string; criterionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteLeadMilestoneCriterionApiV1PipelineLeadMilestonesMilestoneIdCriteriaCriterionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reorder a milestone's criteria (admin).
 * @summary Reorder Lead Milestone Criteria
 */
export const reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost =
  (
    milestoneId: string,
    leadMilestoneCriteriaReorder: LeadMilestoneCriteriaReorder,
    signal?: AbortSignal
  ) => {
    return customInstance<LeadMilestoneCriterionListResponse>({
      url: `/api/v1/pipeline/lead-milestones/${milestoneId}/criteria/reorder`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leadMilestoneCriteriaReorder,
      signal
    });
  };

export const getReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
        >
      >,
      TError,
      { milestoneId: string; data: LeadMilestoneCriteriaReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
      >
    >,
    TError,
    { milestoneId: string; data: LeadMilestoneCriteriaReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
        >
      >,
      { milestoneId: string; data: LeadMilestoneCriteriaReorder }
    > = (props) => {
      const { milestoneId, data } = props ?? {};

      return reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost(
        milestoneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
      >
    >
  >;
export type ReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPostMutationBody =
  LeadMilestoneCriteriaReorder;
export type ReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPostMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Lead Milestone Criteria
 */
export const useReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
          >
        >,
        TError,
        { milestoneId: string; data: LeadMilestoneCriteriaReorder },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPost
      >
    >,
    TError,
    { milestoneId: string; data: LeadMilestoneCriteriaReorder },
    TContext
  > => {
    const mutationOptions =
      getReorderLeadMilestoneCriteriaApiV1PipelineLeadMilestonesMilestoneIdCriteriaReorderPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List one page of contacts filtered to contact_relationship containing 'lead'.

Each row carries two values that are not columns of the master-data contact,
each batch-loaded for the whole page in one query — serializing the contact
alone left both of the list's columns empty for every lead:

* ``lead_status`` from ``pipeline_contact_status``;
* ``company_name``, the employer's display name from
  ``contacts_organizations`` (the contact holds only ``organization_id``).

Leads accumulate without bound, so this is a Shape A list
(ui-list-pages.md § 11): the page it returns is not the result set, which is
why the ordering is resolved in SQL here rather than in the browser — sorting
a fetched page only reorders that page, and looks right on page 1.
 * @summary List Leads
 */
export const listLeadsApiV1PipelineLeadsGet = (
  params?: ListLeadsApiV1PipelineLeadsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadListResponse>({
    url: `/api/v1/pipeline/leads`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeadsApiV1PipelineLeadsGetQueryKey = (
  params?: ListLeadsApiV1PipelineLeadsGetParams
) => {
  return [`/api/v1/pipeline/leads`, ...(params ? [params] : [])] as const;
};

export const getListLeadsApiV1PipelineLeadsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
  TError = HTTPValidationError
>(
  params?: ListLeadsApiV1PipelineLeadsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLeadsApiV1PipelineLeadsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>
  > = ({ signal }) => listLeadsApiV1PipelineLeadsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLeadsApiV1PipelineLeadsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>
>;
export type ListLeadsApiV1PipelineLeadsGetQueryError = HTTPValidationError;

export function useListLeadsApiV1PipelineLeadsGet<
  TData = Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListLeadsApiV1PipelineLeadsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
          TError,
          Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeadsApiV1PipelineLeadsGet<
  TData = Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
  TError = HTTPValidationError
>(
  params?: ListLeadsApiV1PipelineLeadsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
          TError,
          Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeadsApiV1PipelineLeadsGet<
  TData = Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
  TError = HTTPValidationError
>(
  params?: ListLeadsApiV1PipelineLeadsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Leads
 */

export function useListLeadsApiV1PipelineLeadsGet<
  TData = Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
  TError = HTTPValidationError
>(
  params?: ListLeadsApiV1PipelineLeadsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLeadsApiV1PipelineLeadsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListLeadsApiV1PipelineLeadsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new contact as a lead.

Sets contact_relationship=['lead'] and creates a pipeline_contact_status with lead_status='new'.
Optionally creates or links a company with 'lead' relationship.
 * @summary Create Lead
 */
export const createLeadApiV1PipelineLeadsPost = (
  leadCreateRequest: LeadCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/leads`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leadCreateRequest,
    signal
  });
};

export const getCreateLeadApiV1PipelineLeadsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>,
    TError,
    { data: LeadCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>,
  TError,
  { data: LeadCreateRequest },
  TContext
> => {
  const mutationKey = ['createLeadApiV1PipelineLeadsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>,
    { data: LeadCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createLeadApiV1PipelineLeadsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeadApiV1PipelineLeadsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>
>;
export type CreateLeadApiV1PipelineLeadsPostMutationBody = LeadCreateRequest;
export type CreateLeadApiV1PipelineLeadsPostMutationError = HTTPValidationError;

/**
 * @summary Create Lead
 */
export const useCreateLeadApiV1PipelineLeadsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>,
      TError,
      { data: LeadCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLeadApiV1PipelineLeadsPost>>,
  TError,
  { data: LeadCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateLeadApiV1PipelineLeadsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return linked-record candidates from the broad accessible lead scope.
 * @summary Get Lead Filter Facets
 */
export const getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet = (
  signal?: AbortSignal
) => {
  return customInstance<LeadFilterFacets>({
    url: `/api/v1/pipeline/leads/filter-facets`,
    method: 'GET',
    signal
  });
};

export const getGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryKey =
  () => {
    return [`/api/v1/pipeline/leads/filter-facets`] as const;
  };

export const getGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
      >
    > = ({ signal }) =>
      getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
    >
  >;
export type GetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryError =
  unknown;

export function useGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Filter Facets
 */

export function useGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadFilterFacetsApiV1PipelineLeadsFilterFacetsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Per-milestone lead counts for the Leads board's column badges.

The lead-side analogue of the deal board's pipeline summary. It takes the SAME
filter params as ``GET /leads`` and resolves them through the same helper, so a
column badge can never describe a different set than the cards under it — the
defect this shape exists to prevent is a board whose columns sum to something
other than the list's own total.

Registered BEFORE the ``/leads/{contact_id}/…`` routes. They are longer paths
so nothing is shadowed today, but Starlette matches in registration order and a
literal added after a same-length parameter route is silently dead.

One grouped query, not one per column: the ladder is tenant-configurable, so a
per-column count would be an N+1 whose width the tenant chooses.
 * @summary Get Lead Status Counts
 */
export const getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet = (
  params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadStatusCountsResponse>({
    url: `/api/v1/pipeline/leads/status-counts`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryKey = (
  params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams
) => {
  return [
    `/api/v1/pipeline/leads/status-counts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
      >
    > = ({ signal }) =>
      getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
    >
  >;
export type GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryError =
  HTTPValidationError;

export function useGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGet<
  TData = Awaited<
    ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGet<
  TData = Awaited<
    ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGet<
  TData = Awaited<
    ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Status Counts
 */

export function useGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGet<
  TData = Awaited<
    ReturnType<typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadStatusCountsApiV1PipelineLeadsStatusCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadStatusCountsApiV1PipelineLeadsStatusCountsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Move leads to one milestone, over an explicit id list or the filter set.

The target milestone is validated against the tenant's own ACTIVE ladder before
anything is touched, so a rejected request leaves every lead exactly as it was —
the same guard the single-lead route applies, and the replacement for the CHECK
constraint 20260804_170100 dropped.

Every moved lead gets a funnel trail row carrying the rung it came FROM, which
is why the pre-change statuses are read before the write rather than after.

A lead already carrying the ``do_not_contact`` detail is SKIPPED, not moved and
not a reason to refuse the batch, and the response says how many were —
``skipped_suppressed``. Only the tenant's email suppression list lifts that
mark; removing the address from it does so automatically.
 * @summary Bulk Update Lead Status
 */
export const bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost = (
  bulkLeadStatusRequest: BulkLeadStatusRequest,
  signal?: AbortSignal
) => {
  return customInstance<LeadBulkStatusResponse>({
    url: `/api/v1/pipeline/leads/bulk-status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkLeadStatusRequest,
    signal
  });
};

export const getBulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
      >,
      TError,
      { data: BulkLeadStatusRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
    >,
    TError,
    { data: BulkLeadStatusRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
      >,
      { data: BulkLeadStatusRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
    >
  >;
export type BulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPostMutationBody =
  BulkLeadStatusRequest;
export type BulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Update Lead Status
 */
export const useBulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
      >,
      TError,
      { data: BulkLeadStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPost>
  >,
  TError,
  { data: BulkLeadStatusRequest },
  TContext
> => {
  const mutationOptions =
    getBulkUpdateLeadStatusApiV1PipelineLeadsBulkStatusPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reassign leads to one owner, over an explicit id list or the filter set.
 * @summary Bulk Assign Lead Owner
 */
export const bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost = (
  bulkLeadAssignOwnerRequest: BulkLeadAssignOwnerRequest,
  signal?: AbortSignal
) => {
  return customInstance<LeadBulkAssignOwnerResponse>({
    url: `/api/v1/pipeline/leads/bulk-assign-owner`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkLeadAssignOwnerRequest,
    signal
  });
};

export const getBulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost
        >
      >,
      TError,
      { data: BulkLeadAssignOwnerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost
      >
    >,
    TError,
    { data: BulkLeadAssignOwnerRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost
        >
      >,
      { data: BulkLeadAssignOwnerRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost
      >
    >
  >;
export type BulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPostMutationBody =
  BulkLeadAssignOwnerRequest;
export type BulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Assign Lead Owner
 */
export const useBulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost
        >
      >,
      TError,
      { data: BulkLeadAssignOwnerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPost>
  >,
  TError,
  { data: BulkLeadAssignOwnerRequest },
  TContext
> => {
  const mutationOptions =
    getBulkAssignLeadOwnerApiV1PipelineLeadsBulkAssignOwnerPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The Leads tab of the Reports page.

Deliberately ONE endpoint rather than the six the deal reports split into: every
metric here is drawn from the same cohort (the leads created inside the window),
so serving them separately would let six requests disagree about the denominator
they share.

Scoped through the same resolver the list and the board use, so the report is
bounded by exactly the leads the caller may see. That matters more here than on
a list: an aggregate reads as anonymous right up until it is broken down BY
owner or source, at which point every bucket key is a colleague's data.
 * @summary Get Lead Funnel Report
 */
export const getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet = (
  params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadFunnelReport>({
    url: `/api/v1/pipeline/reports/lead-funnel`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryKey = (
  params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams
) => {
  return [
    `/api/v1/pipeline/reports/lead-funnel`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
      >
    > = ({ signal }) =>
      getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
    >
  >;
export type GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryError =
  HTTPValidationError;

export function useGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGet<
  TData = Awaited<
    ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGet<
  TData = Awaited<
    ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGet<
  TData = Awaited<
    ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Funnel Report
 */

export function useGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGet<
  TData = Awaited<
    ReturnType<typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadFunnelReportApiV1PipelineReportsLeadFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadFunnelReportApiV1PipelineReportsLeadFunnelGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This lead's tick state against one milestone's qualification criteria.

`milestone_id` is required rather than defaulting to the lead's CURRENT rung:
the gate dialog always asks about the rung being advanced TO, and a silent
default would answer a different question than the caller asked.
 * @summary Get Lead Criteria Status
 */
export const getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet =
  (
    contactId: string,
    params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<LeadCriteriaStatusResponse>({
      url: `/api/v1/pipeline/leads/${contactId}/criteria-status`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryKey =
  (
    contactId?: string,
    params?: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams
  ) => {
    return [
      `/api/v1/pipeline/leads/${contactId}/criteria-status`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryKey(
        contactId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
        >
      >
    > = ({ signal }) =>
      getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet(
        contactId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
      >
    >
  >;
export type GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryError =
  HTTPValidationError;

export function useGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Criteria Status
 */

export function useGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: GetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadCriteriaStatusApiV1PipelineLeadsContactIdCriteriaStatusGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record qualification progress WITHOUT moving the lead.

Takes the same body as the status route (`lead_status` names the rung being
assessed, `completions` carries the ticks) so a rep can evidence a rung as
the work happens and qualify later. No gate is evaluated here — nothing is
advancing — and the lead's own milestone is left alone.
 * @summary Update Lead Criteria Completions
 */
export const updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost =
  (
    contactId: string,
    leadStatusUpdate: LeadStatusUpdate,
    signal?: AbortSignal
  ) => {
    return customInstance<LeadCriteriaStatusResponse>({
      url: `/api/v1/pipeline/leads/${contactId}/criteria-completions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leadStatusUpdate,
      signal
    });
  };

export const getUpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
        >
      >,
      TError,
      { contactId: string; data: LeadStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
      >
    >,
    TError,
    { contactId: string; data: LeadStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
        >
      >,
      { contactId: string; data: LeadStatusUpdate }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
      >
    >
  >;
export type UpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPostMutationBody =
  LeadStatusUpdate;
export type UpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Criteria Completions
 */
export const useUpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
          >
        >,
        TError,
        { contactId: string; data: LeadStatusUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPost
      >
    >,
    TError,
    { contactId: string; data: LeadStatusUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateLeadCriteriaCompletionsApiV1PipelineLeadsContactIdCriteriaCompletionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Read one contact's lead funnel state.

The single-record counterpart of ``GET /leads``, and the seam that lets a
master-data contact page render lead context: ``lead_status`` and
``routed_pipeline_id`` live on ``pipeline_contact_status``, not on the
contact, so before this the contact detail page had no way to see either
without the pipeline module widening the contact payload every other module
reads. Mirrors ``GET /prospecting/prospects/{contact_id}``, which the
prospecting funnel control on the same page has always had.

Contract D: VIEWER on the contact — this is a read of the contact's own
funnel state and carries no fields of any other entity, so there is no far
side to scope.
 * @summary Get Lead Context
 */
export const getLeadContextApiV1PipelineLeadsContactIdGet = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeadContextResponse>({
    url: `/api/v1/pipeline/leads/${contactId}`,
    method: 'GET',
    signal
  });
};

export const getGetLeadContextApiV1PipelineLeadsContactIdGetQueryKey = (
  contactId?: string
) => {
  return [`/api/v1/pipeline/leads/${contactId}`] as const;
};

export const getGetLeadContextApiV1PipelineLeadsContactIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetLeadContextApiV1PipelineLeadsContactIdGetQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>>
  > = ({ signal }) =>
    getLeadContextApiV1PipelineLeadsContactIdGet(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLeadContextApiV1PipelineLeadsContactIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>>
  >;
export type GetLeadContextApiV1PipelineLeadsContactIdGetQueryError =
  HTTPValidationError;

export function useGetLeadContextApiV1PipelineLeadsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadContextApiV1PipelineLeadsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadContextApiV1PipelineLeadsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Context
 */

export function useGetLeadContextApiV1PipelineLeadsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeadContextApiV1PipelineLeadsContactIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadContextApiV1PipelineLeadsContactIdGetQueryOptions(
      contactId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Put an existing contact on the lead rung and open its funnel state.

'lead' is a lifecycle-owned relationship, so the contact update path
deliberately ignores it and the detail page renders it LOCKED — which left a
user no way at all to promote a contact they had just met into the lead
funnel from its own page. This is that affordance: the rung goes through
:meth:`LeadLifecycleService.set_contact_sales_relationship` (the only
sanctioned hand-set of one, so nothing another writer added to the array
since the page loaded is discarded) and the funnel state through
:meth:`~LeadLifecycleService.ensure_lead_status`, which opens the row on the
tenant's own first rung.

Idempotent: a contact that is already a lead keeps its milestone —
``ensure_lead_status`` never regresses an advanced status — so a double click
or a retried request is a no-op rather than a demotion to the first rung.

Unconditional on the rung the contact currently sits on, exactly like the
lifecycle seam it calls: a rep correcting a wrongly-promoted contact must be
able to move it back DOWN to lead. The UI offers the action only to a contact
on no sales rung, so demoting a customer stays a deliberate act through the
relationship editor rather than a stray menu click.

Deliberately NOT built on ``_lead_or_error``: that helper refuses a contact
that is not already a lead, which is the entire population this route exists
to serve.

Contract D: EDITOR on the contact — this rewrites its lifecycle position.
 * @summary Mark Contact As Lead
 */
export const markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeadContextResponse>({
    url: `/api/v1/pipeline/leads/${contactId}/mark-as-lead`,
    method: 'POST',
    signal
  });
};

export const getMarkContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
      >
    >
  >;

export type MarkContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Contact As Lead
 */
export const useMarkContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof markContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPost
    >
  >,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getMarkContactAsLeadApiV1PipelineLeadsContactIdMarkAsLeadPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Move a lead to another milestone, through the qualification gate.

The gate applies to a FORWARD move onto a NON-TERMINAL rung, mirroring how
the deal stage gate treats a stage move: qualifying a lead is the act the
criteria describe, so closing one out or walking it back down the
funnel is never blocked by criteria it has not met — that would trap a lead
on a rung it does not belong on. A move to the rung the lead is already on
is not a move at all and is likewise ungated.

**Automation never reaches this gate.** Outreach automation and the deal-lost
lifecycle write `lead_status` through LeadLifecycleService / the milestone
resolvers, on the session directly — they never call this route, so an
auto-advance cannot be blocked by a criterion no human was asked about.

Past the gate the write is otherwise **unconditional**: it OVERWRITES whatever
rung the automation had recorded, including a terminal one. That is the point
of a separate seam — the automatic producers are monotonic, which is what stops
a late bounce webhook dragging a converted lead backwards, but a human must be
able to walk a lead back down and to correct a terminal rung applied in error.
Parking a lead on the out-of-play rung (the seeded ``closed``) takes it out
of the team's working funnel until someone puts it back.

What a rep may NOT do is pick a rung whose truth is owned elsewhere:
``validate_milestone_or_raise`` rejects any rung that is not
``is_manually_settable``, i.e. the ``counts_as_converted`` rung that deal
creation stamps and conversion analytics count.

The out-of-play rung IS theirs to set — "unqualified" and "bad timing" are a
rep's own verdicts — so the one out-of-play verdict that is not theirs is
refused one level down. ``validate_detail_or_raise`` rejects the
``do_not_contact`` **detail**, whose truth belongs to the tenant's admin-only
shared email suppression list, and refuses ANY hand-edit of a lead already
carrying it: allowing the move while refusing the value would let a rep
quietly re-open a suppressed lead by picking a different reason. It also
requires a detail on a rung whose ``detail_required`` is set — the seeded
Closed rung — because out-of-play with no reason recorded is exactly the state
the second layer exists to prevent.

The rung is a *view* of where a lead sits and is NOT a suppression control:
setting it neither stops nor starts outreach, because the sequence engine
consults the suppression list and not this column. If sends have to stop, the
contact must also be removed from their sequences — a separate action.

This docstring is the description FastAPI publishes for the MCP tool, so it is
what the AI assistant reads before calling it.
 * @summary Update Lead Status
 */
export const updateLeadStatusApiV1PipelineLeadsContactIdStatusPut = (
  contactId: string,
  leadStatusUpdate: LeadStatusUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/leads/${contactId}/status`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: leadStatusUpdate
  });
};

export const getUpdateLeadStatusApiV1PipelineLeadsContactIdStatusPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
      >,
      TError,
      { contactId: string; data: LeadStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
    >,
    TError,
    { contactId: string; data: LeadStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeadStatusApiV1PipelineLeadsContactIdStatusPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
      >,
      { contactId: string; data: LeadStatusUpdate }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return updateLeadStatusApiV1PipelineLeadsContactIdStatusPut(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadStatusApiV1PipelineLeadsContactIdStatusPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
    >
  >;
export type UpdateLeadStatusApiV1PipelineLeadsContactIdStatusPutMutationBody =
  LeadStatusUpdate;
export type UpdateLeadStatusApiV1PipelineLeadsContactIdStatusPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Status
 */
export const useUpdateLeadStatusApiV1PipelineLeadsContactIdStatusPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
      >,
      TError,
      { contactId: string; data: LeadStatusUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateLeadStatusApiV1PipelineLeadsContactIdStatusPut>
  >,
  TError,
  { contactId: string; data: LeadStatusUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateLeadStatusApiV1PipelineLeadsContactIdStatusPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Set (or clear) the pipeline this lead is routed to.

The human-editable half of the questionnaire routing (lead-attribution design
§C/§D): capture stamps ``routed_pipeline_id`` from the lead connection's
per-form answer rules, and this is where a human overrides or clears it. It
remains an INTENT — no deal is created here; the lead→deal conversion is what
consumes it.

``overwrite=True`` because this IS the deliberate human write; the capture
path's fill-blanks default exists precisely so it can never undo this one.
 * @summary Update Lead Routed Pipeline
 */
export const updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut =
  (contactId: string, leadRoutedPipelineUpdate: LeadRoutedPipelineUpdate) => {
    return customInstance<LeadRoutedPipelineResponse>({
      url: `/api/v1/pipeline/leads/${contactId}/routed-pipeline`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: leadRoutedPipelineUpdate
    });
  };

export const getUpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
        >
      >,
      TError,
      { contactId: string; data: LeadRoutedPipelineUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
      >
    >,
    TError,
    { contactId: string; data: LeadRoutedPipelineUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
        >
      >,
      { contactId: string; data: LeadRoutedPipelineUpdate }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
      >
    >
  >;
export type UpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePutMutationBody =
  LeadRoutedPipelineUpdate;
export type UpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Routed Pipeline
 */
export const useUpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
          >
        >,
        TError,
        { contactId: string; data: LeadRoutedPipelineUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePut
      >
    >,
    TError,
    { contactId: string; data: LeadRoutedPipelineUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateLeadRoutedPipelineApiV1PipelineLeadsContactIdRoutedPipelinePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Take a contact off the lead rung and close its funnel state.

The mirror of :func:`mark_contact_as_lead`, and the affordance the contact
detail page was missing: ``lead`` is lifecycle-owned, so the classification
control renders it LOCKED and ``PUT /contacts/{id}`` unions the stored rungs
back into any payload. Until this route existed the ONLY reachable demote in
the whole app was the contacts list's bulk relationship dialog — a list-level
control for a per-record decision — and it went around the lifecycle
entirely (WI bfa880fa).

Both halves land through :meth:`LeadLifecycleService.demote_contact_from_lead`
in one transaction: the rung comes off element-named (so nothing another
writer added since the page loaded is discarded), ``lead_status`` and
``routed_pipeline_id`` are cleared, and the funnel trail gets its
``to_status = NULL`` exit row naming the acting user. What it does NOT do is
delete the lead's criteria completions — see that method for why, and
``docs/modules/pipeline/lead-management-design.md`` § 4.5.

Idempotent: a contact already off the rung writes nothing and returns the
same blank funnel context, so a double click or a retried request is a no-op.

Deliberately NOT built on ``_lead_or_error``. That helper 404s a contact
carrying no ``lead`` tag, which would turn the second click of a double click
into an error toast on an action that had already succeeded.

Contract D: EDITOR on the contact — this rewrites its lifecycle position.
 * @summary Unmark Contact As Lead
 */
export const unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeadContextResponse>({
    url: `/api/v1/pipeline/leads/${contactId}/unmark-as-lead`,
    method: 'POST',
    signal
  });
};

export const getUnmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
      >
    >
  >;

export type UnmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPostMutationError =
  HTTPValidationError;

/**
 * @summary Unmark Contact As Lead
 */
export const useUnmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
          >
        >,
        TError,
        { contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationOptions =
      getUnmarkContactAsLeadApiV1PipelineLeadsContactIdUnmarkAsLeadPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Create a deal from a lead, carrying its attribution across.

Creates the deal, links it to the contact, and triggers lifecycle
auto-transitions via LeadLifecycleService (contact -> opportunity,
company -> prospect).

Conversion is also where a lead's acquisition context has to survive
(lead-attribution design §D). The deal inherits the contact's
``source``/``source_detail``, the custom-field answers a ``pipeline_deal``
can also hold, and its tags; and the pipeline defaults to the one the lead
was routed to. Before this, the conversion copied nothing but the contact and
organization ids, so every lead arrived in the pipeline unattributed.
 * @summary Create Deal From Lead
 */
export const createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost = (
  contactId: string,
  leadCreateDealRequest: LeadCreateDealRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/leads/${contactId}/create-deal`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leadCreateDealRequest,
    signal
  });
};

export const getCreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
        >
      >,
      TError,
      { contactId: string; data: LeadCreateDealRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
      >
    >,
    TError,
    { contactId: string; data: LeadCreateDealRequest },
    TContext
  > => {
    const mutationKey = [
      'createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
        >
      >,
      { contactId: string; data: LeadCreateDealRequest }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
      >
    >
  >;
export type CreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPostMutationBody =
  LeadCreateDealRequest;
export type CreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Deal From Lead
 */
export const useCreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
        >
      >,
      TError,
      { contactId: string; data: LeadCreateDealRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createDealFromLeadApiV1PipelineLeadsContactIdCreateDealPost
    >
  >,
  TError,
  { contactId: string; data: LeadCreateDealRequest },
  TContext
> => {
  const mutationOptions =
    getCreateDealFromLeadApiV1PipelineLeadsContactIdCreateDealPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List email templates.
 * @summary List Templates
 */
export const listTemplatesApiV1PipelineProspectingTemplatesGet = (
  params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<EmailTemplateListResponse>({
    url: `/api/v1/pipeline/prospecting/templates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTemplatesApiV1PipelineProspectingTemplatesGetQueryKey = (
  params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams
) => {
  return [
    `/api/v1/pipeline/prospecting/templates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListTemplatesApiV1PipelineProspectingTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTemplatesApiV1PipelineProspectingTemplatesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
      >
    > = ({ signal }) =>
      listTemplatesApiV1PipelineProspectingTemplatesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTemplatesApiV1PipelineProspectingTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
    >
  >;
export type ListTemplatesApiV1PipelineProspectingTemplatesGetQueryError =
  HTTPValidationError;

export function useListTemplatesApiV1PipelineProspectingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTemplatesApiV1PipelineProspectingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTemplatesApiV1PipelineProspectingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Templates
 */

export function useListTemplatesApiV1PipelineProspectingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PipelineProspectingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PipelineProspectingTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTemplatesApiV1PipelineProspectingTemplatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new email template.
 * @summary Create Template
 */
export const createTemplateApiV1PipelineProspectingTemplatesPost = (
  emailTemplateCreate: EmailTemplateCreate,
  signal?: AbortSignal
) => {
  return customInstance<EmailTemplateResponse>({
    url: `/api/v1/pipeline/prospecting/templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailTemplateCreate,
    signal
  });
};

export const getCreateTemplateApiV1PipelineProspectingTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
      >,
      TError,
      { data: EmailTemplateCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
    >,
    TError,
    { data: EmailTemplateCreate },
    TContext
  > => {
    const mutationKey = ['createTemplateApiV1PipelineProspectingTemplatesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
      >,
      { data: EmailTemplateCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createTemplateApiV1PipelineProspectingTemplatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTemplateApiV1PipelineProspectingTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
    >
  >;
export type CreateTemplateApiV1PipelineProspectingTemplatesPostMutationBody =
  EmailTemplateCreate;
export type CreateTemplateApiV1PipelineProspectingTemplatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Template
 */
export const useCreateTemplateApiV1PipelineProspectingTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
      >,
      TError,
      { data: EmailTemplateCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createTemplateApiV1PipelineProspectingTemplatesPost>
  >,
  TError,
  { data: EmailTemplateCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTemplateApiV1PipelineProspectingTemplatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get an email template by ID.
 * @summary Get Template
 */
export const getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet = (
  templateId: string,
  signal?: AbortSignal
) => {
  return customInstance<EmailTemplateResponse>({
    url: `/api/v1/pipeline/prospecting/templates/${templateId}`,
    method: 'GET',
    signal
  });
};

export const getGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryKey =
  (templateId?: string) => {
    return [`/api/v1/pipeline/prospecting/templates/${templateId}`] as const;
  };

export const getGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    templateId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryKey(
        templateId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
        >
      >
    > = ({ signal }) =>
      getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet(
        templateId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
      >
    >
  >;
export type GetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryError =
  HTTPValidationError;

export function useGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Template
 */

export function useGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PipelineProspectingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTemplateApiV1PipelineProspectingTemplatesTemplateIdGetQueryOptions(
      templateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an email template.
 * @summary Update Template
 */
export const updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut = (
  templateId: string,
  sharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate
) => {
  return customInstance<EmailTemplateResponse>({
    url: `/api/v1/pipeline/prospecting/templates/${templateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate
  });
};

export const getUpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
        >
      >,
      TError,
      {
        templateId: string;
        data: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
      >
    >,
    TError,
    {
      templateId: string;
      data: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
        >
      >,
      {
        templateId: string;
        data: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
      }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
      >
    >
  >;
export type UpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPutMutationBody =
  SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
export type UpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Template
 */
export const useUpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
        >
      >,
      TError,
      {
        templateId: string;
        data: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateTemplateApiV1PipelineProspectingTemplatesTemplateIdPut
    >
  >,
  TError,
  {
    templateId: string;
    data: SharedGeneratedPythonPipelineEmailTemplateUpdateSchemaEmailTemplateUpdate;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateTemplateApiV1PipelineProspectingTemplatesTemplateIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete an email template.
 * @summary Delete Template
 */
export const deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete = (
  templateId: string
) => {
  return customInstance<ProspectingDeleteResult>({
    url: `/api/v1/pipeline/prospecting/templates/${templateId}`,
    method: 'DELETE'
  });
};

export const getDeleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Template
 */
export const useDeleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTemplateApiV1PipelineProspectingTemplatesTemplateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Render a template with a specific contact's data.
 * @summary Preview Template
 */
export const previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost =
  (
    templateId: string,
    emailTemplatePreviewRequest: EmailTemplatePreviewRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<EmailTemplatePreviewResponse>({
      url: `/api/v1/pipeline/prospecting/templates/${templateId}/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: emailTemplatePreviewRequest,
      signal
    });
  };

export const getPreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
        >
      >,
      TError,
      { templateId: string; data: EmailTemplatePreviewRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
      >
    >,
    TError,
    { templateId: string; data: EmailTemplatePreviewRequest },
    TContext
  > => {
    const mutationKey = [
      'previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
        >
      >,
      { templateId: string; data: EmailTemplatePreviewRequest }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
      >
    >
  >;
export type PreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPostMutationBody =
  EmailTemplatePreviewRequest;
export type PreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Template
 */
export const usePreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
          >
        >,
        TError,
        { templateId: string; data: EmailTemplatePreviewRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof previewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPost
      >
    >,
    TError,
    { templateId: string; data: EmailTemplatePreviewRequest },
    TContext
  > => {
    const mutationOptions =
      getPreviewTemplateApiV1PipelineProspectingTemplatesTemplateIdPreviewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List sequences with optional filtering.
 * @summary List Sequences
 */
export const listSequencesApiV1PipelineProspectingSequencesGet = (
  params?: ListSequencesApiV1PipelineProspectingSequencesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SequenceListResponse>({
    url: `/api/v1/pipeline/prospecting/sequences`,
    method: 'GET',
    params,
    signal
  });
};

export const getListSequencesApiV1PipelineProspectingSequencesGetQueryKey = (
  params?: ListSequencesApiV1PipelineProspectingSequencesGetParams
) => {
  return [
    `/api/v1/pipeline/prospecting/sequences`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListSequencesApiV1PipelineProspectingSequencesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListSequencesApiV1PipelineProspectingSequencesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListSequencesApiV1PipelineProspectingSequencesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
      >
    > = ({ signal }) =>
      listSequencesApiV1PipelineProspectingSequencesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListSequencesApiV1PipelineProspectingSequencesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
    >
  >;
export type ListSequencesApiV1PipelineProspectingSequencesGetQueryError =
  HTTPValidationError;

export function useListSequencesApiV1PipelineProspectingSequencesGet<
  TData = Awaited<
    ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListSequencesApiV1PipelineProspectingSequencesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSequencesApiV1PipelineProspectingSequencesGet<
  TData = Awaited<
    ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListSequencesApiV1PipelineProspectingSequencesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSequencesApiV1PipelineProspectingSequencesGet<
  TData = Awaited<
    ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListSequencesApiV1PipelineProspectingSequencesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Sequences
 */

export function useListSequencesApiV1PipelineProspectingSequencesGet<
  TData = Awaited<
    ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListSequencesApiV1PipelineProspectingSequencesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSequencesApiV1PipelineProspectingSequencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListSequencesApiV1PipelineProspectingSequencesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new sequence.
 * @summary Create Sequence
 */
export const createSequenceApiV1PipelineProspectingSequencesPost = (
  sequenceCreate: SequenceCreate,
  signal?: AbortSignal
) => {
  return customInstance<SequenceResponse>({
    url: `/api/v1/pipeline/prospecting/sequences`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sequenceCreate,
    signal
  });
};

export const getCreateSequenceApiV1PipelineProspectingSequencesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
      >,
      TError,
      { data: SequenceCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
    >,
    TError,
    { data: SequenceCreate },
    TContext
  > => {
    const mutationKey = ['createSequenceApiV1PipelineProspectingSequencesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
      >,
      { data: SequenceCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createSequenceApiV1PipelineProspectingSequencesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateSequenceApiV1PipelineProspectingSequencesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
    >
  >;
export type CreateSequenceApiV1PipelineProspectingSequencesPostMutationBody =
  SequenceCreate;
export type CreateSequenceApiV1PipelineProspectingSequencesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Sequence
 */
export const useCreateSequenceApiV1PipelineProspectingSequencesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
      >,
      TError,
      { data: SequenceCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createSequenceApiV1PipelineProspectingSequencesPost>
  >,
  TError,
  { data: SequenceCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSequenceApiV1PipelineProspectingSequencesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a sequence by ID with its steps.
 * @summary Get Sequence
 */
export const getSequenceApiV1PipelineProspectingSequencesSequenceIdGet = (
  sequenceId: string,
  signal?: AbortSignal
) => {
  return customInstance<SequenceResponse>({
    url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}`,
    method: 'GET',
    signal
  });
};

export const getGetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryKey =
  (sequenceId?: string) => {
    return [`/api/v1/pipeline/prospecting/sequences/${sequenceId}`] as const;
  };

export const getGetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    sequenceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryKey(
        sequenceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
        >
      >
    > = ({ signal }) =>
      getSequenceApiV1PipelineProspectingSequencesSequenceIdGet(
        sequenceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sequenceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
      >
    >
  >;
export type GetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryError =
  HTTPValidationError;

export function useGetSequenceApiV1PipelineProspectingSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet>
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSequenceApiV1PipelineProspectingSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet>
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSequenceApiV1PipelineProspectingSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet>
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sequence
 */

export function useGetSequenceApiV1PipelineProspectingSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet>
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceApiV1PipelineProspectingSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSequenceApiV1PipelineProspectingSequencesSequenceIdGetQueryOptions(
      sequenceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a sequence.
 * @summary Update Sequence
 */
export const updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut = (
  sequenceId: string,
  sequenceUpdate: SequenceUpdate
) => {
  return customInstance<SequenceResponse>({
    url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sequenceUpdate
  });
};

export const getUpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
        >
      >,
      TError,
      { sequenceId: string; data: SequenceUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
      >
    >,
    TError,
    { sequenceId: string; data: SequenceUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
        >
      >,
      { sequenceId: string; data: SequenceUpdate }
    > = (props) => {
      const { sequenceId, data } = props ?? {};

      return updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut(
        sequenceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
      >
    >
  >;
export type UpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPutMutationBody =
  SequenceUpdate;
export type UpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Sequence
 */
export const useUpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
        >
      >,
      TError,
      { sequenceId: string; data: SequenceUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateSequenceApiV1PipelineProspectingSequencesSequenceIdPut
    >
  >,
  TError,
  { sequenceId: string; data: SequenceUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSequenceApiV1PipelineProspectingSequencesSequenceIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete a sequence.
 * @summary Delete Sequence
 */
export const deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete = (
  sequenceId: string
) => {
  return customInstance<ProspectingDeleteResult>({
    url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}`,
    method: 'DELETE'
  });
};

export const getDeleteSequenceApiV1PipelineProspectingSequencesSequenceIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
        >
      >,
      TError,
      { sequenceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
      >
    >,
    TError,
    { sequenceId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
        >
      >,
      { sequenceId: string }
    > = (props) => {
      const { sequenceId } = props ?? {};

      return deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete(
        sequenceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSequenceApiV1PipelineProspectingSequencesSequenceIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
      >
    >
  >;

export type DeleteSequenceApiV1PipelineProspectingSequencesSequenceIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Sequence
 */
export const useDeleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
          >
        >,
        TError,
        { sequenceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteSequenceApiV1PipelineProspectingSequencesSequenceIdDelete
      >
    >,
    TError,
    { sequenceId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteSequenceApiV1PipelineProspectingSequencesSequenceIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Change sequence status (activate, pause, archive).
 * @summary Change Sequence Status
 */
export const changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch =
  (sequenceId: string, sequenceStatusUpdate: SequenceStatusUpdate) => {
    return customInstance<SequenceResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/status`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sequenceStatusUpdate
    });
  };

export const getChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
        >
      >,
      TError,
      { sequenceId: string; data: SequenceStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
        >
      >,
      { sequenceId: string; data: SequenceStatusUpdate }
    > = (props) => {
      const { sequenceId, data } = props ?? {};

      return changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch(
        sequenceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
      >
    >
  >;
export type ChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatchMutationBody =
  SequenceStatusUpdate;
export type ChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatchMutationError =
  HTTPValidationError;

/**
 * @summary Change Sequence Status
 */
export const useChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
          >
        >,
        TError,
        { sequenceId: string; data: SequenceStatusUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof changeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatch
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStatusUpdate },
    TContext
  > => {
    const mutationOptions =
      getChangeSequenceStatusApiV1PipelineProspectingSequencesSequenceIdStatusPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Duplicate a sequence with all its steps and variants.
 * @summary Duplicate Sequence
 */
export const duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost =
  (sequenceId: string, signal?: AbortSignal) => {
    return customInstance<SequenceResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/duplicate`,
      method: 'POST',
      signal
    });
  };

export const getDuplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
        >
      >,
      TError,
      { sequenceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
      >
    >,
    TError,
    { sequenceId: string },
    TContext
  > => {
    const mutationKey = [
      'duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
        >
      >,
      { sequenceId: string }
    > = (props) => {
      const { sequenceId } = props ?? {};

      return duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost(
        sequenceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
      >
    >
  >;

export type DuplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Sequence
 */
export const useDuplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
          >
        >,
        TError,
        { sequenceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof duplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePost
      >
    >,
    TError,
    { sequenceId: string },
    TContext
  > => {
    const mutationOptions =
      getDuplicateSequenceApiV1PipelineProspectingSequencesSequenceIdDuplicatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all steps for a sequence.
 * @summary List Steps
 */
export const listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet = (
  sequenceId: string,
  signal?: AbortSignal
) => {
  return customInstance<SequenceStepListResponse>({
    url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps`,
    method: 'GET',
    signal
  });
};

export const getListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryKey =
  (sequenceId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps`
    ] as const;
  };

export const getListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
      >
    >,
    TError = HTTPValidationError
  >(
    sequenceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryKey(
        sequenceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
        >
      >
    > = ({ signal }) =>
      listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet(
        sequenceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sequenceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
      >
    >
  >;
export type ListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryError =
  HTTPValidationError;

export function useListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet<
  TData = Awaited<
    ReturnType<
      typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet<
  TData = Awaited<
    ReturnType<
      typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet<
  TData = Awaited<
    ReturnType<
      typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Steps
 */

export function useListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet<
  TData = Awaited<
    ReturnType<
      typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStepsApiV1PipelineProspectingSequencesSequenceIdStepsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStepsApiV1PipelineProspectingSequencesSequenceIdStepsGetQueryOptions(
      sequenceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a step to a sequence.
 * @summary Create Step
 */
export const createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost = (
  sequenceId: string,
  sequenceStepCreate: SequenceStepCreate,
  signal?: AbortSignal
) => {
  return customInstance<SequenceStepResponse>({
    url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sequenceStepCreate,
    signal
  });
};

export const getCreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
        >
      >,
      TError,
      { sequenceId: string; data: SequenceStepCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStepCreate },
    TContext
  > => {
    const mutationKey = [
      'createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
        >
      >,
      { sequenceId: string; data: SequenceStepCreate }
    > = (props) => {
      const { sequenceId, data } = props ?? {};

      return createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost(
        sequenceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
      >
    >
  >;
export type CreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPostMutationBody =
  SequenceStepCreate;
export type CreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Step
 */
export const useCreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
          >
        >,
        TError,
        { sequenceId: string; data: SequenceStepCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createStepApiV1PipelineProspectingSequencesSequenceIdStepsPost
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStepCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateStepApiV1PipelineProspectingSequencesSequenceIdStepsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reorder steps in a sequence.
 * @summary Reorder Steps
 */
export const reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut =
  (
    sequenceId: string,
    sequenceStepReorderRequest: SequenceStepReorderRequest
  ) => {
    return customInstance<SequenceStepListResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps/reorder`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sequenceStepReorderRequest
    });
  };

export const getReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
        >
      >,
      TError,
      { sequenceId: string; data: SequenceStepReorderRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStepReorderRequest },
    TContext
  > => {
    const mutationKey = [
      'reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
        >
      >,
      { sequenceId: string; data: SequenceStepReorderRequest }
    > = (props) => {
      const { sequenceId, data } = props ?? {};

      return reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut(
        sequenceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
      >
    >
  >;
export type ReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPutMutationBody =
  SequenceStepReorderRequest;
export type ReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Steps
 */
export const useReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
          >
        >,
        TError,
        { sequenceId: string; data: SequenceStepReorderRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPut
      >
    >,
    TError,
    { sequenceId: string; data: SequenceStepReorderRequest },
    TContext
  > => {
    const mutationOptions =
      getReorderStepsApiV1PipelineProspectingSequencesSequenceIdStepsReorderPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a step.
 * @summary Update Step
 */
export const updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut =
  (
    sequenceId: string,
    stepId: string,
    sequenceStepUpdate: SequenceStepUpdate
  ) => {
    return customInstance<SequenceStepResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps/${stepId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sequenceStepUpdate
    });
  };

export const getUpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
        >
      >,
      TError,
      { sequenceId: string; stepId: string; data: SequenceStepUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
      >
    >,
    TError,
    { sequenceId: string; stepId: string; data: SequenceStepUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
        >
      >,
      { sequenceId: string; stepId: string; data: SequenceStepUpdate }
    > = (props) => {
      const { sequenceId, stepId, data } = props ?? {};

      return updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut(
        sequenceId,
        stepId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
      >
    >
  >;
export type UpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPutMutationBody =
  SequenceStepUpdate;
export type UpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Step
 */
export const useUpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
          >
        >,
        TError,
        { sequenceId: string; stepId: string; data: SequenceStepUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPut
      >
    >,
    TError,
    { sequenceId: string; stepId: string; data: SequenceStepUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a step from a sequence.
 * @summary Delete Step
 */
export const deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete =
  (sequenceId: string, stepId: string) => {
    return customInstance<ProspectingDeleteResult>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/steps/${stepId}`,
      method: 'DELETE'
    });
  };

export const getDeleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
        >
      >,
      TError,
      { sequenceId: string; stepId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
      >
    >,
    TError,
    { sequenceId: string; stepId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
        >
      >,
      { sequenceId: string; stepId: string }
    > = (props) => {
      const { sequenceId, stepId } = props ?? {};

      return deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete(
        sequenceId,
        stepId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
      >
    >
  >;

export type DeleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Step
 */
export const useDeleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
          >
        >,
        TError,
        { sequenceId: string; stepId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDelete
      >
    >,
    TError,
    { sequenceId: string; stepId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteStepApiV1PipelineProspectingSequencesSequenceIdStepsStepIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List variants for a step.
 * @summary List Variants
 */
export const listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet = (
  stepId: string,
  signal?: AbortSignal
) => {
  return customInstance<SequenceStepVariantListResponse>({
    url: `/api/v1/pipeline/prospecting/steps/${stepId}/variants`,
    method: 'GET',
    signal
  });
};

export const getListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryKey =
  (stepId?: string) => {
    return [`/api/v1/pipeline/prospecting/steps/${stepId}/variants`] as const;
  };

export const getListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
      >
    >,
    TError = HTTPValidationError
  >(
    stepId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryKey(
        stepId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
        >
      >
    > = ({ signal }) =>
      listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet(
        stepId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!stepId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
      >
    >
  >;
export type ListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryError =
  HTTPValidationError;

export function useListVariantsApiV1PipelineProspectingStepsStepIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  stepId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVariantsApiV1PipelineProspectingStepsStepIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  stepId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVariantsApiV1PipelineProspectingStepsStepIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  stepId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Variants
 */

export function useListVariantsApiV1PipelineProspectingStepsStepIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  stepId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1PipelineProspectingStepsStepIdVariantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVariantsApiV1PipelineProspectingStepsStepIdVariantsGetQueryOptions(
      stepId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an A/B test variant to a step.
 * @summary Create Variant
 */
export const createVariantApiV1PipelineProspectingStepsStepIdVariantsPost = (
  stepId: string,
  sequenceStepVariantCreate: SequenceStepVariantCreate,
  signal?: AbortSignal
) => {
  return customInstance<SequenceStepVariantResponse>({
    url: `/api/v1/pipeline/prospecting/steps/${stepId}/variants`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sequenceStepVariantCreate,
    signal
  });
};

export const getCreateVariantApiV1PipelineProspectingStepsStepIdVariantsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
        >
      >,
      TError,
      { stepId: string; data: SequenceStepVariantCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
      >
    >,
    TError,
    { stepId: string; data: SequenceStepVariantCreate },
    TContext
  > => {
    const mutationKey = [
      'createVariantApiV1PipelineProspectingStepsStepIdVariantsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
        >
      >,
      { stepId: string; data: SequenceStepVariantCreate }
    > = (props) => {
      const { stepId, data } = props ?? {};

      return createVariantApiV1PipelineProspectingStepsStepIdVariantsPost(
        stepId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateVariantApiV1PipelineProspectingStepsStepIdVariantsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
      >
    >
  >;
export type CreateVariantApiV1PipelineProspectingStepsStepIdVariantsPostMutationBody =
  SequenceStepVariantCreate;
export type CreateVariantApiV1PipelineProspectingStepsStepIdVariantsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Variant
 */
export const useCreateVariantApiV1PipelineProspectingStepsStepIdVariantsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
        >
      >,
      TError,
      { stepId: string; data: SequenceStepVariantCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createVariantApiV1PipelineProspectingStepsStepIdVariantsPost
    >
  >,
  TError,
  { stepId: string; data: SequenceStepVariantCreate },
  TContext
> => {
  const mutationOptions =
    getCreateVariantApiV1PipelineProspectingStepsStepIdVariantsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a variant.
 * @summary Update Variant
 */
export const updateVariantApiV1PipelineProspectingVariantsVariantIdPut = (
  variantId: string,
  sequenceStepVariantUpdate: SequenceStepVariantUpdate
) => {
  return customInstance<SequenceStepVariantResponse>({
    url: `/api/v1/pipeline/prospecting/variants/${variantId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sequenceStepVariantUpdate
  });
};

export const getUpdateVariantApiV1PipelineProspectingVariantsVariantIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut
        >
      >,
      TError,
      { variantId: string; data: SequenceStepVariantUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut
      >
    >,
    TError,
    { variantId: string; data: SequenceStepVariantUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateVariantApiV1PipelineProspectingVariantsVariantIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut
        >
      >,
      { variantId: string; data: SequenceStepVariantUpdate }
    > = (props) => {
      const { variantId, data } = props ?? {};

      return updateVariantApiV1PipelineProspectingVariantsVariantIdPut(
        variantId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateVariantApiV1PipelineProspectingVariantsVariantIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut
      >
    >
  >;
export type UpdateVariantApiV1PipelineProspectingVariantsVariantIdPutMutationBody =
  SequenceStepVariantUpdate;
export type UpdateVariantApiV1PipelineProspectingVariantsVariantIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Variant
 */
export const useUpdateVariantApiV1PipelineProspectingVariantsVariantIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut
        >
      >,
      TError,
      { variantId: string; data: SequenceStepVariantUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateVariantApiV1PipelineProspectingVariantsVariantIdPut>
  >,
  TError,
  { variantId: string; data: SequenceStepVariantUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateVariantApiV1PipelineProspectingVariantsVariantIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove a variant.
 * @summary Delete Variant
 */
export const deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete = (
  variantId: string
) => {
  return customInstance<ProspectingDeleteResult>({
    url: `/api/v1/pipeline/prospecting/variants/${variantId}`,
    method: 'DELETE'
  });
};

export const getDeleteVariantApiV1PipelineProspectingVariantsVariantIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
        >
      >,
      TError,
      { variantId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
      >
    >,
    TError,
    { variantId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
        >
      >,
      { variantId: string }
    > = (props) => {
      const { variantId } = props ?? {};

      return deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete(
        variantId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteVariantApiV1PipelineProspectingVariantsVariantIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
      >
    >
  >;

export type DeleteVariantApiV1PipelineProspectingVariantsVariantIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Variant
 */
export const useDeleteVariantApiV1PipelineProspectingVariantsVariantIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
        >
      >,
      TError,
      { variantId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteVariantApiV1PipelineProspectingVariantsVariantIdDelete
    >
  >,
  TError,
  { variantId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteVariantApiV1PipelineProspectingVariantsVariantIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Figures over a sequence's whole enrollment set — the list holds one page.
 * @summary Get Enrollment Aggregates
 */
export const getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet =
  (
    sequenceId: string,
    params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<EnrollmentAggregatesResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/enrollments/aggregates`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryKey =
  (
    sequenceId?: string,
    params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams
  ) => {
    return [
      `/api/v1/pipeline/prospecting/sequences/${sequenceId}/enrollments/aggregates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    sequenceId: string,
    params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryKey(
        sequenceId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
        >
      >
    > = ({ signal }) =>
      getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet(
        sequenceId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sequenceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
      >
    >
  >;
export type GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryError =
  HTTPValidationError;

export function useGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params:
    | undefined
    | GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Enrollment Aggregates
 */

export function useGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: GetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEnrollmentAggregatesApiV1PipelineProspectingSequencesSequenceIdEnrollmentsAggregatesGetQueryOptions(
      sequenceId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of a sequence's enrollments, plus the filtered total.
 * @summary List Enrollments
 */
export const listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet =
  (
    sequenceId: string,
    params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<EnrollmentListResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/enrollments`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryKey =
  (
    sequenceId?: string,
    params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams
  ) => {
    return [
      `/api/v1/pipeline/prospecting/sequences/${sequenceId}/enrollments`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    sequenceId: string,
    params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryKey(
        sequenceId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
        >
      >
    > = ({ signal }) =>
      listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet(
        sequenceId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sequenceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
      >
    >
  >;
export type ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryError =
  HTTPValidationError;

export function useListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params:
    | undefined
    | ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Enrollments
 */

export function useListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  params?: ListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEnrollmentsApiV1PipelineProspectingSequencesSequenceIdEnrollmentsGetQueryOptions(
      sequenceId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enroll contacts in a sequence.
 * @summary Enroll Contacts
 */
export const enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost =
  (
    sequenceId: string,
    enrollContactsRequest: EnrollContactsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<EnrollmentListResponse>({
      url: `/api/v1/pipeline/prospecting/sequences/${sequenceId}/enroll`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: enrollContactsRequest,
      signal
    });
  };

export const getEnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
        >
      >,
      TError,
      { sequenceId: string; data: EnrollContactsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
      >
    >,
    TError,
    { sequenceId: string; data: EnrollContactsRequest },
    TContext
  > => {
    const mutationKey = [
      'enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
        >
      >,
      { sequenceId: string; data: EnrollContactsRequest }
    > = (props) => {
      const { sequenceId, data } = props ?? {};

      return enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost(
        sequenceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
      >
    >
  >;
export type EnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPostMutationBody =
  EnrollContactsRequest;
export type EnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPostMutationError =
  HTTPValidationError;

/**
 * @summary Enroll Contacts
 */
export const useEnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
          >
        >,
        TError,
        { sequenceId: string; data: EnrollContactsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof enrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPost
      >
    >,
    TError,
    { sequenceId: string; data: EnrollContactsRequest },
    TContext
  > => {
    const mutationOptions =
      getEnrollContactsApiV1PipelineProspectingSequencesSequenceIdEnrollPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Pause, resume, or remove an enrollment.
 * @summary Change Enrollment Status
 */
export const changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch =
  (enrollmentId: string, enrollmentStatusUpdate: EnrollmentStatusUpdate) => {
    return customInstance<EnrollmentResponse>({
      url: `/api/v1/pipeline/prospecting/enrollments/${enrollmentId}/status`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: enrollmentStatusUpdate
    });
  };

export const getChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
        >
      >,
      TError,
      { enrollmentId: string; data: EnrollmentStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
      >
    >,
    TError,
    { enrollmentId: string; data: EnrollmentStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
        >
      >,
      { enrollmentId: string; data: EnrollmentStatusUpdate }
    > = (props) => {
      const { enrollmentId, data } = props ?? {};

      return changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch(
        enrollmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
      >
    >
  >;
export type ChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatchMutationBody =
  EnrollmentStatusUpdate;
export type ChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatchMutationError =
  HTTPValidationError;

/**
 * @summary Change Enrollment Status
 */
export const useChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
          >
        >,
        TError,
        { enrollmentId: string; data: EnrollmentStatusUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof changeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatch
      >
    >,
    TError,
    { enrollmentId: string; data: EnrollmentStatusUpdate },
    TContext
  > => {
    const mutationOptions =
      getChangeEnrollmentStatusApiV1PipelineProspectingEnrollmentsEnrollmentIdStatusPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get enrollment detail with step states.
 * @summary Get Enrollment
 */
export const getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet = (
  enrollmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<EnrollmentResponse>({
    url: `/api/v1/pipeline/prospecting/enrollments/${enrollmentId}`,
    method: 'GET',
    signal
  });
};

export const getGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryKey =
  (enrollmentId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/enrollments/${enrollmentId}`
    ] as const;
  };

export const getGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    enrollmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryKey(
        enrollmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
        >
      >
    > = ({ signal }) =>
      getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet(
        enrollmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!enrollmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
      >
    >
  >;
export type GetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryError =
  HTTPValidationError;

export function useGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  enrollmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  enrollmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  enrollmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Enrollment
 */

export function useGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  enrollmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEnrollmentApiV1PipelineProspectingEnrollmentsEnrollmentIdGetQueryOptions(
      enrollmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a contact's enrollment history.
 * @summary Get Contact Enrollments
 */
export const getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet =
  (contactId: string, signal?: AbortSignal) => {
    return customInstance<EnrollmentListResponse>({
      url: `/api/v1/pipeline/prospecting/contacts/${contactId}/enrollments`,
      method: 'GET',
      signal
    });
  };

export const getGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryKey =
  (contactId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/contacts/${contactId}/enrollments`
    ] as const;
  };

export const getGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryKey(
        contactId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
        >
      >
    > = ({ signal }) =>
      getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet(
        contactId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
      >
    >
  >;
export type GetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryError =
  HTTPValidationError;

export function useGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contact Enrollments
 */

export function useGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet<
  TData = Awaited<
    ReturnType<
      typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactEnrollmentsApiV1PipelineProspectingContactsContactIdEnrollmentsGetQueryOptions(
      contactId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List outreach tasks with optional filtering.
 * @summary List Outreach Tasks
 */
export const listOutreachTasksApiV1PipelineProspectingTasksGet = (
  params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
  signal?: AbortSignal
) => {
  return customInstance<OutreachTaskListResponse>({
    url: `/api/v1/pipeline/prospecting/tasks`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOutreachTasksApiV1PipelineProspectingTasksGetQueryKey = (
  params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams
) => {
  return [
    `/api/v1/pipeline/prospecting/tasks`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListOutreachTasksApiV1PipelineProspectingTasksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOutreachTasksApiV1PipelineProspectingTasksGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
      >
    > = ({ signal }) =>
      listOutreachTasksApiV1PipelineProspectingTasksGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOutreachTasksApiV1PipelineProspectingTasksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
    >
  >;
export type ListOutreachTasksApiV1PipelineProspectingTasksGetQueryError =
  HTTPValidationError;

export function useListOutreachTasksApiV1PipelineProspectingTasksGet<
  TData = Awaited<
    ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOutreachTasksApiV1PipelineProspectingTasksGet<
  TData = Awaited<
    ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOutreachTasksApiV1PipelineProspectingTasksGet<
  TData = Awaited<
    ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Outreach Tasks
 */

export function useListOutreachTasksApiV1PipelineProspectingTasksGet<
  TData = Awaited<
    ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOutreachTasksApiV1PipelineProspectingTasksGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOutreachTasksApiV1PipelineProspectingTasksGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOutreachTasksApiV1PipelineProspectingTasksGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get today's prioritized outreach task queue for the current user.
 * @summary Get Today Tasks
 */
export const getTodayTasksApiV1PipelineProspectingTasksTodayGet = (
  signal?: AbortSignal
) => {
  return customInstance<OutreachTaskListResponse>({
    url: `/api/v1/pipeline/prospecting/tasks/today`,
    method: 'GET',
    signal
  });
};

export const getGetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryKey =
  () => {
    return [`/api/v1/pipeline/prospecting/tasks/today`] as const;
  };

export const getGetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
      >
    > = ({ signal }) =>
      getTodayTasksApiV1PipelineProspectingTasksTodayGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
    >
  >;
export type GetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryError =
  unknown;

export function useGetTodayTasksApiV1PipelineProspectingTasksTodayGet<
  TData = Awaited<
    ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTodayTasksApiV1PipelineProspectingTasksTodayGet<
  TData = Awaited<
    ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTodayTasksApiV1PipelineProspectingTasksTodayGet<
  TData = Awaited<
    ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Today Tasks
 */

export function useGetTodayTasksApiV1PipelineProspectingTasksTodayGet<
  TData = Awaited<
    ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTodayTasksApiV1PipelineProspectingTasksTodayGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTodayTasksApiV1PipelineProspectingTasksTodayGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Complete or skip an outreach task.
 * @summary Change Task Status
 */
export const changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch = (
  taskId: string,
  outreachTaskStatusUpdate: OutreachTaskStatusUpdate
) => {
  return customInstance<OutreachTaskResponse>({
    url: `/api/v1/pipeline/prospecting/tasks/${taskId}/status`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: outreachTaskStatusUpdate
  });
};

export const getChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
        >
      >,
      TError,
      { taskId: string; data: OutreachTaskStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
      >
    >,
    TError,
    { taskId: string; data: OutreachTaskStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
        >
      >,
      { taskId: string; data: OutreachTaskStatusUpdate }
    > = (props) => {
      const { taskId, data } = props ?? {};

      return changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch(
        taskId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
      >
    >
  >;
export type ChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatchMutationBody =
  OutreachTaskStatusUpdate;
export type ChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatchMutationError =
  HTTPValidationError;

/**
 * @summary Change Task Status
 */
export const useChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
          >
        >,
        TError,
        { taskId: string; data: OutreachTaskStatusUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof changeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatch
      >
    >,
    TError,
    { taskId: string; data: OutreachTaskStatusUpdate },
    TContext
  > => {
    const mutationOptions =
      getChangeTaskStatusApiV1PipelineProspectingTasksTaskIdStatusPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Log the outcome of a call or task.
 * @summary Update Task Outcome
 */
export const updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch =
  (taskId: string, outreachTaskOutcomeUpdate: OutreachTaskOutcomeUpdate) => {
    return customInstance<OutreachTaskResponse>({
      url: `/api/v1/pipeline/prospecting/tasks/${taskId}/outcome`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: outreachTaskOutcomeUpdate
    });
  };

export const getUpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
        >
      >,
      TError,
      { taskId: string; data: OutreachTaskOutcomeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
      >
    >,
    TError,
    { taskId: string; data: OutreachTaskOutcomeUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
        >
      >,
      { taskId: string; data: OutreachTaskOutcomeUpdate }
    > = (props) => {
      const { taskId, data } = props ?? {};

      return updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch(
        taskId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
      >
    >
  >;
export type UpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatchMutationBody =
  OutreachTaskOutcomeUpdate;
export type UpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Task Outcome
 */
export const useUpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
          >
        >,
        TError,
        { taskId: string; data: OutreachTaskOutcomeUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatch
      >
    >,
    TError,
    { taskId: string; data: OutreachTaskOutcomeUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateTaskOutcomeApiV1PipelineProspectingTasksTaskIdOutcomePatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Trigger AI research for a contact.
 * @summary Research Contact
 */
export const researchContactApiV1PipelineProspectingResearchContactContactIdPost =
  (contactId: string, signal?: AbortSignal) => {
    return customInstance<ProspectResearchResponse>({
      url: `/api/v1/pipeline/prospecting/research/contact/${contactId}`,
      method: 'POST',
      signal
    });
  };

export const getResearchContactApiV1PipelineProspectingResearchContactContactIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'researchContactApiV1PipelineProspectingResearchContactContactIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return researchContactApiV1PipelineProspectingResearchContactContactIdPost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResearchContactApiV1PipelineProspectingResearchContactContactIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
      >
    >
  >;

export type ResearchContactApiV1PipelineProspectingResearchContactContactIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Research Contact
 */
export const useResearchContactApiV1PipelineProspectingResearchContactContactIdPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
          >
        >,
        TError,
        { contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof researchContactApiV1PipelineProspectingResearchContactContactIdPost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationOptions =
      getResearchContactApiV1PipelineProspectingResearchContactContactIdPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get the latest research profile for a contact.
 * @summary Get Contact Research
 */
export const getContactResearchApiV1PipelineProspectingResearchContactContactIdGet =
  (contactId: string, signal?: AbortSignal) => {
    return customInstance<ProspectResearchResponse>({
      url: `/api/v1/pipeline/prospecting/research/contact/${contactId}`,
      method: 'GET',
      signal
    });
  };

export const getGetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryKey =
  (contactId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/research/contact/${contactId}`
    ] as const;
  };

export const getGetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryKey(
        contactId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
        >
      >
    > = ({ signal }) =>
      getContactResearchApiV1PipelineProspectingResearchContactContactIdGet(
        contactId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
      >
    >
  >;
export type GetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryError =
  HTTPValidationError;

export function useGetContactResearchApiV1PipelineProspectingResearchContactContactIdGet<
  TData = Awaited<
    ReturnType<
      typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactResearchApiV1PipelineProspectingResearchContactContactIdGet<
  TData = Awaited<
    ReturnType<
      typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactResearchApiV1PipelineProspectingResearchContactContactIdGet<
  TData = Awaited<
    ReturnType<
      typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contact Research
 */

export function useGetContactResearchApiV1PipelineProspectingResearchContactContactIdGet<
  TData = Awaited<
    ReturnType<
      typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactResearchApiV1PipelineProspectingResearchContactContactIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactResearchApiV1PipelineProspectingResearchContactContactIdGetQueryOptions(
      contactId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Trigger AI research for a company.
 * @summary Research Organization
 */
export const researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<ProspectResearchResponse>({
      url: `/api/v1/pipeline/prospecting/research/organization/${organizationId}`,
      method: 'POST',
      signal
    });
  };

export const getResearchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResearchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
      >
    >
  >;

export type ResearchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Research Organization
 */
export const useResearchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof researchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getResearchOrganizationApiV1PipelineProspectingResearchOrganizationOrganizationIdPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get the latest research profile for a company.
 * @summary Get Organization Research
 */
export const getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<ProspectResearchResponse>({
      url: `/api/v1/pipeline/prospecting/research/organization/${organizationId}`,
      method: 'GET',
      signal
    });
  };

export const getGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryKey =
  (organizationId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/research/organization/${organizationId}`
    ] as const;
  };

export const getGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryKey(
        organizationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
        >
      >
    > = ({ signal }) =>
      getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet(
        organizationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
      >
    >
  >;
export type GetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryError =
  HTTPValidationError;

export function useGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organization Research
 */

export function useGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOrganizationResearchApiV1PipelineProspectingResearchOrganizationOrganizationIdGetQueryOptions(
      organizationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate a personalized outreach email for a contact using AI.
 * @summary Generate Email
 */
export const generateEmailApiV1PipelineProspectingAiGenerateEmailPost = (
  generateEmailRequest: GenerateEmailRequest,
  signal?: AbortSignal
) => {
  return customInstance<GenerateEmailResponse>({
    url: `/api/v1/pipeline/prospecting/ai/generate-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateEmailRequest,
    signal
  });
};

export const getGenerateEmailApiV1PipelineProspectingAiGenerateEmailPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost
        >
      >,
      TError,
      { data: GenerateEmailRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost
      >
    >,
    TError,
    { data: GenerateEmailRequest },
    TContext
  > => {
    const mutationKey = [
      'generateEmailApiV1PipelineProspectingAiGenerateEmailPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost
        >
      >,
      { data: GenerateEmailRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateEmailApiV1PipelineProspectingAiGenerateEmailPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateEmailApiV1PipelineProspectingAiGenerateEmailPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost
      >
    >
  >;
export type GenerateEmailApiV1PipelineProspectingAiGenerateEmailPostMutationBody =
  GenerateEmailRequest;
export type GenerateEmailApiV1PipelineProspectingAiGenerateEmailPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Email
 */
export const useGenerateEmailApiV1PipelineProspectingAiGenerateEmailPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost
        >
      >,
      TError,
      { data: GenerateEmailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof generateEmailApiV1PipelineProspectingAiGenerateEmailPost>
  >,
  TError,
  { data: GenerateEmailRequest },
  TContext
> => {
  const mutationOptions =
    getGenerateEmailApiV1PipelineProspectingAiGenerateEmailPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * AI-generate a full sequence structure from a natural language description.
 * @summary Generate Sequence
 */
export const generateSequenceApiV1PipelineProspectingAiGenerateSequencePost = (
  generateSequenceRequest: GenerateSequenceRequest,
  signal?: AbortSignal
) => {
  return customInstance<GenerateSequenceResponse>({
    url: `/api/v1/pipeline/prospecting/ai/generate-sequence`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateSequenceRequest,
    signal
  });
};

export const getGenerateSequenceApiV1PipelineProspectingAiGenerateSequencePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
        >
      >,
      TError,
      { data: GenerateSequenceRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
      >
    >,
    TError,
    { data: GenerateSequenceRequest },
    TContext
  > => {
    const mutationKey = [
      'generateSequenceApiV1PipelineProspectingAiGenerateSequencePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
        >
      >,
      { data: GenerateSequenceRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateSequenceApiV1PipelineProspectingAiGenerateSequencePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateSequenceApiV1PipelineProspectingAiGenerateSequencePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
      >
    >
  >;
export type GenerateSequenceApiV1PipelineProspectingAiGenerateSequencePostMutationBody =
  GenerateSequenceRequest;
export type GenerateSequenceApiV1PipelineProspectingAiGenerateSequencePostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Sequence
 */
export const useGenerateSequenceApiV1PipelineProspectingAiGenerateSequencePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
          >
        >,
        TError,
        { data: GenerateSequenceRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateSequenceApiV1PipelineProspectingAiGenerateSequencePost
      >
    >,
    TError,
    { data: GenerateSequenceRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateSequenceApiV1PipelineProspectingAiGenerateSequencePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Engagement aggregates for one sequence, for its Analytics tab.

Open and click rates are deliberately absent: nothing in the outreach
pipeline records them, so the tab reports what is measured rather than a
permanent zero. See ``ProspectingAnalyticsService``.
 * @summary Get Sequence Analytics
 */
export const getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet =
  (sequenceId: string, signal?: AbortSignal) => {
    return customInstance<SequenceAnalytics>({
      url: `/api/v1/pipeline/prospecting/analytics/sequences/${sequenceId}`,
      method: 'GET',
      signal
    });
  };

export const getGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryKey =
  (sequenceId?: string) => {
    return [
      `/api/v1/pipeline/prospecting/analytics/sequences/${sequenceId}`
    ] as const;
  };

export const getGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    sequenceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryKey(
        sequenceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
        >
      >
    > = ({ signal }) =>
      getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet(
        sequenceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sequenceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
      >
    >
  >;
export type GetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryError =
  HTTPValidationError;

export function useGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<
      typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<
      typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<
      typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sequence Analytics
 */

export function useGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet<
  TData = Awaited<
    ReturnType<
      typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
    >
  >,
  TError = HTTPValidationError
>(
  sequenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSequenceAnalyticsApiV1PipelineProspectingAnalyticsSequencesSequenceIdGetQueryOptions(
      sequenceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List available lead source agents, optionally filtered by phase and mode.

``mode`` narrows the library to the agents that can actually run in that
mode's phase graph — a phase name is mode-polymorphic, so without it the
pipeline editor offers e.g. the company batch-search agents to a people-first
campaign, where the engine would (correctly) never run them.

``phases`` is that mode's phase graph in execution order, so the pipeline
editor lays its phase cards out the way the engine actually runs them instead
of hand-copying an order that only holds company-first (people-first runs
``contact_finding`` first). Unaffected by ``phase``, which narrows the agent
list only. A new graph therefore needs no frontend change.

Paid agents (``is_paid``) carry their per-success ``unit_price`` for this
tenant. The registry is tenant-agnostic and can only declare *that* an agent is
billable, so the price is resolved here — once for the whole response, not per
agent — and the editor can state the actual cost before the user switches it on.
 * @summary List Agents
 */
export const listAgentsApiV1PipelineLeadSourceAgentsAgentsGet = (
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceAgentLibraryResponse>({
    url: `/api/v1/pipeline/lead-source-agents/agents`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryKey = (
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams
) => {
  return [
    `/api/v1/pipeline/lead-source-agents/agents`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>>
  > = ({ signal }) =>
    listAgentsApiV1PipelineLeadSourceAgentsAgentsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>>
  >;
export type ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryError =
  HTTPValidationError;

export function useListAgentsApiV1PipelineLeadSourceAgentsAgentsGet<
  TData = Awaited<
    ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAgentsApiV1PipelineLeadSourceAgentsAgentsGet<
  TData = Awaited<
    ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAgentsApiV1PipelineLeadSourceAgentsAgentsGet<
  TData = Awaited<
    ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Agents
 */

export function useListAgentsApiV1PipelineLeadSourceAgentsAgentsGet<
  TData = Awaited<
    ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1PipelineLeadSourceAgentsAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAgentsApiV1PipelineLeadSourceAgentsAgentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAgentsApiV1PipelineLeadSourceAgentsAgentsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List lead source agents.

``target`` filters by persistence destination (``crm`` vs ``recruiting``) so
the CRM prospecting list and the recruiting sourcing list stay disjoint.
 * @summary List Lead Source Agents
 */
export const listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet = (
  params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceAgentListResponse>({
    url: `/api/v1/pipeline/lead-source-agents`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryKey = (
  params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams
) => {
  return [
    `/api/v1/pipeline/lead-source-agents`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
      >
    > = ({ signal }) =>
      listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
    >
  >;
export type ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryError =
  HTTPValidationError;

export function useListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet<
  TData = Awaited<
    ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet<
  TData = Awaited<
    ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet<
  TData = Awaited<
    ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Lead Source Agents
 */

export function useListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet<
  TData = Awaited<
    ReturnType<typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeadSourceAgentsApiV1PipelineLeadSourceAgentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeadSourceAgentsApiV1PipelineLeadSourceAgentsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new lead source agent.
 * @summary Create Lead Source Agent
 */
export const createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost = (
  leadSourceAgentCreate: LeadSourceAgentCreate,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceAgentResponse>({
    url: `/api/v1/pipeline/lead-source-agents`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leadSourceAgentCreate,
    signal
  });
};

export const getCreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost
        >
      >,
      TError,
      { data: LeadSourceAgentCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost>
    >,
    TError,
    { data: LeadSourceAgentCreate },
    TContext
  > => {
    const mutationKey = [
      'createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost
        >
      >,
      { data: LeadSourceAgentCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost>
    >
  >;
export type CreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPostMutationBody =
  LeadSourceAgentCreate;
export type CreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Lead Source Agent
 */
export const useCreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost
        >
      >,
      TError,
      { data: LeadSourceAgentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createLeadSourceAgentApiV1PipelineLeadSourceAgentsPost>
  >,
  TError,
  { data: LeadSourceAgentCreate },
  TContext
> => {
  const mutationOptions =
    getCreateLeadSourceAgentApiV1PipelineLeadSourceAgentsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a lead source agent with pipeline steps.
 * @summary Get Lead Source Agent
 */
export const getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet = (
  agentId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceAgentResponse>({
    url: `/api/v1/pipeline/lead-source-agents/${agentId}`,
    method: 'GET',
    signal
  });
};

export const getGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryKey =
  (agentId?: string) => {
    return [`/api/v1/pipeline/lead-source-agents/${agentId}`] as const;
  };

export const getGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    agentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryKey(
        agentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
        >
      >
    > = ({ signal }) =>
      getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet(
        agentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!agentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
      >
    >
  >;
export type GetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryError =
  HTTPValidationError;

export function useGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Lead Source Agent
 */

export function useGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet<
  TData = Awaited<
    ReturnType<typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdGetQueryOptions(
      agentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a lead source agent.
 * @summary Update Lead Source Agent
 */
export const updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut = (
  agentId: string,
  leadSourceAgentUpdate: LeadSourceAgentUpdate
) => {
  return customInstance<LeadSourceAgentResponse>({
    url: `/api/v1/pipeline/lead-source-agents/${agentId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: leadSourceAgentUpdate
  });
};

export const getUpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
        >
      >,
      TError,
      { agentId: string; data: LeadSourceAgentUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
      >
    >,
    TError,
    { agentId: string; data: LeadSourceAgentUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
        >
      >,
      { agentId: string; data: LeadSourceAgentUpdate }
    > = (props) => {
      const { agentId, data } = props ?? {};

      return updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut(
        agentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
      >
    >
  >;
export type UpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPutMutationBody =
  LeadSourceAgentUpdate;
export type UpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Source Agent
 */
export const useUpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
        >
      >,
      TError,
      { agentId: string; data: LeadSourceAgentUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPut
    >
  >,
  TError,
  { agentId: string; data: LeadSourceAgentUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft delete a lead source agent.
 * @summary Delete Lead Source Agent
 */
export const deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete = (
  agentId: string
) => {
  return customInstance<DeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete200>(
    { url: `/api/v1/pipeline/lead-source-agents/${agentId}`, method: 'DELETE' }
  );
};

export const getDeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
        >
      >,
      TError,
      { agentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
      >
    >,
    TError,
    { agentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
        >
      >,
      { agentId: string }
    > = (props) => {
      const { agentId } = props ?? {};

      return deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete(
        agentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
      >
    >
  >;

export type DeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Lead Source Agent
 */
export const useDeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
          >
        >,
        TError,
        { agentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDelete
      >
    >,
    TError,
    { agentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteLeadSourceAgentApiV1PipelineLeadSourceAgentsAgentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Replace all pipeline steps for a lead source agent.

Named distinctly from ``routes.py``'s ``update_pipeline`` on purpose: the MCP
tool name derives from the function name, and two same-named handlers in one
module collide into a duplicate Anthropic tool name that 400s every AI call
carrying pipeline tools (WI 863ca8a1; enforced by the MCP schema generator's
duplicate-name check).
 * @summary Update Lead Source Pipeline
 */
export const updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut =
  (agentId: string, pipelineUpdateRequest: PipelineUpdateRequest) => {
    return customInstance<UpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut200>(
      {
        url: `/api/v1/pipeline/lead-source-agents/${agentId}/pipeline`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: pipelineUpdateRequest
      }
    );
  };

export const getUpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
        >
      >,
      TError,
      { agentId: string; data: PipelineUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
      >
    >,
    TError,
    { agentId: string; data: PipelineUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
        >
      >,
      { agentId: string; data: PipelineUpdateRequest }
    > = (props) => {
      const { agentId, data } = props ?? {};

      return updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut(
        agentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
      >
    >
  >;
export type UpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePutMutationBody =
  PipelineUpdateRequest;
export type UpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePutMutationError =
  HTTPValidationError;

/**
 * @summary Update Lead Source Pipeline
 */
export const useUpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
          >
        >,
        TError,
        { agentId: string; data: PipelineUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePut
      >
    >,
    TError,
    { agentId: string; data: PipelineUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateLeadSourcePipelineApiV1PipelineLeadSourceAgentsAgentIdPipelinePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Trigger a new lead source run.
 * @summary Trigger Run
 */
export const triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost = (
  leadSourceAgentId: string,
  triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody,
  signal?: AbortSignal
) => {
  return customInstance<TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost201>(
    {
      url: `/api/v1/pipeline/lead-source-agents/${leadSourceAgentId}/run`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody,
      signal
    }
  );
};

export const getTriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
        >
      >,
      TError,
      {
        leadSourceAgentId: string;
        data: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
      >
    >,
    TError,
    {
      leadSourceAgentId: string;
      data: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
        >
      >,
      {
        leadSourceAgentId: string;
        data: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
      }
    > = (props) => {
      const { leadSourceAgentId, data } = props ?? {};

      return triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost(
        leadSourceAgentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
      >
    >
  >;
export type TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostMutationBody =
  TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
export type TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostMutationError =
  HTTPValidationError;

/**
 * @summary Trigger Run
 */
export const useTriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
          >
        >,
        TError,
        {
          leadSourceAgentId: string;
          data: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof triggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPost
      >
    >,
    TError,
    {
      leadSourceAgentId: string;
      data: TriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getTriggerRunApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List runs for a lead source agent.
 * @summary List Runs
 */
export const listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet = (
  leadSourceAgentId: string,
  params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceRunListResponse>({
    url: `/api/v1/pipeline/lead-source-agents/${leadSourceAgentId}/runs`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryKey =
  (
    leadSourceAgentId?: string,
    params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams
  ) => {
    return [
      `/api/v1/pipeline/lead-source-agents/${leadSourceAgentId}/runs`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
      >
    >,
    TError = HTTPValidationError
  >(
    leadSourceAgentId: string,
    params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryKey(
        leadSourceAgentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
        >
      >
    > = ({ signal }) =>
      listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet(
        leadSourceAgentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!leadSourceAgentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
      >
    >
  >;
export type ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryError =
  HTTPValidationError;

export function useListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
    >
  >,
  TError = HTTPValidationError
>(
  leadSourceAgentId: string,
  params:
    | undefined
    | ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
    >
  >,
  TError = HTTPValidationError
>(
  leadSourceAgentId: string,
  params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
    >
  >,
  TError = HTTPValidationError
>(
  leadSourceAgentId: string,
  params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Runs
 */

export function useListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
    >
  >,
  TError = HTTPValidationError
>(
  leadSourceAgentId: string,
  params?: ListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRunsApiV1PipelineLeadSourceAgentsLeadSourceAgentIdRunsGetQueryOptions(
      leadSourceAgentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a run with stats and its mode's phase graph in execution order.

``phases`` is what the run kanban lays its columns out by, and what it
resolves each column's active/complete state against. The order is
mode-specific (people-first runs ``contact_finding`` first), so hardcoding
the company-first sequence in the frontend rendered a people-first run
backwards *and* reported the wrong per-phase progress. Served here rather
than on the run list — the kanban loads exactly one run, so resolving the
agent's mode costs one row, not one per listed run.

``phase_roles`` is what the kanban describes each column WITH: a phase name
is mode-polymorphic, so name alone can't say whether ``contact_finding`` is
this run's batch sourcing phase (people-first) or a per-organization finding
phase (company-first) — and the copy keyed by name alone described the wrong
one. Same graph, so the two keys can't drift apart.
 * @summary Get Run
 */
export const getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet = (
  runId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeadSourceRunDetailResponse>({
    url: `/api/v1/pipeline/lead-source-agents/runs/${runId}`,
    method: 'GET',
    signal
  });
};

export const getGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryKey = (
  runId?: string
) => {
  return [`/api/v1/pipeline/lead-source-agents/runs/${runId}`] as const;
};

export const getGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryKey(runId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>>
  > = ({ signal }) =>
    getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet(runId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!runId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>>
  >;
export type GetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryError =
  HTTPValidationError;

export function useGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGet<
  TData = Awaited<
    ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGet<
  TData = Awaited<
    ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGet<
  TData = Awaited<
    ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Run
 */

export function useGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGet<
  TData = Awaited<
    ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRunApiV1PipelineLeadSourceAgentsRunsRunIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRunApiV1PipelineLeadSourceAgentsRunsRunIdGetQueryOptions(
      runId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cancel a running lead source run.
 * @summary Cancel Run
 */
export const cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost = (
  runId: string,
  signal?: AbortSignal
) => {
  return customInstance<CancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/cancel`,
      method: 'POST',
      signal
    }
  );
};

export const getCancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost
        >
      >,
      TError,
      { runId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost
      >
    >,
    TError,
    { runId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost
        >
      >,
      { runId: string }
    > = (props) => {
      const { runId } = props ?? {};

      return cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost(runId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost
      >
    >
  >;

export type CancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Run
 */
export const useCancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost
        >
      >,
      TError,
      { runId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof cancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPost>
  >,
  TError,
  { runId: string },
  TContext
> => {
  const mutationOptions =
    getCancelRunApiV1PipelineLeadSourceAgentsRunsRunIdCancelPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List items for a run, optionally filtered.
 * @summary List Run Items
 */
export const listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet = (
  runId: string,
  params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/items`,
      method: 'GET',
      params,
      signal
    }
  );
};

export const getListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryKey =
  (
    runId?: string,
    params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams
  ) => {
    return [
      `/api/v1/pipeline/lead-source-agents/runs/${runId}/items`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    runId: string,
    params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryKey(
        runId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
        >
      >
    > = ({ signal }) =>
      listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet(
        runId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!runId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
      >
    >
  >;
export type ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryError =
  HTTPValidationError;

export function useListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  params:
    | undefined
    | ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Run Items
 */

export function useListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRunItemsApiV1PipelineLeadSourceAgentsRunsRunIdItemsGetQueryOptions(
      runId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get items pending review for a run.
 * @summary Get Review Queue
 */
export const getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet = (
  runId: string,
  signal?: AbortSignal
) => {
  return customInstance<GetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/review`,
      method: 'GET',
      signal
    }
  );
};

export const getGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryKey =
  (runId?: string) => {
    return [
      `/api/v1/pipeline/lead-source-agents/runs/${runId}/review`
    ] as const;
  };

export const getGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    runId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryKey(
        runId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
        >
      >
    > = ({ signal }) =>
      getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet(
        runId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!runId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
      >
    >
  >;
export type GetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryError =
  HTTPValidationError;

export function useGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Queue
 */

export function useGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet<
  TData = Awaited<
    ReturnType<
      typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
    >
  >,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReviewQueueApiV1PipelineLeadSourceAgentsRunsRunIdReviewGetQueryOptions(
      runId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve or reject individual items in review.
 * @summary Review Items
 */
export const reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost = (
  runId: string,
  reviewBatchRequest: ReviewBatchRequest,
  signal?: AbortSignal
) => {
  return customInstance<ReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/review`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewBatchRequest,
      signal
    }
  );
};

export const getReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
        >
      >,
      TError,
      { runId: string; data: ReviewBatchRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
      >
    >,
    TError,
    { runId: string; data: ReviewBatchRequest },
    TContext
  > => {
    const mutationKey = [
      'reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
        >
      >,
      { runId: string; data: ReviewBatchRequest }
    > = (props) => {
      const { runId, data } = props ?? {};

      return reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost(
        runId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
      >
    >
  >;
export type ReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPostMutationBody =
  ReviewBatchRequest;
export type ReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Review Items
 */
export const useReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
        >
      >,
      TError,
      { runId: string; data: ReviewBatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof reviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPost
    >
  >,
  TError,
  { runId: string; data: ReviewBatchRequest },
  TContext
> => {
  const mutationOptions =
    getReviewItemsApiV1PipelineLeadSourceAgentsRunsRunIdReviewPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Approve all pending review items in a run.
 * @summary Approve All
 */
export const approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost = (
  runId: string,
  signal?: AbortSignal
) => {
  return customInstance<ApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/approve-all`,
      method: 'POST',
      signal
    }
  );
};

export const getApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
        >
      >,
      TError,
      { runId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
      >
    >,
    TError,
    { runId: string },
    TContext
  > => {
    const mutationKey = [
      'approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
        >
      >,
      { runId: string }
    > = (props) => {
      const { runId } = props ?? {};

      return approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost(
        runId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
      >
    >
  >;

export type ApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPostMutationError =
  HTTPValidationError;

/**
 * @summary Approve All
 */
export const useApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
          >
        >,
        TError,
        { runId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof approveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPost
      >
    >,
    TError,
    { runId: string },
    TContext
  > => {
    const mutationOptions =
      getApproveAllApiV1PipelineLeadSourceAgentsRunsRunIdApproveAllPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resume a paused run — a human review gate, or a prepaid-credit block.

Both pauses are recoverable, but they resume DIFFERENTLY. A review gate paused
a phase that had already finished its work, so execution continues at the next
phase. A ``paused_no_credits`` block aborted its phase mid-item, so that phase
is re-entered (``restart_at_phase``) and the contacts it never reached are
processed. The credit block additionally re-checks the wallet here so a resume
on a still-empty wallet fails fast with an actionable error rather than
re-pausing one vendor lookup later.
 * @summary Resume Run
 */
export const resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost = (
  runId: string,
  signal?: AbortSignal
) => {
  return customInstance<ResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost200>(
    {
      url: `/api/v1/pipeline/lead-source-agents/runs/${runId}/resume`,
      method: 'POST',
      signal
    }
  );
};

export const getResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost
        >
      >,
      TError,
      { runId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost
      >
    >,
    TError,
    { runId: string },
    TContext
  > => {
    const mutationKey = [
      'resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost
        >
      >,
      { runId: string }
    > = (props) => {
      const { runId } = props ?? {};

      return resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost(runId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost
      >
    >
  >;

export type ResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePostMutationError =
  HTTPValidationError;

/**
 * @summary Resume Run
 */
export const useResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost
        >
      >,
      TError,
      { runId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof resumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePost>
  >,
  TError,
  { runId: string },
  TContext
> => {
  const mutationOptions =
    getResumeRunApiV1PipelineLeadSourceAgentsRunsRunIdResumePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get default pipeline stages for a segment.

Defaults to the tenant's customer-type-derived preset (B2B vs B2C); pass
``?segment=`` to seed a specific segment's stages regardless of the tenant
default (used by the create dialogs' segment selector). Stage and preset
names are translated into ``language`` (the caller's UI language) so a
pipeline created from these defaults reads in the user's language.
 * @summary Get Pipeline Defaults
 */
export const getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet = (
  params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines/defaults`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryKey = (
  params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams
) => {
  return [
    `/api/v1/pipeline/pipelines/defaults`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
      >
    > = ({ signal }) =>
      getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
    >
  >;
export type GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryError =
  HTTPValidationError;

export function useGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline Defaults
 */

export function useGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineDefaultsApiV1PipelinePipelinesDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineDefaultsApiV1PipelinePipelinesDefaultsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all pipelines.
 * @summary List Pipelines
 */
export const listPipelinesApiV1PipelinePipelinesGet = (
  params?: ListPipelinesApiV1PipelinePipelinesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPipelinesApiV1PipelinePipelinesGetQueryKey = (
  params?: ListPipelinesApiV1PipelinePipelinesGetParams
) => {
  return [`/api/v1/pipeline/pipelines`, ...(params ? [params] : [])] as const;
};

export const getListPipelinesApiV1PipelinePipelinesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPipelinesApiV1PipelinePipelinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPipelinesApiV1PipelinePipelinesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>
  > = ({ signal }) => listPipelinesApiV1PipelinePipelinesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPipelinesApiV1PipelinePipelinesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>
>;
export type ListPipelinesApiV1PipelinePipelinesGetQueryError =
  HTTPValidationError;

export function useListPipelinesApiV1PipelinePipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListPipelinesApiV1PipelinePipelinesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPipelinesApiV1PipelinePipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPipelinesApiV1PipelinePipelinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPipelinesApiV1PipelinePipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPipelinesApiV1PipelinePipelinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Pipelines
 */

export function useListPipelinesApiV1PipelinePipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPipelinesApiV1PipelinePipelinesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1PipelinePipelinesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListPipelinesApiV1PipelinePipelinesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new pipeline with stages (admin).
 * @summary Create Pipeline
 */
export const createPipelineApiV1PipelinePipelinesPost = (
  pipelineCreate: PipelineCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: pipelineCreate,
    signal
  });
};

export const getCreatePipelineApiV1PipelinePipelinesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>,
    TError,
    { data: PipelineCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>,
  TError,
  { data: PipelineCreate },
  TContext
> => {
  const mutationKey = ['createPipelineApiV1PipelinePipelinesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>,
    { data: PipelineCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createPipelineApiV1PipelinePipelinesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePipelineApiV1PipelinePipelinesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>
  >;
export type CreatePipelineApiV1PipelinePipelinesPostMutationBody =
  PipelineCreate;
export type CreatePipelineApiV1PipelinePipelinesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Pipeline
 */
export const useCreatePipelineApiV1PipelinePipelinesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>,
      TError,
      { data: PipelineCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPipelineApiV1PipelinePipelinesPost>>,
  TError,
  { data: PipelineCreate },
  TContext
> => {
  const mutationOptions =
    getCreatePipelineApiV1PipelinePipelinesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a pipeline by ID.
 * @summary Get Pipeline
 */
export const getPipelineApiV1PipelinePipelinesPipelineIdGet = (
  pipelineId: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPipelineApiV1PipelinePipelinesPipelineIdGetQueryKey = (
  pipelineId?: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams
) => {
  return [
    `/api/v1/pipeline/pipelines/${pipelineId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetPipelineApiV1PipelinePipelinesPipelineIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPipelineApiV1PipelinePipelinesPipelineIdGetQueryKey(
      pipelineId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>>
  > = ({ signal }) =>
    getPipelineApiV1PipelinePipelinesPipelineIdGet(pipelineId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pipelineId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPipelineApiV1PipelinePipelinesPipelineIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>>
  >;
export type GetPipelineApiV1PipelinePipelinesPipelineIdGetQueryError =
  HTTPValidationError;

export function useGetPipelineApiV1PipelinePipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params: undefined | GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineApiV1PipelinePipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineApiV1PipelinePipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline
 */

export function useGetPipelineApiV1PipelinePipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: GetPipelineApiV1PipelinePipelinesPipelineIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1PipelinePipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineApiV1PipelinePipelinesPipelineIdGetQueryOptions(
      pipelineId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a pipeline (admin).
 * @summary Update Pipeline
 */
export const updatePipelineApiV1PipelinePipelinesPipelineIdPut = (
  pipelineId: string,
  pipelineUpdate: PipelineUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: pipelineUpdate
  });
};

export const getUpdatePipelineApiV1PipelinePipelinesPipelineIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>
      >,
      TError,
      { pipelineId: string; data: PipelineUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>
    >,
    TError,
    { pipelineId: string; data: PipelineUpdate },
    TContext
  > => {
    const mutationKey = ['updatePipelineApiV1PipelinePipelinesPipelineIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>
      >,
      { pipelineId: string; data: PipelineUpdate }
    > = (props) => {
      const { pipelineId, data } = props ?? {};

      return updatePipelineApiV1PipelinePipelinesPipelineIdPut(
        pipelineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePipelineApiV1PipelinePipelinesPipelineIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>
    >
  >;
export type UpdatePipelineApiV1PipelinePipelinesPipelineIdPutMutationBody =
  PipelineUpdate;
export type UpdatePipelineApiV1PipelinePipelinesPipelineIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Pipeline
 */
export const useUpdatePipelineApiV1PipelinePipelinesPipelineIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>
      >,
      TError,
      { pipelineId: string; data: PipelineUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePipelineApiV1PipelinePipelinesPipelineIdPut>>,
  TError,
  { pipelineId: string; data: PipelineUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdatePipelineApiV1PipelinePipelinesPipelineIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a pipeline (admin) — refused while live deals still sit on it.

The pipeline-level twin of the stage guard, and the same contract one level
up: an unconditional soft delete left every deal pointing at a
``pipeline_id`` no board resolves, so the deal survived with its kanban gone
and nothing on screen said where it went. Only the confirm dialog's own copy
ever admitted it ("All deals in this pipeline will need to be moved").

Unlike the stage guard this one is RECOVERABLE in the same request, because
the remedy is not a per-deal edit: a pipeline can hold hundreds of deals and
there is no bulk move-to-pipeline surface, so refusing outright would make
an occupied pipeline undeletable in practice. Naming ``move_deals_to``
re-homes them and deletes in the same transaction — two calls could fail
between them and leave the deals on a pipeline that no longer exists.

``pipeline_contact_status.routed_pipeline_id`` is deliberately untouched: it
is ``ON DELETE SET NULL`` and holds a routing PREFERENCE, not a record's
home, so losing it degrades a future lead's routing rather than stranding
anything that exists (WI c6402982).
 * @summary Delete Pipeline
 */
export const deletePipelineApiV1PipelinePipelinesPipelineIdDelete = (
  pipelineId: string,
  params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams
) => {
  return customInstance<void>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}`,
    method: 'DELETE',
    params
  });
};

export const getDeletePipelineApiV1PipelinePipelinesPipelineIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
      >,
      TError,
      {
        pipelineId: string;
        params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
    >,
    TError,
    {
      pipelineId: string;
      params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams;
    },
    TContext
  > => {
    const mutationKey = [
      'deletePipelineApiV1PipelinePipelinesPipelineIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
      >,
      {
        pipelineId: string;
        params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams;
      }
    > = (props) => {
      const { pipelineId, params } = props ?? {};

      return deletePipelineApiV1PipelinePipelinesPipelineIdDelete(
        pipelineId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
    >
  >;

export type DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Pipeline
 */
export const useDeletePipelineApiV1PipelinePipelinesPipelineIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
      >,
      TError,
      {
        pipelineId: string;
        params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deletePipelineApiV1PipelinePipelinesPipelineIdDelete>
  >,
  TError,
  {
    pipelineId: string;
    params?: DeletePipelineApiV1PipelinePipelinesPipelineIdDeleteParams;
  },
  TContext
> => {
  const mutationOptions =
    getDeletePipelineApiV1PipelinePipelinesPipelineIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a default pipeline with standard stages (admin).
 * @summary Create Default Pipeline
 */
export const createDefaultPipelineApiV1PipelinePipelinesDefaultPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines/default`,
    method: 'POST',
    signal
  });
};

export const getCreateDefaultPipelineApiV1PipelinePipelinesDefaultPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'createDefaultPipelineApiV1PipelinePipelinesDefaultPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost
        >
      >,
      void
    > = () => {
      return createDefaultPipelineApiV1PipelinePipelinesDefaultPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDefaultPipelineApiV1PipelinePipelinesDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost>
    >
  >;

export type CreateDefaultPipelineApiV1PipelinePipelinesDefaultPostMutationError =
  unknown;

/**
 * @summary Create Default Pipeline
 */
export const useCreateDefaultPipelineApiV1PipelinePipelinesDefaultPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createDefaultPipelineApiV1PipelinePipelinesDefaultPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateDefaultPipelineApiV1PipelinePipelinesDefaultPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Seed any missing default pipeline for the tenant's customer segments.

A tenant that serves both B2B and B2C should have one default pipeline per
segment. New tenants get these at creation; this endpoint backfills existing
tenants (e.g. after they add a customer type) and is idempotent — pipelines
whose name already exists are left untouched.
 * @summary Ensure Segment Default Pipelines
 */
export const ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/pipelines/ensure-segment-defaults`,
      method: 'POST',
      signal
    });
  };

export const getEnsureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
        >
      >,
      void
    > = () => {
      return ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnsureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
      >
    >
  >;

export type EnsureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPostMutationError =
  unknown;

/**
 * @summary Ensure Segment Default Pipelines
 */
export const useEnsureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof ensureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getEnsureSegmentDefaultPipelinesApiV1PipelinePipelinesEnsureSegmentDefaultsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List stages for a pipeline.

Reads stay open to any authenticated user — the kanban board, the deal
dialogs and the stage pickers all need the ladder. Only the WRITES below are
admin-only.
 * @summary List Stages
 */
export const listStagesApiV1PipelinePipelinesPipelineIdStagesGet = (
  pipelineId: string,
  params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<StageListResponse>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}/stages`,
    method: 'GET',
    params,
    signal
  });
};

export const getListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryKey = (
  pipelineId?: string,
  params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams
) => {
  return [
    `/api/v1/pipeline/pipelines/${pipelineId}/stages`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
    >,
    TError = HTTPValidationError
  >(
    pipelineId: string,
    params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryKey(
        pipelineId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
      >
    > = ({ signal }) =>
      listStagesApiV1PipelinePipelinesPipelineIdStagesGet(
        pipelineId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!pipelineId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
    >
  >;
export type ListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryError =
  HTTPValidationError;

export function useListStagesApiV1PipelinePipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params: undefined | ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStagesApiV1PipelinePipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStagesApiV1PipelinePipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stages
 */

export function useListStagesApiV1PipelinePipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  params?: ListStagesApiV1PipelinePipelinesPipelineIdStagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStagesApiV1PipelinePipelinesPipelineIdStagesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStagesApiV1PipelinePipelinesPipelineIdStagesGetQueryOptions(
      pipelineId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a stage to a deal pipeline (admin).

Admin-only for the same reason the lead funnel's rungs are: a pipeline's
ladder is workspace configuration, and changing it changes what every rep
can record and which automations fire.
 * @summary Create Stage
 */
export const createStageApiV1PipelinePipelinesPipelineIdStagesPost = (
  pipelineId: string,
  stageCreate: StageCreate,
  signal?: AbortSignal
) => {
  return customInstance<StageResponse>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}/stages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: stageCreate,
    signal
  });
};

export const getCreateStageApiV1PipelinePipelinesPipelineIdStagesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
      >,
      TError,
      { pipelineId: string; data: StageCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
    >,
    TError,
    { pipelineId: string; data: StageCreate },
    TContext
  > => {
    const mutationKey = [
      'createStageApiV1PipelinePipelinesPipelineIdStagesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
      >,
      { pipelineId: string; data: StageCreate }
    > = (props) => {
      const { pipelineId, data } = props ?? {};

      return createStageApiV1PipelinePipelinesPipelineIdStagesPost(
        pipelineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateStageApiV1PipelinePipelinesPipelineIdStagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
    >
  >;
export type CreateStageApiV1PipelinePipelinesPipelineIdStagesPostMutationBody =
  StageCreate;
export type CreateStageApiV1PipelinePipelinesPipelineIdStagesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Stage
 */
export const useCreateStageApiV1PipelinePipelinesPipelineIdStagesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
      >,
      TError,
      { pipelineId: string; data: StageCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createStageApiV1PipelinePipelinesPipelineIdStagesPost>
  >,
  TError,
  { pipelineId: string; data: StageCreate },
  TContext
> => {
  const mutationOptions =
    getCreateStageApiV1PipelinePipelinesPipelineIdStagesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a stage (admin). Partial: only the fields actually sent are applied.
 * @summary Update Stage
 */
export const updateStageApiV1PipelineStagesStageIdPut = (
  stageId: string,
  stageUpdate: StageUpdate
) => {
  return customInstance<StageResponse>({
    url: `/api/v1/pipeline/stages/${stageId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: stageUpdate
  });
};

export const getUpdateStageApiV1PipelineStagesStageIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>,
    TError,
    { stageId: string; data: StageUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>,
  TError,
  { stageId: string; data: StageUpdate },
  TContext
> => {
  const mutationKey = ['updateStageApiV1PipelineStagesStageIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>,
    { stageId: string; data: StageUpdate }
  > = (props) => {
    const { stageId, data } = props ?? {};

    return updateStageApiV1PipelineStagesStageIdPut(stageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStageApiV1PipelineStagesStageIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>
  >;
export type UpdateStageApiV1PipelineStagesStageIdPutMutationBody = StageUpdate;
export type UpdateStageApiV1PipelineStagesStageIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Stage
 */
export const useUpdateStageApiV1PipelineStagesStageIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>,
      TError,
      { stageId: string; data: StageUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateStageApiV1PipelineStagesStageIdPut>>,
  TError,
  { stageId: string; data: StageUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateStageApiV1PipelineStagesStageIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a stage (admin) — refused while live deals still sit on it.

An unconditional delete removed the kanban column while its deals kept
pointing at it, so they dropped off the board with nothing on screen saying
where they went. Same contract as the lead funnel's occupied-rung guard
(LEAD_MILESTONE_IN_USE): move the deals first, then delete.
 * @summary Delete Stage
 */
export const deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete = (
  pipelineId: string,
  stageId: string
) => {
  return customInstance<void>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}/stages/${stageId}`,
    method: 'DELETE'
  });
};

export const getDeleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
        >
      >,
      TError,
      { pipelineId: string; stageId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
      >
    >,
    TError,
    { pipelineId: string; stageId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
        >
      >,
      { pipelineId: string; stageId: string }
    > = (props) => {
      const { pipelineId, stageId } = props ?? {};

      return deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete(
        pipelineId,
        stageId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
      >
    >
  >;

export type DeleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Stage
 */
export const useDeleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
          >
        >,
        TError,
        { pipelineId: string; stageId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDelete
      >
    >,
    TError,
    { pipelineId: string; stageId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteStageApiV1PipelinePipelinesPipelineIdStagesStageIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Rewrite a pipeline's stage order from one ordered id list (admin).

The hand-rolled `stage_ids` presence/type checks this route used to open
with are gone: `StageReorder` is the same `minItems: 1` array declared once
in the schema, so a missing or empty list is a 422 naming the field instead
of two INVALID_REQUEST branches nothing else in the module spells.

Answers with the WHOLE reordered pipeline rather than the moved pair, so the
client can replace its cached ladder outright — the mirror of the lead
funnel's reorder.
 * @summary Reorder Stages
 */
export const reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost = (
  pipelineId: string,
  stageReorder: StageReorder,
  signal?: AbortSignal
) => {
  return customInstance<PipelineResponse>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}/stages/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: stageReorder,
    signal
  });
};

export const getReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
        >
      >,
      TError,
      { pipelineId: string; data: StageReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
      >
    >,
    TError,
    { pipelineId: string; data: StageReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
        >
      >,
      { pipelineId: string; data: StageReorder }
    > = (props) => {
      const { pipelineId, data } = props ?? {};

      return reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost(
        pipelineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
      >
    >
  >;
export type ReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPostMutationBody =
  StageReorder;
export type ReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPostMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Stages
 */
export const useReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
          >
        >,
        TError,
        { pipelineId: string; data: StageReorder },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPost
      >
    >,
    TError,
    { pipelineId: string; data: StageReorder },
    TContext
  > => {
    const mutationOptions =
      getReorderStagesApiV1PipelinePipelinesPipelineIdStagesReorderPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List gate criteria for a stage.
 * @summary List Stage Criteria
 */
export const listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet = (
  stageId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/stages/${stageId}/criteria`,
    method: 'GET',
    signal
  });
};

export const getListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryKey =
  (stageId?: string) => {
    return [`/api/v1/pipeline/stages/${stageId}/criteria`] as const;
  };

export const getListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
    >,
    TError = HTTPValidationError
  >(
    stageId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryKey(
        stageId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
        >
      >
    > = ({ signal }) =>
      listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet(stageId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!stageId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
    >
  >;
export type ListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryError =
  HTTPValidationError;

export function useListStageCriteriaApiV1PipelineStagesStageIdCriteriaGet<
  TData = Awaited<
    ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
  >,
  TError = HTTPValidationError
>(
  stageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStageCriteriaApiV1PipelineStagesStageIdCriteriaGet<
  TData = Awaited<
    ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
  >,
  TError = HTTPValidationError
>(
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStageCriteriaApiV1PipelineStagesStageIdCriteriaGet<
  TData = Awaited<
    ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
  >,
  TError = HTTPValidationError
>(
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stage Criteria
 */

export function useListStageCriteriaApiV1PipelineStagesStageIdCriteriaGet<
  TData = Awaited<
    ReturnType<typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet>
  >,
  TError = HTTPValidationError
>(
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStageCriteriaApiV1PipelineStagesStageIdCriteriaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStageCriteriaApiV1PipelineStagesStageIdCriteriaGetQueryOptions(
      stageId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new gate criterion for a stage (admin).

Admin-only exactly like the milestones' criteria: changing a stage's gate
changes what every rep must evidence before advancing a deal.
 * @summary Create Stage Criterion
 */
export const createStageCriterionApiV1PipelineStagesStageIdCriteriaPost = (
  stageId: string,
  stageCriterionCreate: StageCriterionCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/stages/${stageId}/criteria`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: stageCriterionCreate,
    signal
  });
};

export const getCreateStageCriterionApiV1PipelineStagesStageIdCriteriaPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
        >
      >,
      TError,
      { stageId: string; data: StageCriterionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
      >
    >,
    TError,
    { stageId: string; data: StageCriterionCreate },
    TContext
  > => {
    const mutationKey = [
      'createStageCriterionApiV1PipelineStagesStageIdCriteriaPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
        >
      >,
      { stageId: string; data: StageCriterionCreate }
    > = (props) => {
      const { stageId, data } = props ?? {};

      return createStageCriterionApiV1PipelineStagesStageIdCriteriaPost(
        stageId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateStageCriterionApiV1PipelineStagesStageIdCriteriaPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
      >
    >
  >;
export type CreateStageCriterionApiV1PipelineStagesStageIdCriteriaPostMutationBody =
  StageCriterionCreate;
export type CreateStageCriterionApiV1PipelineStagesStageIdCriteriaPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Stage Criterion
 */
export const useCreateStageCriterionApiV1PipelineStagesStageIdCriteriaPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
        >
      >,
      TError,
      { stageId: string; data: StageCriterionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createStageCriterionApiV1PipelineStagesStageIdCriteriaPost
    >
  >,
  TError,
  { stageId: string; data: StageCriterionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateStageCriterionApiV1PipelineStagesStageIdCriteriaPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a gate criterion (admin).
 * @summary Update Stage Criterion
 */
export const updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut =
  (
    stageId: string,
    criterionId: string,
    stageCriterionUpdate: StageCriterionUpdate
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/stages/${stageId}/criteria/${criterionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: stageCriterionUpdate
    });
  };

export const getUpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
        >
      >,
      TError,
      { stageId: string; criterionId: string; data: StageCriterionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
      >
    >,
    TError,
    { stageId: string; criterionId: string; data: StageCriterionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
        >
      >,
      { stageId: string; criterionId: string; data: StageCriterionUpdate }
    > = (props) => {
      const { stageId, criterionId, data } = props ?? {};

      return updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut(
        stageId,
        criterionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
      >
    >
  >;
export type UpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPutMutationBody =
  StageCriterionUpdate;
export type UpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Stage Criterion
 */
export const useUpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
          >
        >,
        TError,
        { stageId: string; criterionId: string; data: StageCriterionUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPut
      >
    >,
    TError,
    { stageId: string; criterionId: string; data: StageCriterionUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a gate criterion (admin).
 * @summary Delete Stage Criterion
 */
export const deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete =
  (stageId: string, criterionId: string) => {
    return customInstance<void>({
      url: `/api/v1/pipeline/stages/${stageId}/criteria/${criterionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
        >
      >,
      TError,
      { stageId: string; criterionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
      >
    >,
    TError,
    { stageId: string; criterionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
        >
      >,
      { stageId: string; criterionId: string }
    > = (props) => {
      const { stageId, criterionId } = props ?? {};

      return deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete(
        stageId,
        criterionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
      >
    >
  >;

export type DeleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Stage Criterion
 */
export const useDeleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
          >
        >,
        TError,
        { stageId: string; criterionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDelete
      >
    >,
    TError,
    { stageId: string; criterionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteStageCriterionApiV1PipelineStagesStageIdCriteriaCriterionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reorder criteria within a stage (admin).
 * @summary Reorder Stage Criteria
 */
export const reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost =
  (
    stageId: string,
    stageCriteriaReorder: StageCriteriaReorder,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/stages/${stageId}/criteria/reorder`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: stageCriteriaReorder,
      signal
    });
  };

export const getReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
        >
      >,
      TError,
      { stageId: string; data: StageCriteriaReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
      >
    >,
    TError,
    { stageId: string; data: StageCriteriaReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
        >
      >,
      { stageId: string; data: StageCriteriaReorder }
    > = (props) => {
      const { stageId, data } = props ?? {};

      return reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost(
        stageId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
      >
    >
  >;
export type ReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPostMutationBody =
  StageCriteriaReorder;
export type ReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPostMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Stage Criteria
 */
export const useReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
          >
        >,
        TError,
        { stageId: string; data: StageCriteriaReorder },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPost
      >
    >,
    TError,
    { stageId: string; data: StageCriteriaReorder },
    TContext
  > => {
    const mutationOptions =
      getReorderStageCriteriaApiV1PipelineStagesStageIdCriteriaReorderPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get criteria completion status for a deal.
 * @summary Get Deal Criteria Status
 */
export const getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet = (
  dealId: string,
  params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/criteria-status`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryKey =
  (
    dealId?: string,
    params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams
  ) => {
    return [
      `/api/v1/pipeline/deals/${dealId}/criteria-status`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
      >
    >,
    TError = HTTPValidationError
  >(
    dealId: string,
    params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryKey(
        dealId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
        >
      >
    > = ({ signal }) =>
      getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet(
        dealId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dealId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
      >
    >
  >;
export type GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryError =
  HTTPValidationError;

export function useGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params:
    | undefined
    | GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Deal Criteria Status
 */

export function useGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDealCriteriaStatusApiV1PipelineDealsDealIdCriteriaStatusGetQueryOptions(
      dealId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update criterion completions for a deal.
 * @summary Update Deal Criteria Completions
 */
export const updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost =
  (
    dealId: string,
    dealCriteriaCompletionsUpdate: DealCriteriaCompletionsUpdate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/deals/${dealId}/criteria-completions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dealCriteriaCompletionsUpdate,
      signal
    });
  };

export const getUpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
        >
      >,
      TError,
      { dealId: string; data: DealCriteriaCompletionsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
      >
    >,
    TError,
    { dealId: string; data: DealCriteriaCompletionsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
        >
      >,
      { dealId: string; data: DealCriteriaCompletionsUpdate }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost(
        dealId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
      >
    >
  >;
export type UpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPostMutationBody =
  DealCriteriaCompletionsUpdate;
export type UpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Update Deal Criteria Completions
 */
export const useUpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
          >
        >,
        TError,
        { dealId: string; data: DealCriteriaCompletionsUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPost
      >
    >,
    TError,
    { dealId: string; data: DealCriteriaCompletionsUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDealCriteriaCompletionsApiV1PipelineDealsDealIdCriteriaCompletionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Advance a deal to the next stage, with optional criteria completions.

Request body (optional):
{
    "target_stage_id": "uuid",  // optional, defaults to next stage by position
    "completions": [            // optional, criteria completion updates
        {"criterion_id": "uuid", "completed": true, "attachment_id": "uuid"}
    ]
}
 * @summary Advance Deal
 */
export const advanceDealApiV1PipelineDealsDealIdAdvancePost = (
  dealId: string,
  advanceDealApiV1PipelineDealsDealIdAdvancePostBody: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/advance`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: advanceDealApiV1PipelineDealsDealIdAdvancePostBody,
    signal
  });
};

export const getAdvanceDealApiV1PipelineDealsDealIdAdvancePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>
      >,
      TError,
      {
        dealId: string;
        data: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>>,
    TError,
    {
      dealId: string;
      data: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody;
    },
    TContext
  > => {
    const mutationKey = ['advanceDealApiV1PipelineDealsDealIdAdvancePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>
      >,
      {
        dealId: string;
        data: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody;
      }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return advanceDealApiV1PipelineDealsDealIdAdvancePost(dealId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdvanceDealApiV1PipelineDealsDealIdAdvancePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>>
  >;
export type AdvanceDealApiV1PipelineDealsDealIdAdvancePostMutationBody =
  AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody;
export type AdvanceDealApiV1PipelineDealsDealIdAdvancePostMutationError =
  HTTPValidationError;

/**
 * @summary Advance Deal
 */
export const useAdvanceDealApiV1PipelineDealsDealIdAdvancePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>
      >,
      TError,
      {
        dealId: string;
        data: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof advanceDealApiV1PipelineDealsDealIdAdvancePost>>,
  TError,
  { dealId: string; data: AdvanceDealApiV1PipelineDealsDealIdAdvancePostBody },
  TContext
> => {
  const mutationOptions =
    getAdvanceDealApiV1PipelineDealsDealIdAdvancePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List companies with optional filtering.
 * @summary List Organizations
 */
export const listOrganizationsApiV1PipelineOrganizationsGet = (
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/organizations`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOrganizationsApiV1PipelineOrganizationsGetQueryKey = (
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams
) => {
  return [
    `/api/v1/pipeline/organizations`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListOrganizationsApiV1PipelineOrganizationsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationsApiV1PipelineOrganizationsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>>
  > = ({ signal }) =>
    listOrganizationsApiV1PipelineOrganizationsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListOrganizationsApiV1PipelineOrganizationsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>>
  >;
export type ListOrganizationsApiV1PipelineOrganizationsGetQueryError =
  HTTPValidationError;

export function useListOrganizationsApiV1PipelineOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListOrganizationsApiV1PipelineOrganizationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOrganizationsApiV1PipelineOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOrganizationsApiV1PipelineOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Organizations
 */

export function useListOrganizationsApiV1PipelineOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1PipelineOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listOrganizationsApiV1PipelineOrganizationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOrganizationsApiV1PipelineOrganizationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated — use POST /master-data/contacts/organizations.

Not byte-compatible: it validates an untyped body against the generated
``OrganizationCreate`` schema, whose field set has drifted from master_data's
request model (this one carries ``annual_revenue_range`` and lacks
``address*`` / ``tier_id``), and the master_data twin additionally returns
``tags`` and the tier. What it does that master_data does not is write the
caller's ``contacts_organization_visibility`` row (source ``creator``), which
is what puts the row in this module's "My Companies" list.

The VALIDATION is the same on both doors (WI 243021fa, WI 29639d14) — one
implementation in ``services/write_validation.py``, the same tiered dedup,
the same ``normalize_domain`` on the derived identity key, the same class-id
and custom-field validation, the same ``validate_company_ids_or_raise`` on
the multi-company tag, the same admin gate and 1:1 check on the intercompany
identity link, and the same post-commit ``organization_changed`` event that
lets trade-compliance screen the row.
 * @deprecated
 * @summary Create Organization
 */
export const createOrganizationApiV1PipelineOrganizationsPost = (
  createOrganizationApiV1PipelineOrganizationsPostBody: CreateOrganizationApiV1PipelineOrganizationsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/organizations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOrganizationApiV1PipelineOrganizationsPostBody,
    signal
  });
};

export const getCreateOrganizationApiV1PipelineOrganizationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>
      >,
      TError,
      { data: CreateOrganizationApiV1PipelineOrganizationsPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>
    >,
    TError,
    { data: CreateOrganizationApiV1PipelineOrganizationsPostBody },
    TContext
  > => {
    const mutationKey = ['createOrganizationApiV1PipelineOrganizationsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>
      >,
      { data: CreateOrganizationApiV1PipelineOrganizationsPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createOrganizationApiV1PipelineOrganizationsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateOrganizationApiV1PipelineOrganizationsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>>
  >;
export type CreateOrganizationApiV1PipelineOrganizationsPostMutationBody =
  CreateOrganizationApiV1PipelineOrganizationsPostBody;
export type CreateOrganizationApiV1PipelineOrganizationsPostMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Create Organization
 */
export const useCreateOrganizationApiV1PipelineOrganizationsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>
      >,
      TError,
      { data: CreateOrganizationApiV1PipelineOrganizationsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganizationApiV1PipelineOrganizationsPost>>,
  TError,
  { data: CreateOrganizationApiV1PipelineOrganizationsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateOrganizationApiV1PipelineOrganizationsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deprecated — use GET /master-data/contacts/organizations/industries.

Same rows, same tenant scope; master_data owns ``contacts_organizations``.
 * @deprecated
 * @summary List Industries
 */
export const listIndustriesApiV1PipelineOrganizationsIndustriesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/organizations/industries`,
    method: 'GET',
    signal
  });
};

export const getListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryKey =
  () => {
    return [`/api/v1/pipeline/organizations/industries`] as const;
  };

export const getListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
      >
    > = ({ signal }) =>
      listIndustriesApiV1PipelineOrganizationsIndustriesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
    >
  >;
export type ListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryError =
  unknown;

export function useListIndustriesApiV1PipelineOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListIndustriesApiV1PipelineOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListIndustriesApiV1PipelineOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary List Industries
 */

export function useListIndustriesApiV1PipelineOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1PipelineOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListIndustriesApiV1PipelineOrganizationsIndustriesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated — use GET /master-data/contacts/organizations/{organization_id}.

Same row, same Contract-D gate and the same ``include_contacts`` redaction.
The master_data twin is a strict superset: it also returns ``tags``,
``class_ids`` and the relationship pins this route omits.
 * @deprecated
 * @summary Get Organization
 */
export const getOrganizationApiV1PipelineOrganizationsOrganizationIdGet = (
  organizationId: string,
  params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/organizations/${organizationId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryKey =
  (
    organizationId?: string,
    params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams
  ) => {
    return [
      `/api/v1/pipeline/organizations/${organizationId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryKey(
        organizationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
        >
      >
    > = ({ signal }) =>
      getOrganizationApiV1PipelineOrganizationsOrganizationIdGet(
        organizationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
      >
    >
  >;
export type GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryError =
  HTTPValidationError;

export function useGetOrganizationApiV1PipelineOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params:
    | undefined
    | GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationApiV1PipelineOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationApiV1PipelineOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary Get Organization
 */

export function useGetOrganizationApiV1PipelineOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1PipelineOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1PipelineOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOrganizationApiV1PipelineOrganizationsOrganizationIdGetQueryOptions(
      organizationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated — use PUT /master-data/contacts/organizations/{organization_id}.

The Contract-D gate is identical (EDITOR, and OWNER when ``owner_id``
changes), and since WI 243021fa / WI 29639d14 so is the validation: the same
``normalize_domain`` on the derived identity key, the same tiered dedup, the
same class-membership and custom-field validation, the same
``validate_company_ids_or_raise`` on the multi-company tag, the same admin
gate and 1:1 check on the intercompany identity link, and the same
``organization_changed`` event. The master_data twin still returns more
(``tags``, the tier); this one writes the "My Companies" visibility row.
 * @deprecated
 * @summary Update Organization
 */
export const updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut = (
  organizationId: string,
  updateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/organizations/${organizationId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody
  });
};

export const getUpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
        >
      >,
      TError,
      {
        organizationId: string;
        data: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
      >
    >,
    TError,
    {
      organizationId: string;
      data: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
        >
      >,
      {
        organizationId: string;
        data: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
      }
    > = (props) => {
      const { organizationId, data } = props ?? {};

      return updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut(
        organizationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
      >
    >
  >;
export type UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutMutationBody =
  UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
export type UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Update Organization
 */
export const useUpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
          >
        >,
        TError,
        {
          organizationId: string;
          data: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1PipelineOrganizationsOrganizationIdPut
      >
    >,
    TError,
    {
      organizationId: string;
      data: UpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateOrganizationApiV1PipelineOrganizationsOrganizationIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deprecated — use DELETE /master-data/contacts/organizations/{organization_id}.

Behaviourally identical at the database level since WI 2c5ce62d wired the
referential guard below: same EDITOR gate, same ``enforce_deletable``
refusal, same soft delete. Only the envelope differs — this route answers
204 with no body where master_data answers 200 ``{"success": true}``.
 * @deprecated
 * @summary Delete Organization
 */
export const deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete =
  (organizationId: string) => {
    return customInstance<void>({
      url: `/api/v1/pipeline/organizations/${organizationId}`,
      method: 'DELETE'
    });
  };

export const getDeleteOrganizationApiV1PipelineOrganizationsOrganizationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteOrganizationApiV1PipelineOrganizationsOrganizationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
      >
    >
  >;

export type DeleteOrganizationApiV1PipelineOrganizationsOrganizationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Delete Organization
 */
export const useDeleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1PipelineOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteOrganizationApiV1PipelineOrganizationsOrganizationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Claim a company to add it to My Companies.
 * @summary Claim Organization
 */
export const claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/organizations/${organizationId}/claim`,
      method: 'POST',
      signal
    });
  };

export const getClaimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClaimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
      >
    >
  >;

export type ClaimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPostMutationError =
  HTTPValidationError;

/**
 * @summary Claim Organization
 */
export const useClaimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof claimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getClaimOrganizationApiV1PipelineOrganizationsOrganizationIdClaimPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Archive a company.

If other users have visibility, this just removes the company from My Companies.
If no other users have visibility, the company is actually archived.
 * @summary Archive Organization
 */
export const archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/organizations/${organizationId}/archive`,
      method: 'POST',
      signal
    });
  };

export const getArchiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
      >
    >
  >;

export type ArchiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Organization
 */
export const useArchiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getArchiveOrganizationApiV1PipelineOrganizationsOrganizationIdArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unarchive a company and claim it for the current user.
 * @summary Unarchive Organization
 */
export const unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/organizations/${organizationId}/unarchive`,
      method: 'POST',
      signal
    });
  };

export const getUnarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
      >
    >
  >;

export type UnarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive Organization
 */
export const useUnarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getUnarchiveOrganizationApiV1PipelineOrganizationsOrganizationIdUnarchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List contacts with optional filtering.
 * @summary List Contacts
 */
export const listContactsApiV1PipelineContactsGet = (
  params?: ListContactsApiV1PipelineContactsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts`,
    method: 'GET',
    params,
    signal
  });
};

export const getListContactsApiV1PipelineContactsGetQueryKey = (
  params?: ListContactsApiV1PipelineContactsGetParams
) => {
  return [`/api/v1/pipeline/contacts`, ...(params ? [params] : [])] as const;
};

export const getListContactsApiV1PipelineContactsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1PipelineContactsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListContactsApiV1PipelineContactsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>
  > = ({ signal }) => listContactsApiV1PipelineContactsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListContactsApiV1PipelineContactsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>
>;
export type ListContactsApiV1PipelineContactsGetQueryError =
  HTTPValidationError;

export function useListContactsApiV1PipelineContactsGet<
  TData = Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListContactsApiV1PipelineContactsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
          TError,
          Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContactsApiV1PipelineContactsGet<
  TData = Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1PipelineContactsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
          TError,
          Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContactsApiV1PipelineContactsGet<
  TData = Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1PipelineContactsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Contacts
 */

export function useListContactsApiV1PipelineContactsGet<
  TData = Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1PipelineContactsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsApiV1PipelineContactsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListContactsApiV1PipelineContactsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated — use POST /master-data/contacts/people.

Both doors share the ``ContactService.create_contact`` chokepoint, so the
owner grant, the agent auto-share and the lead-funnel opening are identical,
and since WI 243021fa so is the validation listed here: the same name guard,
the same URL-scheme check, the same tiered (case-insensitive) email dedup and
the same class-id and custom-field validation, from one implementation in
``services/write_validation.py``. What this one adds is the caller's
``contacts_contact_visibility`` row (source ``creator``), which is what puts
the row in this module's "My Contacts"; the master_data twin returns more
(``tags``, the relationship pins, the portal state).

``company_ids`` goes through the twin's ``validate_company_ids_or_raise``
too, since WI 29639d14.
 * @deprecated
 * @summary Create Contact
 */
export const createContactApiV1PipelineContactsPost = (
  createContactApiV1PipelineContactsPostBody: CreateContactApiV1PipelineContactsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createContactApiV1PipelineContactsPostBody,
    signal
  });
};

export const getCreateContactApiV1PipelineContactsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>,
    TError,
    { data: CreateContactApiV1PipelineContactsPostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>,
  TError,
  { data: CreateContactApiV1PipelineContactsPostBody },
  TContext
> => {
  const mutationKey = ['createContactApiV1PipelineContactsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>,
    { data: CreateContactApiV1PipelineContactsPostBody }
  > = (props) => {
    const { data } = props ?? {};

    return createContactApiV1PipelineContactsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContactApiV1PipelineContactsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>
>;
export type CreateContactApiV1PipelineContactsPostMutationBody =
  CreateContactApiV1PipelineContactsPostBody;
export type CreateContactApiV1PipelineContactsPostMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Create Contact
 */
export const useCreateContactApiV1PipelineContactsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>,
      TError,
      { data: CreateContactApiV1PipelineContactsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createContactApiV1PipelineContactsPost>>,
  TError,
  { data: CreateContactApiV1PipelineContactsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateContactApiV1PipelineContactsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deprecated — use GET /master-data/contacts/people/{contact_id}.

Same row, same Contract-D gate and the same ``include_company`` redaction.
The master_data twin is a strict superset: it also returns ``tags``,
``class_ids``, the relationship pins and the portal-user state.
 * @deprecated
 * @summary Get Contact
 */
export const getContactApiV1PipelineContactsContactIdGet = (
  contactId: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts/${contactId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetContactApiV1PipelineContactsContactIdGetQueryKey = (
  contactId?: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams
) => {
  return [
    `/api/v1/pipeline/contacts/${contactId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetContactApiV1PipelineContactsContactIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetContactApiV1PipelineContactsContactIdGetQueryKey(contactId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>
  > = ({ signal }) =>
    getContactApiV1PipelineContactsContactIdGet(contactId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetContactApiV1PipelineContactsContactIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>
  >;
export type GetContactApiV1PipelineContactsContactIdGetQueryError =
  HTTPValidationError;

export function useGetContactApiV1PipelineContactsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: undefined | GetContactApiV1PipelineContactsContactIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactApiV1PipelineContactsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactApiV1PipelineContactsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary Get Contact
 */

export function useGetContactApiV1PipelineContactsContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1PipelineContactsContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactApiV1PipelineContactsContactIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactApiV1PipelineContactsContactIdGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated — use PUT /master-data/contacts/people/{contact_id}.

The Contract-D gate is identical (EDITOR, and OWNER when ``owner_id``
changes) and both doors go through ``ContactService.update_contact``, so the
lead-rung preservation is the same. Since WI 243021fa the validation listed
here matches too: the same URL check, the same post-update name guard, the
same tiered email dedup, the same class-membership and custom-field
validation, and — since WI 29639d14 — the same
``validate_company_ids_or_raise`` on the multi-company tag.
 * @deprecated
 * @summary Update Contact
 */
export const updateContactApiV1PipelineContactsContactIdPut = (
  contactId: string,
  updateContactApiV1PipelineContactsContactIdPutBody: UpdateContactApiV1PipelineContactsContactIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateContactApiV1PipelineContactsContactIdPutBody
  });
};

export const getUpdateContactApiV1PipelineContactsContactIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>
      >,
      TError,
      {
        contactId: string;
        data: UpdateContactApiV1PipelineContactsContactIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>>,
    TError,
    {
      contactId: string;
      data: UpdateContactApiV1PipelineContactsContactIdPutBody;
    },
    TContext
  > => {
    const mutationKey = ['updateContactApiV1PipelineContactsContactIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>
      >,
      {
        contactId: string;
        data: UpdateContactApiV1PipelineContactsContactIdPutBody;
      }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return updateContactApiV1PipelineContactsContactIdPut(contactId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateContactApiV1PipelineContactsContactIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>>
  >;
export type UpdateContactApiV1PipelineContactsContactIdPutMutationBody =
  UpdateContactApiV1PipelineContactsContactIdPutBody;
export type UpdateContactApiV1PipelineContactsContactIdPutMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Update Contact
 */
export const useUpdateContactApiV1PipelineContactsContactIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>
      >,
      TError,
      {
        contactId: string;
        data: UpdateContactApiV1PipelineContactsContactIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateContactApiV1PipelineContactsContactIdPut>>,
  TError,
  {
    contactId: string;
    data: UpdateContactApiV1PipelineContactsContactIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateContactApiV1PipelineContactsContactIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deprecated — use DELETE /master-data/contacts/people/{contact_id}.

Behaviourally identical at the database level since WI 2c5ce62d wired the
referential guard below: same EDITOR gate, same ``enforce_deletable``
refusal, same soft delete. Only the envelope differs — this route answers
204 with no body where master_data answers 200 ``{"success": true}``.
 * @deprecated
 * @summary Delete Contact
 */
export const deleteContactApiV1PipelineContactsContactIdDelete = (
  contactId: string
) => {
  return customInstance<void>({
    url: `/api/v1/pipeline/contacts/${contactId}`,
    method: 'DELETE'
  });
};

export const getDeleteContactApiV1PipelineContactsContactIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = ['deleteContactApiV1PipelineContactsContactIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return deleteContactApiV1PipelineContactsContactIdDelete(contactId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteContactApiV1PipelineContactsContactIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>
    >
  >;

export type DeleteContactApiV1PipelineContactsContactIdDeleteMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Delete Contact
 */
export const useDeleteContactApiV1PipelineContactsContactIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactApiV1PipelineContactsContactIdDelete>>,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteContactApiV1PipelineContactsContactIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Claim a contact to add it to My Contacts.
 * @summary Claim Contact
 */
export const claimContactApiV1PipelineContactsContactIdClaimPost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts/${contactId}/claim`,
    method: 'POST',
    signal
  });
};

export const getClaimContactApiV1PipelineContactsContactIdClaimPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = ['claimContactApiV1PipelineContactsContactIdClaimPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return claimContactApiV1PipelineContactsContactIdClaimPost(contactId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClaimContactApiV1PipelineContactsContactIdClaimPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
    >
  >;

export type ClaimContactApiV1PipelineContactsContactIdClaimPostMutationError =
  HTTPValidationError;

/**
 * @summary Claim Contact
 */
export const useClaimContactApiV1PipelineContactsContactIdClaimPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof claimContactApiV1PipelineContactsContactIdClaimPost>
  >,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getClaimContactApiV1PipelineContactsContactIdClaimPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Archive a contact.

If other users have visibility, this just removes the contact from My Contacts.
If no other users have visibility, the contact is actually archived.
 * @summary Archive Contact
 */
export const archiveContactApiV1PipelineContactsContactIdArchivePost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts/${contactId}/archive`,
    method: 'POST',
    signal
  });
};

export const getArchiveContactApiV1PipelineContactsContactIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveContactApiV1PipelineContactsContactIdArchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof archiveContactApiV1PipelineContactsContactIdArchivePost>
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveContactApiV1PipelineContactsContactIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveContactApiV1PipelineContactsContactIdArchivePost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return archiveContactApiV1PipelineContactsContactIdArchivePost(contactId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveContactApiV1PipelineContactsContactIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof archiveContactApiV1PipelineContactsContactIdArchivePost>
    >
  >;

export type ArchiveContactApiV1PipelineContactsContactIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Contact
 */
export const useArchiveContactApiV1PipelineContactsContactIdArchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveContactApiV1PipelineContactsContactIdArchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof archiveContactApiV1PipelineContactsContactIdArchivePost>
  >,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getArchiveContactApiV1PipelineContactsContactIdArchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unarchive a contact and claim it for the current user.
 * @summary Unarchive Contact
 */
export const unarchiveContactApiV1PipelineContactsContactIdUnarchivePost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/contacts/${contactId}/unarchive`,
    method: 'POST',
    signal
  });
};

export const getUnarchiveContactApiV1PipelineContactsContactIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'unarchiveContactApiV1PipelineContactsContactIdUnarchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return unarchiveContactApiV1PipelineContactsContactIdUnarchivePost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveContactApiV1PipelineContactsContactIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
      >
    >
  >;

export type UnarchiveContactApiV1PipelineContactsContactIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive Contact
 */
export const useUnarchiveContactApiV1PipelineContactsContactIdUnarchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof unarchiveContactApiV1PipelineContactsContactIdUnarchivePost
    >
  >,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getUnarchiveContactApiV1PipelineContactsContactIdUnarchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get every deal this contact is on — both as a participant and as the credited partner.

Returns the UNION of the two ways a contact reaches a deal, and labels each row
with the arm(s) it matched:

- `is_customer_party` — the contact is a participant on the deal itself.
- `is_credited_party` — the contact is the party credited with introducing the
  deal (the architect, distributor or affiliate behind it).

Both flags are true where the same person is the customer-side contact AND the
credited partner; at least one is always true. This is the same set, and the same
two labels, the contact's own Deals tab shows.
 * @summary Get Contact Deals
 */
export const getContactDealsApiV1PipelineContactsContactIdDealsGet = (
  contactId: string,
  params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DealCollectionResponse>({
    url: `/api/v1/pipeline/contacts/${contactId}/deals`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetContactDealsApiV1PipelineContactsContactIdDealsGetQueryKey =
  (
    contactId?: string,
    params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams
  ) => {
    return [
      `/api/v1/pipeline/contacts/${contactId}/deals`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetContactDealsApiV1PipelineContactsContactIdDealsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactDealsApiV1PipelineContactsContactIdDealsGetQueryKey(
        contactId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
      >
    > = ({ signal }) =>
      getContactDealsApiV1PipelineContactsContactIdDealsGet(
        contactId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactDealsApiV1PipelineContactsContactIdDealsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
    >
  >;
export type GetContactDealsApiV1PipelineContactsContactIdDealsGetQueryError =
  HTTPValidationError;

export function useGetContactDealsApiV1PipelineContactsContactIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params:
    | undefined
    | GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactDealsApiV1PipelineContactsContactIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactDealsApiV1PipelineContactsContactIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contact Deals
 */

export function useGetContactDealsApiV1PipelineContactsContactIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getContactDealsApiV1PipelineContactsContactIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactDealsApiV1PipelineContactsContactIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDealsApiV1PipelineContactsContactIdDealsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactDealsApiV1PipelineContactsContactIdDealsGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List deals visible to the caller. IMPORTANT: Depending on the tenant's deal visibility setting, results may be filtered by permissions — only returning deals the caller owns or that have been shared with them. Check the 'access_limited' field in the response to know if filtering is active. When active, always inform the user that this is NOT a complete list and there may be additional deals they don't have access to.
 * @summary List Deals
 */
export const listDealsApiV1PipelineDealsGet = (
  params?: ListDealsApiV1PipelineDealsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DealListResponse>({
    url: `/api/v1/pipeline/deals`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDealsApiV1PipelineDealsGetQueryKey = (
  params?: ListDealsApiV1PipelineDealsGetParams
) => {
  return [`/api/v1/pipeline/deals`, ...(params ? [params] : [])] as const;
};

export const getListDealsApiV1PipelineDealsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
  TError = HTTPValidationError
>(
  params?: ListDealsApiV1PipelineDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDealsApiV1PipelineDealsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>
  > = ({ signal }) => listDealsApiV1PipelineDealsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDealsApiV1PipelineDealsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>
>;
export type ListDealsApiV1PipelineDealsGetQueryError = HTTPValidationError;

export function useListDealsApiV1PipelineDealsGet<
  TData = Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListDealsApiV1PipelineDealsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
          TError,
          Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDealsApiV1PipelineDealsGet<
  TData = Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
  TError = HTTPValidationError
>(
  params?: ListDealsApiV1PipelineDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
          TError,
          Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDealsApiV1PipelineDealsGet<
  TData = Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
  TError = HTTPValidationError
>(
  params?: ListDealsApiV1PipelineDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Deals
 */

export function useListDealsApiV1PipelineDealsGet<
  TData = Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
  TError = HTTPValidationError
>(
  params?: ListDealsApiV1PipelineDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDealsApiV1PipelineDealsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListDealsApiV1PipelineDealsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new deal. Creator becomes the owner.
 * @summary Create Deal
 */
export const createDealApiV1PipelineDealsPost = (
  dealCreate: DealCreate,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dealCreate,
    signal
  });
};

export const getCreateDealApiV1PipelineDealsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>,
    TError,
    { data: DealCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>,
  TError,
  { data: DealCreate },
  TContext
> => {
  const mutationKey = ['createDealApiV1PipelineDealsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>,
    { data: DealCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createDealApiV1PipelineDealsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDealApiV1PipelineDealsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>
>;
export type CreateDealApiV1PipelineDealsPostMutationBody = DealCreate;
export type CreateDealApiV1PipelineDealsPostMutationError = HTTPValidationError;

/**
 * @summary Create Deal
 */
export const useCreateDealApiV1PipelineDealsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>,
      TError,
      { data: DealCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDealApiV1PipelineDealsPost>>,
  TError,
  { data: DealCreate },
  TContext
> => {
  const mutationOptions =
    getCreateDealApiV1PipelineDealsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deal-value figures over the **whole filtered deal set**, never one page.

ui-list-pages.md §11 (aggregates on a server-paged list): this endpoint takes
the identical filter query params as ``GET /deals`` minus `offset`/`limit`/the
sort, and resolves them through the same repository query builder — so the
totals above a paged pipeline table can never honour a different filter set,
or a weaker permission scope, than the rows in it. A per-page deal-value total
on a sales pipeline is a wrong number in front of the people forecasting on it.

Grouped by `currency_code` — a deal carries its own currency, so one
cross-currency SUM would be meaningless.
 * @summary Get Deal Aggregates
 */
export const getDealAggregatesApiV1PipelineDealsAggregatesGet = (
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DealAggregatesResponse>({
    url: `/api/v1/pipeline/deals/aggregates`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDealAggregatesApiV1PipelineDealsAggregatesGetQueryKey = (
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams
) => {
  return [
    `/api/v1/pipeline/deals/aggregates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDealAggregatesApiV1PipelineDealsAggregatesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDealAggregatesApiV1PipelineDealsAggregatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>>
  > = ({ signal }) =>
    getDealAggregatesApiV1PipelineDealsAggregatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDealAggregatesApiV1PipelineDealsAggregatesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>>
  >;
export type GetDealAggregatesApiV1PipelineDealsAggregatesGetQueryError =
  HTTPValidationError;

export function useGetDealAggregatesApiV1PipelineDealsAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDealAggregatesApiV1PipelineDealsAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDealAggregatesApiV1PipelineDealsAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Deal Aggregates
 */

export function useGetDealAggregatesApiV1PipelineDealsAggregatesGet<
  TData = Awaited<
    ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDealAggregatesApiV1PipelineDealsAggregatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealAggregatesApiV1PipelineDealsAggregatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDealAggregatesApiV1PipelineDealsAggregatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List deals that have been in their current stage longer than the stage's rotting_days.

These deals may need attention to move forward.
 * @summary List Rotting Deals
 */
export const listRottingDealsApiV1PipelineDealsRottingGet = (
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<RottingDealListResponse>({
    url: `/api/v1/pipeline/deals/rotting`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRottingDealsApiV1PipelineDealsRottingGetQueryKey = (
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams
) => {
  return [
    `/api/v1/pipeline/deals/rotting`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListRottingDealsApiV1PipelineDealsRottingGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRottingDealsApiV1PipelineDealsRottingGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>>
  > = ({ signal }) =>
    listRottingDealsApiV1PipelineDealsRottingGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRottingDealsApiV1PipelineDealsRottingGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>>
  >;
export type ListRottingDealsApiV1PipelineDealsRottingGetQueryError =
  HTTPValidationError;

export function useListRottingDealsApiV1PipelineDealsRottingGet<
  TData = Awaited<
    ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListRottingDealsApiV1PipelineDealsRottingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRottingDealsApiV1PipelineDealsRottingGet<
  TData = Awaited<
    ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRottingDealsApiV1PipelineDealsRottingGet<
  TData = Awaited<
    ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Rotting Deals
 */

export function useListRottingDealsApiV1PipelineDealsRottingGet<
  TData = Awaited<
    ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRottingDealsApiV1PipelineDealsRottingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRottingDealsApiV1PipelineDealsRottingGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRottingDealsApiV1PipelineDealsRottingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a deal by ID with currency conversion to base currency.
 * @summary Get Deal
 */
export const getDealApiV1PipelineDealsDealIdGet = (
  dealId: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDealApiV1PipelineDealsDealIdGetQueryKey = (
  dealId?: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams
) => {
  return [
    `/api/v1/pipeline/deals/${dealId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDealApiV1PipelineDealsDealIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDealApiV1PipelineDealsDealIdGetQueryKey(dealId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>
  > = ({ signal }) =>
    getDealApiV1PipelineDealsDealIdGet(dealId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!dealId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDealApiV1PipelineDealsDealIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>
>;
export type GetDealApiV1PipelineDealsDealIdGetQueryError = HTTPValidationError;

export function useGetDealApiV1PipelineDealsDealIdGet<
  TData = Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
  TError = HTTPValidationError
>(
  dealId: string,
  params: undefined | GetDealApiV1PipelineDealsDealIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDealApiV1PipelineDealsDealIdGet<
  TData = Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDealApiV1PipelineDealsDealIdGet<
  TData = Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Deal
 */

export function useGetDealApiV1PipelineDealsDealIdGet<
  TData = Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: GetDealApiV1PipelineDealsDealIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDealApiV1PipelineDealsDealIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDealApiV1PipelineDealsDealIdGetQueryOptions(
    dealId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a deal. Requires editor or higher permission.
 * @summary Update Deal
 */
export const updateDealApiV1PipelineDealsDealIdPut = (
  dealId: string,
  dealUpdate: DealUpdate
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dealUpdate
  });
};

export const getUpdateDealApiV1PipelineDealsDealIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>,
    TError,
    { dealId: string; data: DealUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>,
  TError,
  { dealId: string; data: DealUpdate },
  TContext
> => {
  const mutationKey = ['updateDealApiV1PipelineDealsDealIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>,
    { dealId: string; data: DealUpdate }
  > = (props) => {
    const { dealId, data } = props ?? {};

    return updateDealApiV1PipelineDealsDealIdPut(dealId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDealApiV1PipelineDealsDealIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>
>;
export type UpdateDealApiV1PipelineDealsDealIdPutMutationBody = DealUpdate;
export type UpdateDealApiV1PipelineDealsDealIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Deal
 */
export const useUpdateDealApiV1PipelineDealsDealIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>,
      TError,
      { dealId: string; data: DealUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDealApiV1PipelineDealsDealIdPut>>,
  TError,
  { dealId: string; data: DealUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateDealApiV1PipelineDealsDealIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a deal. Requires owner permission.
 * @summary Delete Deal
 */
export const deleteDealApiV1PipelineDealsDealIdDelete = (dealId: string) => {
  return customInstance<void>({
    url: `/api/v1/pipeline/deals/${dealId}`,
    method: 'DELETE'
  });
};

export const getDeleteDealApiV1PipelineDealsDealIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>,
    TError,
    { dealId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationKey = ['deleteDealApiV1PipelineDealsDealIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>,
    { dealId: string }
  > = (props) => {
    const { dealId } = props ?? {};

    return deleteDealApiV1PipelineDealsDealIdDelete(dealId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDealApiV1PipelineDealsDealIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>
  >;

export type DeleteDealApiV1PipelineDealsDealIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Deal
 */
export const useDeleteDealApiV1PipelineDealsDealIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>,
      TError,
      { dealId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDealApiV1PipelineDealsDealIdDelete>>,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteDealApiV1PipelineDealsDealIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Move a deal to a different stage. Requires editor or higher permission.
 * @summary Move Deal To Stage
 */
export const moveDealToStageApiV1PipelineDealsDealIdStagePut = (
  dealId: string,
  dealStageMove: DealStageMove
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/stage`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dealStageMove
  });
};

export const getMoveDealToStageApiV1PipelineDealsDealIdStagePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>
      >,
      TError,
      { dealId: string; data: DealStageMove },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>>,
    TError,
    { dealId: string; data: DealStageMove },
    TContext
  > => {
    const mutationKey = ['moveDealToStageApiV1PipelineDealsDealIdStagePut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>
      >,
      { dealId: string; data: DealStageMove }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return moveDealToStageApiV1PipelineDealsDealIdStagePut(dealId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type MoveDealToStageApiV1PipelineDealsDealIdStagePutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>>
  >;
export type MoveDealToStageApiV1PipelineDealsDealIdStagePutMutationBody =
  DealStageMove;
export type MoveDealToStageApiV1PipelineDealsDealIdStagePutMutationError =
  HTTPValidationError;

/**
 * @summary Move Deal To Stage
 */
export const useMoveDealToStageApiV1PipelineDealsDealIdStagePut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>
      >,
      TError,
      { dealId: string; data: DealStageMove },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof moveDealToStageApiV1PipelineDealsDealIdStagePut>>,
  TError,
  { dealId: string; data: DealStageMove },
  TContext
> => {
  const mutationOptions =
    getMoveDealToStageApiV1PipelineDealsDealIdStagePutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Archive a deal. Requires editor or higher permission.
 * @summary Archive Deal
 */
export const archiveDealApiV1PipelineDealsDealIdArchivePost = (
  dealId: string,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/archive`,
    method: 'POST',
    signal
  });
};

export const getArchiveDealApiV1PipelineDealsDealIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>>,
    TError,
    { dealId: string },
    TContext
  > => {
    const mutationKey = ['archiveDealApiV1PipelineDealsDealIdArchivePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>
      >,
      { dealId: string }
    > = (props) => {
      const { dealId } = props ?? {};

      return archiveDealApiV1PipelineDealsDealIdArchivePost(dealId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveDealApiV1PipelineDealsDealIdArchivePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>>
  >;

export type ArchiveDealApiV1PipelineDealsDealIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Deal
 */
export const useArchiveDealApiV1PipelineDealsDealIdArchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof archiveDealApiV1PipelineDealsDealIdArchivePost>>,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationOptions =
    getArchiveDealApiV1PipelineDealsDealIdArchivePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unarchive a deal. Requires editor or higher permission.
 * @summary Unarchive Deal
 */
export const unarchiveDealApiV1PipelineDealsDealIdUnarchivePost = (
  dealId: string,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/unarchive`,
    method: 'POST',
    signal
  });
};

export const getUnarchiveDealApiV1PipelineDealsDealIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
    >,
    TError,
    { dealId: string },
    TContext
  > => {
    const mutationKey = ['unarchiveDealApiV1PipelineDealsDealIdUnarchivePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
      >,
      { dealId: string }
    > = (props) => {
      const { dealId } = props ?? {};

      return unarchiveDealApiV1PipelineDealsDealIdUnarchivePost(dealId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveDealApiV1PipelineDealsDealIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
    >
  >;

export type UnarchiveDealApiV1PipelineDealsDealIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive Deal
 */
export const useUnarchiveDealApiV1PipelineDealsDealIdUnarchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof unarchiveDealApiV1PipelineDealsDealIdUnarchivePost>
  >,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationOptions =
    getUnarchiveDealApiV1PipelineDealsDealIdUnarchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reassign deals to one owner, over an explicit id list or the whole filter set.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``_resolve_deal_list_filters`` → ``_build_list_query``) to a bounded id set,
then hands it to the same set-based repository method the id path uses — so the
two cannot drift and the audit trail is identical. Bounded by
``BULK_MATCHING_MAX_AFFECTED``; over that the call is refused rather than
truncated.
 * @summary Bulk Assign Deal Owner
 */
export const bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost = (
  bulkDealAssignOwnerRequest: BulkDealAssignOwnerRequest,
  signal?: AbortSignal
) => {
  return customInstance<DealBulkAssignOwnerResponse>({
    url: `/api/v1/pipeline/deals/bulk-assign-owner`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDealAssignOwnerRequest,
    signal
  });
};

export const getBulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost
        >
      >,
      TError,
      { data: BulkDealAssignOwnerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost
      >
    >,
    TError,
    { data: BulkDealAssignOwnerRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost
        >
      >,
      { data: BulkDealAssignOwnerRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost
      >
    >
  >;
export type BulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPostMutationBody =
  BulkDealAssignOwnerRequest;
export type BulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Assign Deal Owner
 */
export const useBulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost
        >
      >,
      TError,
      { data: BulkDealAssignOwnerRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPost>
  >,
  TError,
  { data: BulkDealAssignOwnerRequest },
  TContext
> => {
  const mutationOptions =
    getBulkAssignDealOwnerApiV1PipelineDealsBulkAssignOwnerPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bulk delete deals — the named ids, or every deal matching the filter set.

The delete is SOFT (``deleted_at``), and both scopes converge on the same
set-based repository method, so the escalated arm is the same shape of work as
the id one. The confirmation that makes the reach visible lives on the surface
(``BulkScopeConfirmDialog`` in ``DealList.tsx``).
 * @summary Bulk Delete Deals
 */
export const bulkDeleteDealsApiV1PipelineDealsBulkDeletePost = (
  bulkDealRequest: BulkDealRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/bulk-delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDealRequest,
    signal
  });
};

export const getBulkDeleteDealsApiV1PipelineDealsBulkDeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>
      >,
      TError,
      { data: BulkDealRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>>,
    TError,
    { data: BulkDealRequest },
    TContext
  > => {
    const mutationKey = ['bulkDeleteDealsApiV1PipelineDealsBulkDeletePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>
      >,
      { data: BulkDealRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkDeleteDealsApiV1PipelineDealsBulkDeletePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkDeleteDealsApiV1PipelineDealsBulkDeletePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>>
  >;
export type BulkDeleteDealsApiV1PipelineDealsBulkDeletePostMutationBody =
  BulkDealRequest;
export type BulkDeleteDealsApiV1PipelineDealsBulkDeletePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Delete Deals
 */
export const useBulkDeleteDealsApiV1PipelineDealsBulkDeletePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>
      >,
      TError,
      { data: BulkDealRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteDealsApiV1PipelineDealsBulkDeletePost>>,
  TError,
  { data: BulkDealRequest },
  TContext
> => {
  const mutationOptions =
    getBulkDeleteDealsApiV1PipelineDealsBulkDeletePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bulk restore soft-deleted deals. Max 100 items.
 * @summary Bulk Restore Deals
 */
export const bulkRestoreDealsApiV1PipelineDealsBulkRestorePost = (
  bulkDealRestoreRequest: BulkDealRestoreRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/bulk-restore`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDealRestoreRequest,
    signal
  });
};

export const getBulkRestoreDealsApiV1PipelineDealsBulkRestorePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>
      >,
      TError,
      { data: BulkDealRestoreRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>
    >,
    TError,
    { data: BulkDealRestoreRequest },
    TContext
  > => {
    const mutationKey = ['bulkRestoreDealsApiV1PipelineDealsBulkRestorePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>
      >,
      { data: BulkDealRestoreRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkRestoreDealsApiV1PipelineDealsBulkRestorePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkRestoreDealsApiV1PipelineDealsBulkRestorePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>
    >
  >;
export type BulkRestoreDealsApiV1PipelineDealsBulkRestorePostMutationBody =
  BulkDealRestoreRequest;
export type BulkRestoreDealsApiV1PipelineDealsBulkRestorePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Restore Deals
 */
export const useBulkRestoreDealsApiV1PipelineDealsBulkRestorePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>
      >,
      TError,
      { data: BulkDealRestoreRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkRestoreDealsApiV1PipelineDealsBulkRestorePost>>,
  TError,
  { data: BulkDealRestoreRequest },
  TContext
> => {
  const mutationOptions =
    getBulkRestoreDealsApiV1PipelineDealsBulkRestorePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bulk archive deals — the named ids, or every deal matching the filter set.
 * @summary Bulk Archive Deals
 */
export const bulkArchiveDealsApiV1PipelineDealsBulkArchivePost = (
  bulkDealRequest: BulkDealRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/bulk-archive`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDealRequest,
    signal
  });
};

export const getBulkArchiveDealsApiV1PipelineDealsBulkArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>
      >,
      TError,
      { data: BulkDealRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>
    >,
    TError,
    { data: BulkDealRequest },
    TContext
  > => {
    const mutationKey = ['bulkArchiveDealsApiV1PipelineDealsBulkArchivePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>
      >,
      { data: BulkDealRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkArchiveDealsApiV1PipelineDealsBulkArchivePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkArchiveDealsApiV1PipelineDealsBulkArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>
    >
  >;
export type BulkArchiveDealsApiV1PipelineDealsBulkArchivePostMutationBody =
  BulkDealRequest;
export type BulkArchiveDealsApiV1PipelineDealsBulkArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Archive Deals
 */
export const useBulkArchiveDealsApiV1PipelineDealsBulkArchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>
      >,
      TError,
      { data: BulkDealRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkArchiveDealsApiV1PipelineDealsBulkArchivePost>>,
  TError,
  { data: BulkDealRequest },
  TContext
> => {
  const mutationOptions =
    getBulkArchiveDealsApiV1PipelineDealsBulkArchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Duplicate a deal. Requires read permission on source deal.

Creates a new deal with the same properties as the source deal,
including associated contacts. The new deal name is prefixed with "Copy of ".
The user becomes the owner of the new deal.
 * @summary Duplicate Deal
 */
export const duplicateDealApiV1PipelineDealsDealIdDuplicatePost = (
  dealId: string,
  signal?: AbortSignal
) => {
  return customInstance<DealResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/duplicate`,
    method: 'POST',
    signal
  });
};

export const getDuplicateDealApiV1PipelineDealsDealIdDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
    >,
    TError,
    { dealId: string },
    TContext
  > => {
    const mutationKey = ['duplicateDealApiV1PipelineDealsDealIdDuplicatePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
      >,
      { dealId: string }
    > = (props) => {
      const { dealId } = props ?? {};

      return duplicateDealApiV1PipelineDealsDealIdDuplicatePost(dealId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateDealApiV1PipelineDealsDealIdDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
    >
  >;

export type DuplicateDealApiV1PipelineDealsDealIdDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Deal
 */
export const useDuplicateDealApiV1PipelineDealsDealIdDuplicatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof duplicateDealApiV1PipelineDealsDealIdDuplicatePost>
  >,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationOptions =
    getDuplicateDealApiV1PipelineDealsDealIdDuplicatePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the roles a contact may hold on a deal, for any member of the tenant.

``require_auth`` — the module's own spelling for a member-open read (every
route on ``pipeline_router`` uses it; pipeline declares no
``require_module_access`` anywhere, and the whole router already sits behind
``Depends(require_module("pipeline"))`` in ``app.py``).

Why this route exists at all: ``ContactRoleSelector`` is a picker on ordinary
contact forms (the deal create page, the deal-contact rows), and it read
``GET /api/v1/pipeline/settings/contact-roles``, which is
``require_module_admin("pipeline")``. For every non-admin that 403'd and the
picker rendered the failure as ordinary emptiness — the eight hardcoded
suggested roles and nothing else, so the tenant's own vocabulary was
invisible to exactly the people expected to use it
(`.claude/rules/rules-frontend.md` § "A page open to ordinary members never
reads from an ADMIN-gated route").

A picker's option VOCABULARY is not admin configuration, so it is served
here — NARROWED to the two fields the picker consumes (``name``,
``is_suggested``) rather than re-exposing the settings model. The admin route
keeps its gate and stays the only way to read or write the rest of the
tenant settings row; both resolve through the same
``CrmSettingsService.get_available_contact_roles``, so there is no second
source of truth.
 * @summary List Contact Role Options
 */
export const listContactRoleOptionsApiV1PipelineContactRoleOptionsGet = (
  signal?: AbortSignal
) => {
  return customInstance<ContactRoleOptionListResponse>({
    url: `/api/v1/pipeline/contact-role-options`,
    method: 'GET',
    signal
  });
};

export const getListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryKey =
  () => {
    return [`/api/v1/pipeline/contact-role-options`] as const;
  };

export const getListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
        >
      >
    > = ({ signal }) =>
      listContactRoleOptionsApiV1PipelineContactRoleOptionsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
      >
    >
  >;
export type ListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryError =
  unknown;

export function useListContactRoleOptionsApiV1PipelineContactRoleOptionsGet<
  TData = Awaited<
    ReturnType<typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContactRoleOptionsApiV1PipelineContactRoleOptionsGet<
  TData = Awaited<
    ReturnType<typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContactRoleOptionsApiV1PipelineContactRoleOptionsGet<
  TData = Awaited<
    ReturnType<typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Contact Role Options
 */

export function useListContactRoleOptionsApiV1PipelineContactRoleOptionsGet<
  TData = Awaited<
    ReturnType<typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactRoleOptionsApiV1PipelineContactRoleOptionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListContactRoleOptionsApiV1PipelineContactRoleOptionsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a contact to a deal. Requires editor or higher permission.
 * @summary Add Deal Contact
 */
export const addDealContactApiV1PipelineDealsDealIdContactsPost = (
  dealId: string,
  dealContactCreate: DealContactCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dealContactCreate,
    signal
  });
};

export const getAddDealContactApiV1PipelineDealsDealIdContactsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
      >,
      TError,
      { dealId: string; data: DealContactCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
    >,
    TError,
    { dealId: string; data: DealContactCreate },
    TContext
  > => {
    const mutationKey = ['addDealContactApiV1PipelineDealsDealIdContactsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
      >,
      { dealId: string; data: DealContactCreate }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return addDealContactApiV1PipelineDealsDealIdContactsPost(dealId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddDealContactApiV1PipelineDealsDealIdContactsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
    >
  >;
export type AddDealContactApiV1PipelineDealsDealIdContactsPostMutationBody =
  DealContactCreate;
export type AddDealContactApiV1PipelineDealsDealIdContactsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Deal Contact
 */
export const useAddDealContactApiV1PipelineDealsDealIdContactsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
      >,
      TError,
      { dealId: string; data: DealContactCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addDealContactApiV1PipelineDealsDealIdContactsPost>
  >,
  TError,
  { dealId: string; data: DealContactCreate },
  TContext
> => {
  const mutationOptions =
    getAddDealContactApiV1PipelineDealsDealIdContactsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a contact's role or primary status on a deal. Requires editor or higher permission.
 * @summary Update Deal Contact
 */
export const updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut = (
  dealId: string,
  contactId: string,
  dealContactUpdate: DealContactUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/contacts/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dealContactUpdate
  });
};

export const getUpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
        >
      >,
      TError,
      { dealId: string; contactId: string; data: DealContactUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
      >
    >,
    TError,
    { dealId: string; contactId: string; data: DealContactUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
        >
      >,
      { dealId: string; contactId: string; data: DealContactUpdate }
    > = (props) => {
      const { dealId, contactId, data } = props ?? {};

      return updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut(
        dealId,
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
      >
    >
  >;
export type UpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPutMutationBody =
  DealContactUpdate;
export type UpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Deal Contact
 */
export const useUpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
          >
        >,
        TError,
        { dealId: string; contactId: string; data: DealContactUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDealContactApiV1PipelineDealsDealIdContactsContactIdPut
      >
    >,
    TError,
    { dealId: string; contactId: string; data: DealContactUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDealContactApiV1PipelineDealsDealIdContactsContactIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a contact from a deal. Requires editor or higher permission on the DEAL.

**EDITOR on the deal only** — deliberately NOT the VIEWER-on-contact re-check
that ``add_deal_contact`` performs
(``docs/platform/entity-relationship-surfaces-design.md`` §5, "Remove link").
Creating a link discloses B to A's readers, so it is gated at VIEWER on B;
removing one discloses nothing, and gating it means revoking a contact share
leaves the deal's own owner unable to detach a contact they can no longer
see — the association goes permanently unmanageable. The asymmetry is the
contract, not an oversight: ``shared/services/entity_link_registry.py`` hands
the edit gate and the far-side filter disjoint arguments for exactly this
reason, and cites this route as the live defect it prevents.
 * @summary Remove Deal Contact
 */
export const removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete =
  (dealId: string, contactId: string) => {
    return customInstance<void>({
      url: `/api/v1/pipeline/deals/${dealId}/contacts/${contactId}`,
      method: 'DELETE'
    });
  };

export const getRemoveDealContactApiV1PipelineDealsDealIdContactsContactIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
        >
      >,
      TError,
      { dealId: string; contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
      >
    >,
    TError,
    { dealId: string; contactId: string },
    TContext
  > => {
    const mutationKey = [
      'removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
        >
      >,
      { dealId: string; contactId: string }
    > = (props) => {
      const { dealId, contactId } = props ?? {};

      return removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete(
        dealId,
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveDealContactApiV1PipelineDealsDealIdContactsContactIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
      >
    >
  >;

export type RemoveDealContactApiV1PipelineDealsDealIdContactsContactIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Deal Contact
 */
export const useRemoveDealContactApiV1PipelineDealsDealIdContactsContactIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
          >
        >,
        TError,
        { dealId: string; contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeDealContactApiV1PipelineDealsDealIdContactsContactIdDelete
      >
    >,
    TError,
    { dealId: string; contactId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveDealContactApiV1PipelineDealsDealIdContactsContactIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all products on a deal.
 * @summary List Deal Products
 */
export const listDealProductsApiV1PipelineDealsDealIdProductsGet = (
  dealId: string,
  params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/products`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDealProductsApiV1PipelineDealsDealIdProductsGetQueryKey = (
  dealId?: string,
  params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams
) => {
  return [
    `/api/v1/pipeline/deals/${dealId}/products`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListDealProductsApiV1PipelineDealsDealIdProductsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
    >,
    TError = HTTPValidationError
  >(
    dealId: string,
    params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDealProductsApiV1PipelineDealsDealIdProductsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDealProductsApiV1PipelineDealsDealIdProductsGetQueryKey(
        dealId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
      >
    > = ({ signal }) =>
      listDealProductsApiV1PipelineDealsDealIdProductsGet(
        dealId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dealId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDealProductsApiV1PipelineDealsDealIdProductsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
    >
  >;
export type ListDealProductsApiV1PipelineDealsDealIdProductsGetQueryError =
  HTTPValidationError;

export function useListDealProductsApiV1PipelineDealsDealIdProductsGet<
  TData = Awaited<
    ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params: undefined | ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealProductsApiV1PipelineDealsDealIdProductsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealProductsApiV1PipelineDealsDealIdProductsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDealProductsApiV1PipelineDealsDealIdProductsGet<
  TData = Awaited<
    ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealProductsApiV1PipelineDealsDealIdProductsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealProductsApiV1PipelineDealsDealIdProductsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDealProductsApiV1PipelineDealsDealIdProductsGet<
  TData = Awaited<
    ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Deal Products
 */

export function useListDealProductsApiV1PipelineDealsDealIdProductsGet<
  TData = Awaited<
    ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealProductsApiV1PipelineDealsDealIdProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDealProductsApiV1PipelineDealsDealIdProductsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDealProductsApiV1PipelineDealsDealIdProductsGetQueryOptions(
      dealId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a product to a deal. Requires editor or higher permission.
 * @summary Add Deal Product
 */
export const addDealProductApiV1PipelineDealsDealIdProductsPost = (
  dealId: string,
  dealProductCreate: DealProductCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/products`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dealProductCreate,
    signal
  });
};

export const getAddDealProductApiV1PipelineDealsDealIdProductsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
      >,
      TError,
      { dealId: string; data: DealProductCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
    >,
    TError,
    { dealId: string; data: DealProductCreate },
    TContext
  > => {
    const mutationKey = ['addDealProductApiV1PipelineDealsDealIdProductsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
      >,
      { dealId: string; data: DealProductCreate }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return addDealProductApiV1PipelineDealsDealIdProductsPost(dealId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddDealProductApiV1PipelineDealsDealIdProductsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
    >
  >;
export type AddDealProductApiV1PipelineDealsDealIdProductsPostMutationBody =
  DealProductCreate;
export type AddDealProductApiV1PipelineDealsDealIdProductsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Deal Product
 */
export const useAddDealProductApiV1PipelineDealsDealIdProductsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
      >,
      TError,
      { dealId: string; data: DealProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addDealProductApiV1PipelineDealsDealIdProductsPost>
  >,
  TError,
  { dealId: string; data: DealProductCreate },
  TContext
> => {
  const mutationOptions =
    getAddDealProductApiV1PipelineDealsDealIdProductsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reorder products on a deal. Requires editor or higher permission.

Request body should contain:
- product_ids: list of deal_product IDs in desired order
 * @summary Reorder Deal Products
 */
export const reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut = (
  dealId: string,
  dealProductReorder: DealProductReorder
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/products/reorder`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dealProductReorder
  });
};

export const getReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
        >
      >,
      TError,
      { dealId: string; data: DealProductReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
      >
    >,
    TError,
    { dealId: string; data: DealProductReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
        >
      >,
      { dealId: string; data: DealProductReorder }
    > = (props) => {
      const { dealId, data } = props ?? {};

      return reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut(
        dealId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
      >
    >
  >;
export type ReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPutMutationBody =
  DealProductReorder;
export type ReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Deal Products
 */
export const useReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
          >
        >,
        TError,
        { dealId: string; data: DealProductReorder },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderDealProductsApiV1PipelineDealsDealIdProductsReorderPut
      >
    >,
    TError,
    { dealId: string; data: DealProductReorder },
    TContext
  > => {
    const mutationOptions =
      getReorderDealProductsApiV1PipelineDealsDealIdProductsReorderPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a product on a deal. Requires editor or higher permission.
 * @summary Update Deal Product
 */
export const updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut =
  (
    dealId: string,
    dealProductId: string,
    dealProductUpdate: DealProductUpdate
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/deals/${dealId}/products/${dealProductId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dealProductUpdate
    });
  };

export const getUpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
        >
      >,
      TError,
      { dealId: string; dealProductId: string; data: DealProductUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
      >
    >,
    TError,
    { dealId: string; dealProductId: string; data: DealProductUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
        >
      >,
      { dealId: string; dealProductId: string; data: DealProductUpdate }
    > = (props) => {
      const { dealId, dealProductId, data } = props ?? {};

      return updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut(
        dealId,
        dealProductId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
      >
    >
  >;
export type UpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPutMutationBody =
  DealProductUpdate;
export type UpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Deal Product
 */
export const useUpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
          >
        >,
        TError,
        { dealId: string; dealProductId: string; data: DealProductUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPut
      >
    >,
    TError,
    { dealId: string; dealProductId: string; data: DealProductUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDealProductApiV1PipelineDealsDealIdProductsDealProductIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a product from a deal. Requires editor or higher permission.
 * @summary Remove Deal Product
 */
export const removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete =
  (dealId: string, dealProductId: string) => {
    return customInstance<void>({
      url: `/api/v1/pipeline/deals/${dealId}/products/${dealProductId}`,
      method: 'DELETE'
    });
  };

export const getRemoveDealProductApiV1PipelineDealsDealIdProductsDealProductIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
        >
      >,
      TError,
      { dealId: string; dealProductId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
      >
    >,
    TError,
    { dealId: string; dealProductId: string },
    TContext
  > => {
    const mutationKey = [
      'removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
        >
      >,
      { dealId: string; dealProductId: string }
    > = (props) => {
      const { dealId, dealProductId } = props ?? {};

      return removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete(
        dealId,
        dealProductId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveDealProductApiV1PipelineDealsDealIdProductsDealProductIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
      >
    >
  >;

export type RemoveDealProductApiV1PipelineDealsDealIdProductsDealProductIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Deal Product
 */
export const useRemoveDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
          >
        >,
        TError,
        { dealId: string; dealProductId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeDealProductApiV1PipelineDealsDealIdProductsDealProductIdDelete
      >
    >,
    TError,
    { dealId: string; dealProductId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveDealProductApiV1PipelineDealsDealIdProductsDealProductIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get all deals that contain a specific product.

Used by the Products module to show which deals include a product.
 * @summary Get Deals By Product
 */
export const getDealsByProductApiV1PipelineProductsProductIdDealsGet = (
  productId: string,
  params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<DealCollectionResponse>({
    url: `/api/v1/pipeline/products/${productId}/deals`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryKey =
  (
    productId?: string,
    params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams
  ) => {
    return [
      `/api/v1/pipeline/products/${productId}/deals`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryKey(
        productId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
        >
      >
    > = ({ signal }) =>
      getDealsByProductApiV1PipelineProductsProductIdDealsGet(
        productId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
    >
  >;
export type GetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryError =
  HTTPValidationError;

export function useGetDealsByProductApiV1PipelineProductsProductIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params:
    | undefined
    | GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDealsByProductApiV1PipelineProductsProductIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDealsByProductApiV1PipelineProductsProductIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Deals By Product
 */

export function useGetDealsByProductApiV1PipelineProductsProductIdDealsGet<
  TData = Awaited<
    ReturnType<typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetDealsByProductApiV1PipelineProductsProductIdDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDealsByProductApiV1PipelineProductsProductIdDealsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDealsByProductApiV1PipelineProductsProductIdDealsGetQueryOptions(
      productId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get deal summary by stage for a pipeline with currency conversion.

Converts all deal amounts to the user's preferred currency for accurate
pipeline totals when deals have mixed currencies.
 * @summary Get Pipeline Summary
 */
export const getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet = (
  pipelineId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/pipelines/${pipelineId}/summary`,
    method: 'GET',
    signal
  });
};

export const getGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryKey =
  (pipelineId?: string) => {
    return [`/api/v1/pipeline/pipelines/${pipelineId}/summary`] as const;
  };

export const getGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
      >
    >,
    TError = HTTPValidationError
  >(
    pipelineId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryKey(
        pipelineId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
        >
      >
    > = ({ signal }) =>
      getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet(
        pipelineId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!pipelineId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
      >
    >
  >;
export type GetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryError =
  HTTPValidationError;

export function useGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline Summary
 */

export function useGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
    >
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineSummaryApiV1PipelinePipelinesPipelineIdSummaryGetQueryOptions(
      pipelineId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lightweight check for whether the tenant has companies, contacts, and deals.
Used by the sidebar to decide whether to show the Get Started nav item.
Uses EXISTS subqueries instead of COUNT for minimal DB cost.
 * @summary Get Setup Status
 */
export const getSetupStatusApiV1PipelineSetupStatusGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/setup-status`,
    method: 'GET',
    signal
  });
};

export const getGetSetupStatusApiV1PipelineSetupStatusGetQueryKey = () => {
  return [`/api/v1/pipeline/setup-status`] as const;
};

export const getGetSetupStatusApiV1PipelineSetupStatusGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSetupStatusApiV1PipelineSetupStatusGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>
  > = ({ signal }) => getSetupStatusApiV1PipelineSetupStatusGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSetupStatusApiV1PipelineSetupStatusGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>
>;
export type GetSetupStatusApiV1PipelineSetupStatusGetQueryError = unknown;

export function useGetSetupStatusApiV1PipelineSetupStatusGet<
  TData = Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSetupStatusApiV1PipelineSetupStatusGet<
  TData = Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSetupStatusApiV1PipelineSetupStatusGet<
  TData = Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Setup Status
 */

export function useGetSetupStatusApiV1PipelineSetupStatusGet<
  TData = Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSetupStatusApiV1PipelineSetupStatusGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSetupStatusApiV1PipelineSetupStatusGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get Sales dashboard metrics.

See docs/platform/dashboard-kpi-endpoints.md. The three scopes are resolved
here, outside ``cached_kpi``, so a Full-Access admin's universal read still
writes its ``admin_override_read`` audit row on a cache hit.
 * @summary Get Crm Dashboard
 */
export const getCrmDashboardApiV1PipelineDashboardGet = (
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PipelineDashboard>({
    url: `/api/v1/pipeline/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetCrmDashboardApiV1PipelineDashboardGetQueryKey = (
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams
) => {
  return [`/api/v1/pipeline/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetCrmDashboardApiV1PipelineDashboardGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCrmDashboardApiV1PipelineDashboardGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>
  > = ({ signal }) => getCrmDashboardApiV1PipelineDashboardGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCrmDashboardApiV1PipelineDashboardGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>
>;
export type GetCrmDashboardApiV1PipelineDashboardGetQueryError =
  HTTPValidationError;

export function useGetCrmDashboardApiV1PipelineDashboardGet<
  TData = Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetCrmDashboardApiV1PipelineDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCrmDashboardApiV1PipelineDashboardGet<
  TData = Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCrmDashboardApiV1PipelineDashboardGet<
  TData = Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Crm Dashboard
 */

export function useGetCrmDashboardApiV1PipelineDashboardGet<
  TData = Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetCrmDashboardApiV1PipelineDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCrmDashboardApiV1PipelineDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCrmDashboardApiV1PipelineDashboardGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the task board for a deal (if it exists).

Returns the board ID and workspace ID if a task board has been created for this
deal AND the caller is a member of it. Returns null values otherwise.
 * @summary Get Deal Board
 */
export const getDealBoardApiV1PipelineDealsDealIdBoardGet = (
  dealId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/board`,
    method: 'GET',
    signal
  });
};

export const getGetDealBoardApiV1PipelineDealsDealIdBoardGetQueryKey = (
  dealId?: string
) => {
  return [`/api/v1/pipeline/deals/${dealId}/board`] as const;
};

export const getGetDealBoardApiV1PipelineDealsDealIdBoardGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDealBoardApiV1PipelineDealsDealIdBoardGetQueryKey(dealId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>>
  > = ({ signal }) =>
    getDealBoardApiV1PipelineDealsDealIdBoardGet(dealId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!dealId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDealBoardApiV1PipelineDealsDealIdBoardGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>>
  >;
export type GetDealBoardApiV1PipelineDealsDealIdBoardGetQueryError =
  HTTPValidationError;

export function useGetDealBoardApiV1PipelineDealsDealIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDealBoardApiV1PipelineDealsDealIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDealBoardApiV1PipelineDealsDealIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Deal Board
 */

export function useGetDealBoardApiV1PipelineDealsDealIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDealBoardApiV1PipelineDealsDealIdBoardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDealBoardApiV1PipelineDealsDealIdBoardGetQueryOptions(
      dealId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or get the task board for a deal.

Creates a new task board linked to the deal if one doesn't exist.
The board is placed in the tenant's "Sales" workspace (created if needed).
Returns the board ID and whether it was newly created. Handing back a board that
already exists requires the caller to hold write access on that board.
 * @summary Create Deal Board
 */
export const createDealBoardApiV1PipelineDealsDealIdBoardPost = (
  dealId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/deals/${dealId}/board`,
    method: 'POST',
    signal
  });
};

export const getCreateDealBoardApiV1PipelineDealsDealIdBoardPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>
    >,
    TError,
    { dealId: string },
    TContext
  > => {
    const mutationKey = ['createDealBoardApiV1PipelineDealsDealIdBoardPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>
      >,
      { dealId: string }
    > = (props) => {
      const { dealId } = props ?? {};

      return createDealBoardApiV1PipelineDealsDealIdBoardPost(dealId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDealBoardApiV1PipelineDealsDealIdBoardPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>>
  >;

export type CreateDealBoardApiV1PipelineDealsDealIdBoardPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Deal Board
 */
export const useCreateDealBoardApiV1PipelineDealsDealIdBoardPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>
      >,
      TError,
      { dealId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDealBoardApiV1PipelineDealsDealIdBoardPost>>,
  TError,
  { dealId: string },
  TContext
> => {
  const mutationOptions =
    getCreateDealBoardApiV1PipelineDealsDealIdBoardPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The interaction timeline on one deal.
 * @summary List Deal Interactions
 */
export const listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet = (
  dealId: string,
  params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InteractionListResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/interactions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryKey =
  (
    dealId?: string,
    params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams
  ) => {
    return [
      `/api/v1/pipeline/deals/${dealId}/interactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    dealId: string,
    params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryKey(
        dealId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
        >
      >
    > = ({ signal }) =>
      listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet(
        dealId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dealId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
      >
    >
  >;
export type ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryError =
  HTTPValidationError;

export function useListDealInteractionsApiV1PipelineDealsDealIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params:
    | undefined
    | ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDealInteractionsApiV1PipelineDealsDealIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDealInteractionsApiV1PipelineDealsDealIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Deal Interactions
 */

export function useListDealInteractionsApiV1PipelineDealsDealIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealInteractionsApiV1PipelineDealsDealIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDealInteractionsApiV1PipelineDealsDealIdInteractionsGetQueryOptions(
      dealId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use `GET /api/v1/master-data/contacts/interactions`.
 * @deprecated
 * @summary List Activities
 */
export const listActivitiesApiV1PipelineActivitiesGet = (
  params?: ListActivitiesApiV1PipelineActivitiesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InteractionListResponse>({
    url: `/api/v1/pipeline/activities`,
    method: 'GET',
    params,
    signal
  });
};

export const getListActivitiesApiV1PipelineActivitiesGetQueryKey = (
  params?: ListActivitiesApiV1PipelineActivitiesGetParams
) => {
  return [`/api/v1/pipeline/activities`, ...(params ? [params] : [])] as const;
};

export const getListActivitiesApiV1PipelineActivitiesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
  TError = HTTPValidationError
>(
  params?: ListActivitiesApiV1PipelineActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListActivitiesApiV1PipelineActivitiesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>
  > = ({ signal }) => listActivitiesApiV1PipelineActivitiesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListActivitiesApiV1PipelineActivitiesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>
>;
export type ListActivitiesApiV1PipelineActivitiesGetQueryError =
  HTTPValidationError;

export function useListActivitiesApiV1PipelineActivitiesGet<
  TData = Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListActivitiesApiV1PipelineActivitiesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
          TError,
          Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListActivitiesApiV1PipelineActivitiesGet<
  TData = Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
  TError = HTTPValidationError
>(
  params?: ListActivitiesApiV1PipelineActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
          TError,
          Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListActivitiesApiV1PipelineActivitiesGet<
  TData = Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
  TError = HTTPValidationError
>(
  params?: ListActivitiesApiV1PipelineActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary List Activities
 */

export function useListActivitiesApiV1PipelineActivitiesGet<
  TData = Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
  TError = HTTPValidationError
>(
  params?: ListActivitiesApiV1PipelineActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listActivitiesApiV1PipelineActivitiesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListActivitiesApiV1PipelineActivitiesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use `POST /api/v1/master-data/contacts/interactions`.
 * @deprecated
 * @summary Create Activity
 */
export const createActivityApiV1PipelineActivitiesPost = (
  interactionCreate: InteractionCreate,
  signal?: AbortSignal
) => {
  return customInstance<InteractionResponse>({
    url: `/api/v1/pipeline/activities`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: interactionCreate,
    signal
  });
};

export const getCreateActivityApiV1PipelineActivitiesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>,
    TError,
    { data: InteractionCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>,
  TError,
  { data: InteractionCreate },
  TContext
> => {
  const mutationKey = ['createActivityApiV1PipelineActivitiesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>,
    { data: InteractionCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createActivityApiV1PipelineActivitiesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActivityApiV1PipelineActivitiesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>
  >;
export type CreateActivityApiV1PipelineActivitiesPostMutationBody =
  InteractionCreate;
export type CreateActivityApiV1PipelineActivitiesPostMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Create Activity
 */
export const useCreateActivityApiV1PipelineActivitiesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>,
      TError,
      { data: InteractionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createActivityApiV1PipelineActivitiesPost>>,
  TError,
  { data: InteractionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateActivityApiV1PipelineActivitiesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deprecated. Use `GET /api/v1/master-data/contacts/people/{contact_id}/interactions`.
 * @deprecated
 * @summary List Contact Activities
 */
export const listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet =
  (
    contactId: string,
    params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<InteractionListResponse>({
      url: `/api/v1/pipeline/contacts/${contactId}/activities`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryKey =
  (
    contactId?: string,
    params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams
  ) => {
    return [
      `/api/v1/pipeline/contacts/${contactId}/activities`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryKey(
        contactId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
        >
      >
    > = ({ signal }) =>
      listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet(
        contactId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
      >
    >
  >;
export type ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryError =
  HTTPValidationError;

export function useListContactActivitiesApiV1PipelineContactsContactIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params:
    | undefined
    | ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContactActivitiesApiV1PipelineContactsContactIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContactActivitiesApiV1PipelineContactsContactIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary List Contact Activities
 */

export function useListContactActivitiesApiV1PipelineContactsContactIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactActivitiesApiV1PipelineContactsContactIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListContactActivitiesApiV1PipelineContactsContactIdActivitiesGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use `GET /api/v1/master-data/contacts/organizations/{id}/interactions`.
 * @deprecated
 * @summary List Organization Activities
 */
export const listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet =
  (
    organizationId: string,
    params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<InteractionListResponse>({
      url: `/api/v1/pipeline/organizations/${organizationId}/activities`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryKey =
  (
    organizationId?: string,
    params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams
  ) => {
    return [
      `/api/v1/pipeline/organizations/${organizationId}/activities`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryKey(
        organizationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
        >
      >
    > = ({ signal }) =>
      listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet(
        organizationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
      >
    >
  >;
export type ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryError =
  HTTPValidationError;

export function useListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params:
    | undefined
    | ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary List Organization Activities
 */

export function useListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOrganizationActivitiesApiV1PipelineOrganizationsOrganizationIdActivitiesGetQueryOptions(
      organizationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use `GET /api/v1/pipeline/deals/{deal_id}/interactions`.
 * @deprecated
 * @summary List Deal Activities
 */
export const listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet = (
  dealId: string,
  params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InteractionListResponse>({
    url: `/api/v1/pipeline/deals/${dealId}/activities`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryKey =
  (
    dealId?: string,
    params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams
  ) => {
    return [
      `/api/v1/pipeline/deals/${dealId}/activities`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
    >,
    TError = HTTPValidationError
  >(
    dealId: string,
    params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryKey(
        dealId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
        >
      >
    > = ({ signal }) =>
      listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet(
        dealId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!dealId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
    >
  >;
export type ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryError =
  HTTPValidationError;

export function useListDealActivitiesApiV1PipelineDealsDealIdActivitiesGet<
  TData = Awaited<
    ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params:
    | undefined
    | ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDealActivitiesApiV1PipelineDealsDealIdActivitiesGet<
  TData = Awaited<
    ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDealActivitiesApiV1PipelineDealsDealIdActivitiesGet<
  TData = Awaited<
    ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary List Deal Activities
 */

export function useListDealActivitiesApiV1PipelineDealsDealIdActivitiesGet<
  TData = Awaited<
    ReturnType<typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet>
  >,
  TError = HTTPValidationError
>(
  dealId: string,
  params?: ListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDealActivitiesApiV1PipelineDealsDealIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDealActivitiesApiV1PipelineDealsDealIdActivitiesGetQueryOptions(
      dealId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated. Use `PUT /api/v1/master-data/contacts/interactions/{interaction_id}`.
 * @deprecated
 * @summary Update Activity
 */
export const updateActivityApiV1PipelineActivitiesActivityIdPut = (
  activityId: string,
  interactionUpdate: InteractionUpdate
) => {
  return customInstance<InteractionResponse>({
    url: `/api/v1/pipeline/activities/${activityId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: interactionUpdate
  });
};

export const getUpdateActivityApiV1PipelineActivitiesActivityIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
      >,
      TError,
      { activityId: string; data: InteractionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
    >,
    TError,
    { activityId: string; data: InteractionUpdate },
    TContext
  > => {
    const mutationKey = ['updateActivityApiV1PipelineActivitiesActivityIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
      >,
      { activityId: string; data: InteractionUpdate }
    > = (props) => {
      const { activityId, data } = props ?? {};

      return updateActivityApiV1PipelineActivitiesActivityIdPut(
        activityId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateActivityApiV1PipelineActivitiesActivityIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
    >
  >;
export type UpdateActivityApiV1PipelineActivitiesActivityIdPutMutationBody =
  InteractionUpdate;
export type UpdateActivityApiV1PipelineActivitiesActivityIdPutMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Update Activity
 */
export const useUpdateActivityApiV1PipelineActivitiesActivityIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
      >,
      TError,
      { activityId: string; data: InteractionUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateActivityApiV1PipelineActivitiesActivityIdPut>
  >,
  TError,
  { activityId: string; data: InteractionUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateActivityApiV1PipelineActivitiesActivityIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deprecated. Use `DELETE /api/v1/master-data/contacts/interactions/{interaction_id}`.
 * @deprecated
 * @summary Delete Activity
 */
export const deleteActivityApiV1PipelineActivitiesActivityIdDelete = (
  activityId: string
) => {
  return customInstance<void>({
    url: `/api/v1/pipeline/activities/${activityId}`,
    method: 'DELETE'
  });
};

export const getDeleteActivityApiV1PipelineActivitiesActivityIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
      >,
      TError,
      { activityId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
    >,
    TError,
    { activityId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteActivityApiV1PipelineActivitiesActivityIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
      >,
      { activityId: string }
    > = (props) => {
      const { activityId } = props ?? {};

      return deleteActivityApiV1PipelineActivitiesActivityIdDelete(activityId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteActivityApiV1PipelineActivitiesActivityIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
    >
  >;

export type DeleteActivityApiV1PipelineActivitiesActivityIdDeleteMutationError =
  HTTPValidationError;

/**
 * @deprecated
 * @summary Delete Activity
 */
export const useDeleteActivityApiV1PipelineActivitiesActivityIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
      >,
      TError,
      { activityId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteActivityApiV1PipelineActivitiesActivityIdDelete>
  >,
  TError,
  { activityId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteActivityApiV1PipelineActivitiesActivityIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get pipeline velocity report - average time deals spend in each stage.

Returns average duration in days per stage for deals closed in the specified period.
 * @summary Get Pipeline Velocity Report
 */
export const getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet =
  (
    params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/reports/pipeline-velocity`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryKey =
  (
    params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams
  ) => {
    return [
      `/api/v1/pipeline/reports/pipeline-velocity`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
        >
      >
    > = ({ signal }) =>
      getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
      >
    >
  >;
export type GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryError =
  HTTPValidationError;

export function useGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline Velocity Report
 */

export function useGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet<
  TData = Awaited<
    ReturnType<
      typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineVelocityReportApiV1PipelineReportsPipelineVelocityGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get win/loss report - deals won vs lost over time.

Returns counts and values grouped by time period or owner.
 * @summary Get Win Loss Report
 */
export const getWinLossReportApiV1PipelineReportsWinLossGet = (
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/reports/win-loss`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetWinLossReportApiV1PipelineReportsWinLossGetQueryKey = (
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams
) => {
  return [
    `/api/v1/pipeline/reports/win-loss`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetWinLossReportApiV1PipelineReportsWinLossGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWinLossReportApiV1PipelineReportsWinLossGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>>
  > = ({ signal }) =>
    getWinLossReportApiV1PipelineReportsWinLossGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetWinLossReportApiV1PipelineReportsWinLossGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>>
  >;
export type GetWinLossReportApiV1PipelineReportsWinLossGetQueryError =
  HTTPValidationError;

export function useGetWinLossReportApiV1PipelineReportsWinLossGet<
  TData = Awaited<
    ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetWinLossReportApiV1PipelineReportsWinLossGet<
  TData = Awaited<
    ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetWinLossReportApiV1PipelineReportsWinLossGet<
  TData = Awaited<
    ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Win Loss Report
 */

export function useGetWinLossReportApiV1PipelineReportsWinLossGet<
  TData = Awaited<
    ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetWinLossReportApiV1PipelineReportsWinLossGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWinLossReportApiV1PipelineReportsWinLossGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetWinLossReportApiV1PipelineReportsWinLossGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get conversion funnel report - how deals progress through stages.

Shows count of deals that reached each stage and conversion rates between stages.
 * @summary Get Conversion Funnel Report
 */
export const getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet =
  (
    params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/pipeline/reports/conversion-funnel`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryKey =
  (
    params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams
  ) => {
    return [
      `/api/v1/pipeline/reports/conversion-funnel`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
        >
      >
    > = ({ signal }) =>
      getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
      >
    >
  >;
export type GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryError =
  HTTPValidationError;

export function useGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGet<
  TData = Awaited<
    ReturnType<
      typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGet<
  TData = Awaited<
    ReturnType<
      typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGet<
  TData = Awaited<
    ReturnType<
      typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Conversion Funnel Report
 */

export function useGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGet<
  TData = Awaited<
    ReturnType<
      typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getConversionFunnelReportApiV1PipelineReportsConversionFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetConversionFunnelReportApiV1PipelineReportsConversionFunnelGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get revenue forecast based on deal probability and expected close dates.

Returns weighted pipeline value by expected close month.
 * @summary Get Forecast Report
 */
export const getForecastReportApiV1PipelineReportsForecastGet = (
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/reports/forecast`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetForecastReportApiV1PipelineReportsForecastGetQueryKey = (
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams
) => {
  return [
    `/api/v1/pipeline/reports/forecast`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetForecastReportApiV1PipelineReportsForecastGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetForecastReportApiV1PipelineReportsForecastGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>>
  > = ({ signal }) =>
    getForecastReportApiV1PipelineReportsForecastGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetForecastReportApiV1PipelineReportsForecastGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>>
  >;
export type GetForecastReportApiV1PipelineReportsForecastGetQueryError =
  HTTPValidationError;

export function useGetForecastReportApiV1PipelineReportsForecastGet<
  TData = Awaited<
    ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetForecastReportApiV1PipelineReportsForecastGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetForecastReportApiV1PipelineReportsForecastGet<
  TData = Awaited<
    ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetForecastReportApiV1PipelineReportsForecastGet<
  TData = Awaited<
    ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Forecast Report
 */

export function useGetForecastReportApiV1PipelineReportsForecastGet<
  TData = Awaited<
    ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetForecastReportApiV1PipelineReportsForecastGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getForecastReportApiV1PipelineReportsForecastGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetForecastReportApiV1PipelineReportsForecastGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get monthly won revenue trends over time.

Shows total won deal value and count per month for the given period.
 * @summary Get Revenue Trends Report
 */
export const getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet = (
  params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/reports/revenue-trends`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryKey =
  (
    params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams
  ) => {
    return [
      `/api/v1/pipeline/reports/revenue-trends`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
        >
      >
    > = ({ signal }) =>
      getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
      >
    >
  >;
export type GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryError =
  HTTPValidationError;

export function useGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet<
  TData = Awaited<
    ReturnType<
      typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet<
  TData = Awaited<
    ReturnType<
      typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet<
  TData = Awaited<
    ReturnType<
      typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Revenue Trends Report
 */

export function useGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet<
  TData = Awaited<
    ReturnType<
      typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRevenueTrendsReportApiV1PipelineReportsRevenueTrendsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get sales rep leaderboard - deals won and revenue by owner.
 * @summary Get Sales Leaderboard
 */
export const getSalesLeaderboardApiV1PipelineReportsLeaderboardGet = (
  params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/reports/leaderboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryKey =
  (params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams) => {
    return [
      `/api/v1/pipeline/reports/leaderboard`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
      >
    > = ({ signal }) =>
      getSalesLeaderboardApiV1PipelineReportsLeaderboardGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
    >
  >;
export type GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryError =
  HTTPValidationError;

export function useGetSalesLeaderboardApiV1PipelineReportsLeaderboardGet<
  TData = Awaited<
    ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSalesLeaderboardApiV1PipelineReportsLeaderboardGet<
  TData = Awaited<
    ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSalesLeaderboardApiV1PipelineReportsLeaderboardGet<
  TData = Awaited<
    ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sales Leaderboard
 */

export function useGetSalesLeaderboardApiV1PipelineReportsLeaderboardGet<
  TData = Awaited<
    ReturnType<typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetSalesLeaderboardApiV1PipelineReportsLeaderboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSalesLeaderboardApiV1PipelineReportsLeaderboardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSalesLeaderboardApiV1PipelineReportsLeaderboardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get team performance comparison report - side-by-side metrics per team member.

Only available to users with subordinates. Shows metrics for the user's team.
 * @summary Get Team Performance Report
 */
export const getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet = (
  params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/pipeline/reports/team-performance`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryKey =
  (
    params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams
  ) => {
    return [
      `/api/v1/pipeline/reports/team-performance`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
        >
      >
    > = ({ signal }) =>
      getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
      >
    >
  >;
export type GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryError =
  HTTPValidationError;

export function useGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Team Performance Report
 */

export function useGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTeamPerformanceReportApiV1PipelineReportsTeamPerformanceGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
